var COLOURS_BARBOT=[
{c:"CA-0056",n:"Amarelo Limao",f:"Yellows",h:"#E9E2B2",s:10},{c:"CA-0057",n:"Amarelo Claro",f:"Yellows",h:"#F0E3BE",s:10},{c:"CA-0059",n:"Amarelo Nata",f:"Yellows",h:"#E0D4B3",s:10},{c:"CA-0061",n:"Amarelo Banana",f:"Yellows",h:"#F3D6A2",s:10},{c:"CA-0063",n:"Amarelo Vitral",f:"Yellows",h:"#E3C89C",s:10},{c:"CA-0179",n:"Limonete",f:"Yellows",h:"#E8E7C9",s:10},{c:"CA-0180",n:"Tranquilidade",f:"Yellows",h:"#E8E3C2",s:10},{c:"CA-0187",n:"Aveia",f:"Yellows",h:"#EEE0AB",s:10},{c:"CA-B007",n:"Salitre",f:"Yellows",h:"#F1E3C8",s:10},{c:"CA-B008",n:"Champagne",f:"Yellows",h:"#E3D6B7",s:10},{c:"CA-B083",n:"Amarelo Acido",f:"Yellows",h:"#EAE6A7",s:10},{c:"CB-0060",n:"Amarelo Praia",f:"Yellows",h:"#E8D599",s:16},{c:"CB-0062",n:"Amarelo Alegria",f:"Yellows",h:"#D3A566",s:16},{c:"CB-0064",n:"Amarelo Estrelado",f:"Yellows",h:"#E6C283",s:16},{c:"CB-0181",n:"Amarelo em Flor",f:"Yellows",h:"#EFE398",s:16},{c:"CB-0183",n:"Amarelo Palido",f:"Yellows",h:"#E8E29A",s:16},{c:"CB-0279",n:"Lima-Limao",f:"Yellows",h:"#D6E29D",s:16},{c:"CB-B009",n:"Caju",f:"Yellows",h:"#E2CFA1",s:16},{c:"CC-0058",n:"Amarelo Mal-Me-Quer",f:"Yellows",h:"#E8D693",s:25},{c:"CC-0067",n:"Amarelo Areia",f:"Yellows",h:"#EAC287",s:25},{c:"CC-0070",n:"Amarelo da Ilha",f:"Yellows",h:"#EEB141",s:25},{c:"CC-0182",n:"Limonada",f:"Yellows",h:"#F3D97E",s:25},{c:"CC-B010",n:"Venus",f:"Yellows",h:"#F2CD81",s:25},{c:"CC-B017",n:"Barro",f:"Yellows",h:"#C1906F",s:25},{c:"CD-0055",n:"Amarelo Sol",f:"Yellows",h:"#EDCD65",s:45},{c:"CD-0065",n:"Amarelo Barroco",f:"Yellows",h:"#E5C687",s:45},{c:"CD-0066",n:"Amarelo Selvagem",f:"Yellows",h:"#D9A464",s:45},{c:"CD-0068",n:"Amarelo Perfeito",f:"Yellows",h:"#E1B861",s:45},{c:"CD-0185",n:"Lirio Amarelo",f:"Yellows",h:"#E7CB76",s:45},{c:"CD-0186",n:"Cha de Hortela",f:"Yellows",h:"#E5DA66",s:45},{c:"CD-0191",n:"Por-do-Sol",f:"Yellows",h:"#E9C070",s:45},{c:"CD-0192",n:"Margarida",f:"Yellows",h:"#F2CD65",s:45},{c:"CD-0193",n:"Amarelo Gema",f:"Yellows",h:"#F5BD51",s:45},{c:"CD-0194",n:"Mostarda",f:"Yellows",h:"#EDA747",s:45},{c:"CD-B084",n:"Canario",f:"Yellows",h:"#F9DA3F",s:45},
{c:"CA-0135",n:"Azul Claro",f:"Blues",h:"#C3D2D5",s:10},{c:"CA-0136",n:"Azul Agua",f:"Blues",h:"#A8BABE",s:10},{c:"CA-0137",n:"Azul Areado",f:"Blues",h:"#8FA3A8",s:10},{c:"CA-0139",n:"Azul Capri",f:"Blues",h:"#C4D2DA",s:10},{c:"CA-0140",n:"Azul Ceu",f:"Blues",h:"#B7C6D1",s:10},{c:"CA-0143",n:"Azul Celeste",f:"Blues",h:"#A8B8C3",s:10},{c:"CA-0144",n:"Azul Maresia",f:"Blues",h:"#93A2AD",s:10},{c:"CA-0147",n:"Azul Caribe",f:"Blues",h:"#9EB2AC",s:10},{c:"CA-0259",n:"Azul Celeste 2",f:"Blues",h:"#C8DCED",s:10},{c:"CA-0260",n:"Mare Azul",f:"Blues",h:"#ACC6DD",s:10},{c:"CA-0261",n:"Azul Vivo",f:"Blues",h:"#699BD1",s:10},{c:"CA-0263",n:"Claridade",f:"Blues",h:"#BDD6E7",s:10},{c:"CA-0264",n:"Azul Creta",f:"Blues",h:"#64ABDA",s:10},{c:"CA-0267",n:"Horizonte",f:"Blues",h:"#D7E2E3",s:10},{c:"CA-0268",n:"Manha Azul",f:"Blues",h:"#B9DCE4",s:10},{c:"CA-0269",n:"Azul Pacifico",f:"Blues",h:"#97D1DD",s:10},{c:"CA-0271",n:"Azul Bucolico",f:"Blues",h:"#D9E8E7",s:10},{c:"CA-0272",n:"Nuvem",f:"Blues",h:"#CDE0E6",s:10},{c:"CA-0273",n:"Recife",f:"Blues",h:"#9EC2C6",s:10},{c:"CA-B039",n:"Artico",f:"Blues",h:"#C2D2DC",s:10},{c:"CA-B041",n:"Azul Real",f:"Blues",h:"#DCE2E0",s:10},{c:"CA-B055",n:"Iceberg",f:"Blues",h:"#BCD2DE",s:10},{c:"CA-B056",n:"Rio Tamisa",f:"Blues",h:"#A7B9BE",s:10},{c:"CA-B057",n:"Calcario",f:"Blues",h:"#99A7A8",s:10},{c:"CA-B058",n:"Pacifico",f:"Blues",h:"#C4D8DB",s:10},{c:"CA-B060",n:"Azul dos Andes",f:"Blues",h:"#80ADBB",s:10},{c:"CA-B061",n:"Santorini",f:"Blues",h:"#75B9CC",s:10},{c:"CA-B104",n:"Ceu",f:"Blues",h:"#8CC0E1",s:10},{c:"CA-B105",n:"Agua do Rio",f:"Blues",h:"#B3C3D2",s:10},{c:"CA-B106",n:"Azul Polo",f:"Blues",h:"#B9D7EE",s:10},{c:"CA-B107",n:"Regata",f:"Blues",h:"#A6CBE8",s:10},{c:"CA-B108",n:"Vitral",f:"Blues",h:"#C2DCE5",s:10},{c:"CA-B109",n:"Azul Nascente",f:"Blues",h:"#C5D9E4",s:10},{c:"CA-B110",n:"Aurora",f:"Blues",h:"#D9E1E6",s:10},{c:"CA-B112",n:"Jacinto",f:"Blues",h:"#A8D2E0",s:10},{c:"CA-B113",n:"Cruzeiro",f:"Blues",h:"#D1E6E5",s:10},{c:"CA-B114",n:"Formentera",f:"Blues",h:"#BDE2DE",s:10},{c:"CA-B115",n:"Lagoa",f:"Blues",h:"#D3E1E8",s:10},{c:"CA-B186",n:"Gelo",f:"Blues",h:"#D3DEE0",s:10},{c:"CA-B214",n:"Azul Segredo",f:"Blues",h:"#7D929E",s:10},{c:"CA-B215",n:"Azul Cinza",f:"Blues",h:"#98ABAC",s:10},{c:"CA-B216",n:"Entardecer",f:"Blues",h:"#A3B6B8",s:10},{c:"CA-B217",n:"Proa",f:"Blues",h:"#6C8B92",s:10},{c:"CB-0138",n:"Azul Polvora",f:"Blues",h:"#809297",s:16},{c:"CB-0142",n:"Azul Algarve",f:"Blues",h:"#497C9C",s:16},{c:"CB-0148",n:"Azul Cadete",f:"Blues",h:"#688893",s:16},{c:"CB-0149",n:"Azul Petroleo",f:"Blues",h:"#55747F",s:16},{c:"CB-0270",n:"Fiorde",f:"Blues",h:"#468A9E",s:16},{c:"CB-0274",n:"Azul Ibiza",f:"Blues",h:"#619A9B",s:16},{c:"CB-B059",n:"Porcelana",f:"Blues",h:"#7C8C8F",s:16},{c:"CB-B063",n:"Aloe vera",f:"Blues",h:"#82A2A2",s:16},{c:"CB-B064",n:"Fromio",f:"Blues",h:"#6C8994",s:16},{c:"CB-B103",n:"Azul Seco",f:"Blues",h:"#7590A5",s:16},{c:"CC-0141",n:"Azul Picasso",f:"Blues",h:"#5B94AF",s:25},{c:"CC-0145",n:"Azul Azulejo",f:"Blues",h:"#7E98AC",s:25},{c:"CC-0146",n:"Azul Hortencia",f:"Blues",h:"#6A8498",s:25},{c:"CC-0150",n:"Azul Marinheiro",f:"Blues",h:"#577083",s:25},{c:"CC-0265",n:"Azul Mineral",f:"Blues",h:"#648EAF",s:25},{c:"CC-B062",n:"Algodao Cinzento",f:"Blues",h:"#8193A5",s:25},{c:"CD-0266",n:"Estrelada da Noite",f:"Blues",h:"#3F6B90",s:45},{c:"CD-B101",n:"Azul Noite",f:"Blues",h:"#40536F",s:45},
{c:"CA-0015",n:"Branco Nata",f:"Whites",h:"#E8E9E4",s:10},{c:"CA-0016",n:"Branco Claro",f:"Whites",h:"#F0EEE1",s:10},{c:"CA-0017",n:"Branco Marfim",f:"Whites",h:"#E8E3D7",s:10},{c:"CA-0018",n:"Branco Cinza",f:"Whites",h:"#D7DAD7",s:10},{c:"CA-0019",n:"Branco Rosa",f:"Whites",h:"#E3E0DA",s:10},{c:"CA-0020",n:"Branco de Inverno",f:"Whites",h:"#DBDBD9",s:10},{c:"CA-0021",n:"Branco Perola",f:"Whites",h:"#E2E1D4",s:10},{c:"CA-0022",n:"Branco Croche",f:"Whites",h:"#D9D8CD",s:10},{c:"CA-0039",n:"Acucar",f:"Whites",h:"#EBE8DE",s:10},{c:"CA-0152",n:"Branco Gelo",f:"Whites",h:"#EFEFE7",s:10},{c:"CA-0153",n:"Branco Leite",f:"Whites",h:"#E5EAE9",s:10},{c:"CA-0154",n:"Branco frio",f:"Whites",h:"#DEE0D9",s:10},{c:"CA-0155",n:"Branco Cetim",f:"Whites",h:"#DFDDD0",s:10},{c:"CA-0156",n:"Branco Creme",f:"Whites",h:"#E8E8E1",s:10},{c:"CA-0157",n:"Branco Rosado",f:"Whites",h:"#EAE9E9",s:10},{c:"CA-0158",n:"Branco espuma",f:"Whites",h:"#E2E6E9",s:10},{c:"CA-0159",n:"Branco Intemporal",f:"Whites",h:"#DDDCD8",s:10},{c:"CA-0160",n:"Branco Azulado",f:"Whites",h:"#E0E9E7",s:10},{c:"CA-0161",n:"Branco Oceano",f:"Whites",h:"#E3EBE7",s:10},{c:"CA-0162",n:"Branco Essencia",f:"Whites",h:"#E3E9DD",s:10},{c:"CA-0163",n:"Clara D ovo",f:"Whites",h:"#F1EFDD",s:10},{c:"CA-0164",n:"Nata",f:"Whites",h:"#EAE6D6",s:10},{c:"CA-0168",n:"Porcelana",f:"Whites",h:"#DDDCD1",s:10},{c:"CA-B001",n:"Tulipa Branca",f:"Whites",h:"#DED9D3",s:10},{c:"CA-B002",n:"Branco Luz",f:"Whites",h:"#E4E4D9",s:10},{c:"CA-B003",n:"Creme de Leite",f:"Whites",h:"#DEDFD5",s:10},{c:"CA-B073",n:"Perola",f:"Whites",h:"#EDEFEF",s:10},{c:"CA-B075",n:"Baunilha",f:"Whites",h:"#E8E8DB",s:10},{c:"CA-B077",n:"Gelo Seco",f:"Whites",h:"#E2E6E0",s:10},{c:"CA-B078",n:"Agua",f:"Whites",h:"#D3D9D8",s:10},{c:"CA-B166",n:"Algodao",f:"Whites",h:"#DFDFD4",s:10},{c:"CA-B167",n:"Semente Abobora",f:"Whites",h:"#D9DCD5",s:10},{c:"CA-B180",n:"Gergelim Branco",f:"Whites",h:"#DDD7D0",s:10},{c:"CA-B187",n:"Basmati",f:"Whites",h:"#CFCCBF",s:10},{c:"CA-B197",n:"Semente",f:"Whites",h:"#E5DDC8",s:10},{c:"CW-001",n:"Branco",f:"Whites",h:"#FFFFFF",s:0},
{c:"CA-0095",n:"Moka",f:"Browns",h:"#A59689",s:10},{c:"CA-0292",n:"Cafe Torrado",f:"Browns",h:"#B8AC9A",s:10},{c:"CA-0295",n:"Mogli",f:"Browns",h:"#AA9C97",s:10},{c:"CA-B018",n:"Linho",f:"Browns",h:"#B6AEA6",s:10},{c:"CA-B019",n:"Lontra",f:"Browns",h:"#BBB4A9",s:10},{c:"CA-B023",n:"Lebre",f:"Browns",h:"#97857D",s:10},{c:"CA-B090",n:"Palmier",f:"Browns",h:"#C0AE97",s:10},{c:"CA-B091",n:"Avela",f:"Browns",h:"#CAC2BA",s:10},{c:"CA-B179",n:"Carioca",f:"Browns",h:"#A28F7D",s:10},{c:"CA-B204",n:"Chuva de Verao",f:"Browns",h:"#847F79",s:10},{c:"CB-0054",n:"Couro",f:"Browns",h:"#B09E8A",s:16},{c:"CB-0089",n:"Cappuccino",f:"Browns",h:"#B19873",s:16},{c:"CB-0293",n:"Mousse",f:"Browns",h:"#9D8266",s:16},{c:"CB-0296",n:"Castanho Classico",f:"Browns",h:"#877669",s:16},{c:"CB-0301",n:"Camel",f:"Browns",h:"#B38B61",s:16},{c:"CB-0302",n:"Chocolate Negro",f:"Browns",h:"#615246",s:16},{c:"CB-0304",n:"Licor de Chocolate",f:"Browns",h:"#84635A",s:16},{c:"CB-B020",n:"Folha Seca",f:"Browns",h:"#ACA291",s:16},{c:"CB-B021",n:"Urso",f:"Browns",h:"#877D6E",s:16},{c:"CB-B022",n:"Alcaparra",f:"Browns",h:"#7E6F57",s:16},{c:"CB-B206",n:"Stracciatella",f:"Browns",h:"#6A625D",s:16},{c:"CC-0090",n:"Grao de Cafe",f:"Browns",h:"#886C54",s:25},{c:"CC-0294",n:"Castanho Africano",f:"Browns",h:"#8A806D",s:25},{c:"CC-0297",n:"Amendoa Torrada",f:"Browns",h:"#AF9F82",s:25},{c:"CC-0298",n:"Castanho Canela",f:"Browns",h:"#88582D",s:25},{c:"CC-0306",n:"Cafe em Po",f:"Browns",h:"#6F5238",s:25},{c:"CC-B024",n:"Aguia",f:"Browns",h:"#8D7E70",s:25},{c:"CC-B025",n:"Cacau",f:"Browns",h:"#553D32",s:25},
{c:"CA-0023",n:"Cinza Gelo",f:"Greys",h:"#D2D9D9",s:10},{c:"CA-0024",n:"Cinza Nevoeiro",f:"Greys",h:"#ADB5B6",s:10},{c:"CA-0025",n:"Cinza Cimento",f:"Greys",h:"#969D9F",s:10},{c:"CA-0026",n:"Cinza Fumo",f:"Greys",h:"#858B8D",s:10},{c:"CA-0027",n:"Cinza Claro",f:"Greys",h:"#C4CCCE",s:10},{c:"CA-0028",n:"Cinza Zen",f:"Greys",h:"#B5C0C6",s:10},{c:"CA-0029",n:"Cinza Inverno",f:"Greys",h:"#8C969D",s:10},{c:"CA-0030",n:"Cinza Doce",f:"Greys",h:"#BCB7BA",s:10},{c:"CA-0031",n:"Cinza Rocha",f:"Greys",h:"#C1BFB9",s:10},{c:"CA-0032",n:"Cinza Escama",f:"Greys",h:"#B1B5B2",s:10},{c:"CA-0033",n:"Cinza Po",f:"Greys",h:"#ADA9A1",s:10},{c:"CA-0034",n:"Cinza Suave",f:"Greys",h:"#A8A6A8",s:10},{c:"CA-0035",n:"Cinza Vieira",f:"Greys",h:"#DCDBD4",s:10},{c:"CA-0036",n:"Cinza Creme",f:"Greys",h:"#CECCC6",s:10},{c:"CA-0228",n:"Pedra Pirite",f:"Greys",h:"#CAC8C2",s:10},{c:"CA-0229",n:"Cimento",f:"Greys",h:"#BBBCB7",s:10},{c:"CA-0230",n:"Estanho",f:"Greys",h:"#AAADA5",s:10},{c:"CA-0232",n:"Cinza Purpura",f:"Greys",h:"#ABA8AA",s:10},{c:"CA-0234",n:"Antracite",f:"Greys",h:"#989C99",s:10},{c:"CA-0235",n:"Neblina Matinal",f:"Greys",h:"#C2C5C1",s:10},{c:"CA-0237",n:"Granito",f:"Greys",h:"#969FA0",s:10},{c:"CA-0239",n:"Persa",f:"Greys",h:"#D7DAD9",s:10},{c:"CA-0240",n:"Serenidade",f:"Greys",h:"#B4BDC2",s:10},{c:"CA-0241",n:"Rochedo",f:"Greys",h:"#9BA5B1",s:10},{c:"CA-B036",n:"Marmore",f:"Greys",h:"#D9DFDD",s:10},{c:"CA-B037",n:"Glaciar",f:"Greys",h:"#C8D1D5",s:10},{c:"CA-B038",n:"Antartida",f:"Greys",h:"#C2C8C9",s:10},{c:"CA-B042",n:"Jacinto",f:"Greys",h:"#C6C7C3",s:10},{c:"CA-B043",n:"Ricota",f:"Greys",h:"#D5D5CB",s:10},{c:"CA-B044",n:"Lirio",f:"Greys",h:"#C9CACA",s:10},{c:"CA-B046",n:"Iris",f:"Greys",h:"#D5D9E2",s:10},{c:"CA-B047",n:"Absinto",f:"Greys",h:"#B1B6B7",s:10},{c:"CA-B048",n:"Cinza Urbano",f:"Greys",h:"#A1A8A8",s:10},{c:"CA-B049",n:"Cromio",f:"Greys",h:"#8E8F83",s:10},{c:"CA-B050",n:"Inox",f:"Greys",h:"#8D8A7E",s:10},{c:"CA-B051",n:"Niquel",f:"Greys",h:"#86888C",s:10},{c:"CA-B052",n:"Folha de Prata",f:"Greys",h:"#7F8684",s:10},{c:"CA-B131",n:"Tornado",f:"Greys",h:"#B1B8C3",s:10},{c:"CA-B132",n:"Medieval",f:"Greys",h:"#8F9CA5",s:10},{c:"CA-B133",n:"Po Seco",f:"Greys",h:"#AFB5B7",s:10},{c:"CA-B134",n:"Niquel 2",f:"Greys",h:"#A7ADB0",s:10},{c:"CA-B135",n:"Tubarao",f:"Greys",h:"#BDBBB9",s:10},{c:"CA-B136",n:"Cinza Mar",f:"Greys",h:"#B5BFB7",s:10},{c:"CA-B137",n:"Degelo",f:"Greys",h:"#D3D1D1",s:10},{c:"CA-B138",n:"Grisalho",f:"Greys",h:"#CFD8E0",s:10},{c:"CA-B140",n:"Siames",f:"Greys",h:"#B8B3AC",s:10},{c:"CA-B172",n:"Cinza Tostado",f:"Greys",h:"#B8B7B2",s:10},{c:"CA-B173",n:"Cafe latte",f:"Greys",h:"#C0BBB4",s:10},{c:"CA-B174",n:"Semente de Chia",f:"Greys",h:"#938E8A",s:10},{c:"CA-B189",n:"Garca",f:"Greys",h:"#A5A9A5",s:10},{c:"CA-B191",n:"Sombrero",f:"Greys",h:"#777875",s:10},{c:"CA-B194",n:"Urbano",f:"Greys",h:"#8E978D",s:10},{c:"CA-B195",n:"Nevoa",f:"Greys",h:"#A7A9A3",s:10},{c:"CA-B205",n:"Felino",f:"Greys",h:"#8E8A80",s:10},{c:"CA-B220",n:"Guaxinim",f:"Greys",h:"#A6A6A7",s:10},{c:"CA-B221",n:"Estatua",f:"Greys",h:"#9DA6AC",s:10},{c:"CA-B222",n:"Crochet",f:"Greys",h:"#CDCFCF",s:10},{c:"CA-B224",n:"Calcada Portuguesa",f:"Greys",h:"#ADB6BB",s:10},{c:"CA-B225",n:"Descobrimentos",f:"Greys",h:"#939897",s:10},{c:"CB-0037",n:"Cinza Metal",f:"Greys",h:"#8B8C85",s:16},{c:"CB-0238",n:"Areia Vulcanica",f:"Greys",h:"#656868",s:16},{c:"CB-B219",n:"Corvo",f:"Greys",h:"#454D51",s:16},{c:"CC-0038",n:"Cinza Escuro",f:"Greys",h:"#656F74",s:25},{c:"CC-0233",n:"Ferro",f:"Greys",h:"#928D90",s:25},{c:"CC-0242",n:"Grafite",f:"Greys",h:"#636C72",s:25},{c:"CC-0257",n:"Violeta de Outono",f:"Greys",h:"#999FAC",s:25},{c:"CC-B053",n:"Carvao Vegetal",f:"Greys",h:"#59646B",s:25},{c:"CC-B054",n:"Manuscrito",f:"Greys",h:"#505B5E",s:25},{c:"CC-B128",n:"Escuridao",f:"Greys",h:"#3F3F35",s:25},{c:"CC-B129",n:"Tempestade",f:"Greys",h:"#445459",s:25},{c:"CD-B130",n:"Brasao",f:"Greys",h:"#68696E",s:45},
{c:"CA-0046",n:"Nude",f:"Creams",h:"#BAA18A",s:10},{c:"CA-0047",n:"Cru",f:"Creams",h:"#EFDEC5",s:10},{c:"CA-0048",n:"Creme",f:"Creams",h:"#F2D6B1",s:10},{c:"CA-0049",n:"Espiga de Trigo",f:"Creams",h:"#CFBA94",s:10},{c:"CA-0050",n:"Bombazine",f:"Creams",h:"#C3B69B",s:10},{c:"CA-0051",n:"Crepe",f:"Creams",h:"#E2D1B6",s:10},{c:"CA-0052",n:"Grao de Bico",f:"Creams",h:"#D4C4A9",s:10},{c:"CA-0053",n:"Flor de Pessegueiro",f:"Creams",h:"#C6B29C",s:10},{c:"CA-0071",n:"Casca de Ovo",f:"Creams",h:"#E0CCB3",s:10},{c:"CA-0074",n:"Pele Rosada",f:"Creams",h:"#D7C2AF",s:10},{c:"CA-0166",n:"Creme Pastel",f:"Creams",h:"#F0E3B6",s:10},{c:"CA-0171",n:"Pedra Clara",f:"Creams",h:"#D4CBB7",s:10},{c:"CA-0173",n:"Mel",f:"Creams",h:"#D7C7A3",s:10},{c:"CA-0174",n:"Creme de Pessego",f:"Creams",h:"#F1D7A2",s:10},{c:"CA-0176",n:"Alabastro",f:"Creams",h:"#DED5BB",s:10},{c:"CA-0178",n:"Creme de Cafe",f:"Creams",h:"#C8BBA7",s:10},{c:"CA-0184",n:"Seara",f:"Creams",h:"#DDCFA1",s:10},{c:"CA-0188",n:"Camurca",f:"Creams",h:"#E1CA9E",s:10},{c:"CA-0204",n:"Pessego",f:"Creams",h:"#E5C298",s:10},{c:"CA-0291",n:"Polen",f:"Creams",h:"#DAD3C8",s:10},{c:"CA-B011",n:"Licor de Avela",f:"Creams",h:"#EED5B3",s:10},{c:"CA-B045",n:"Crisantemo",f:"Creams",h:"#C8CED4",s:10},{c:"CA-B080",n:"Centeio",f:"Creams",h:"#DECDB2",s:10},{c:"CA-B081",n:"Manteiga",f:"Creams",h:"#E7CDA2",s:10},{c:"CA-B082",n:"Dente de Leao",f:"Creams",h:"#F1DFC4",s:10},{c:"CA-B171",n:"Pingado",f:"Creams",h:"#BCB6A8",s:10},{c:"CA-B175",n:"Amaranto",f:"Creams",h:"#DCC7AD",s:10},{c:"CA-B178",n:"Ristretto",f:"Creams",h:"#C0B19E",s:10},{c:"CA-B181",n:"Galao",f:"Creams",h:"#CCBAAE",s:10},{c:"CA-B196",n:"Doce de Nata",f:"Creams",h:"#C0B4A2",s:10},{c:"CA-B199",n:"Creme Queimado",f:"Creams",h:"#BBB3A6",s:10},{c:"CA-B203",n:"Clerigos",f:"Creams",h:"#B5A98C",s:10},
{c:"CA-0040",n:"Concha",f:"Naturals",h:"#DCD5C4",s:10},{c:"CA-0041",n:"Creme Suave",f:"Naturals",h:"#DDD5C2",s:10},{c:"CA-0042",n:"Veludo Claro",f:"Naturals",h:"#C9C8BC",s:10},{c:"CA-0043",n:"Suspiro",f:"Naturals",h:"#F3ECCC",s:10},{c:"CA-0044",n:"Papel de Seda",f:"Naturals",h:"#EEE7D0",s:10},{c:"CA-0045",n:"Manteiga",f:"Naturals",h:"#E2D2B3",s:10},{c:"CA-0165",n:"Banana",f:"Naturals",h:"#E8E1C6",s:10},{c:"CA-0167",n:"Base Natural",f:"Naturals",h:"#E4DFD2",s:10},{c:"CA-0170",n:"Espumado",f:"Naturals",h:"#E0D0B5",s:10},{c:"CA-0172",n:"Beje Rosado",f:"Naturals",h:"#DCD4CF",s:10},{c:"CA-0175",n:"Doce de Leite",f:"Naturals",h:"#E8E0D0",s:10},{c:"CA-0177",n:"La Pura",f:"Naturals",h:"#DDD9C8",s:10},{c:"CA-0203",n:"Areia",f:"Naturals",h:"#F0E0C3",s:10},{c:"CA-0211",n:"Inocencia",f:"Naturals",h:"#EAE2DC",s:10},{c:"CA-0227",n:"Sombra Suave",f:"Naturals",h:"#D3D8D7",s:10},{c:"CA-0231",n:"Cristal",f:"Naturals",h:"#D4D6DB",s:10},{c:"CA-0243",n:"Brisa",f:"Naturals",h:"#D8DCE2",s:10},{c:"CA-B004",n:"Espuma do Mar",f:"Naturals",h:"#EAE0D2",s:10},{c:"CA-B005",n:"Onda",f:"Naturals",h:"#DFDAC9",s:10},{c:"CA-B006",n:"Branca Clara",f:"Naturals",h:"#E8E7DB",s:10},{c:"CA-B040",n:"Anastasia",f:"Naturals",h:"#E2E8DE",s:10},{c:"CA-B079",n:"Melancolia",f:"Naturals",h:"#EAE0CC",s:10},{c:"CA-B169",n:"Quinoa",f:"Naturals",h:"#CECAC0",s:10},{c:"CA-B170",n:"Cevada",f:"Naturals",h:"#D9CCB0",s:10},{c:"CA-B176",n:"Canjica",f:"Naturals",h:"#D1C5A8",s:10},{c:"CA-B177",n:"Cevada 2",f:"Naturals",h:"#CEC9B9",s:10},{c:"CA-B182",n:"Pergaminho",f:"Naturals",h:"#E2D6C5",s:10},{c:"CA-B190",n:"Leite Condensado",f:"Naturals",h:"#BDBAAB",s:10},{c:"CA-B200",n:"Leite Creme",f:"Naturals",h:"#DBCCB2",s:10},{c:"CA-B223",n:"Cinza Pombalino",f:"Naturals",h:"#CCD1D2",s:10},
{c:"CA-0088",n:"Areia de Verao",f:"Ochres",h:"#C7B389",s:10},{c:"CA-0169",n:"Azeitona",f:"Ochres",h:"#C2BBA0",s:10},{c:"CA-B016",n:"California",f:"Ochres",h:"#C29787",s:10},{c:"CA-B183",n:"Ginseng",f:"Ochres",h:"#CEAA98",s:10},{c:"CA-B198",n:"Galho",f:"Ochres",h:"#C4B394",s:10},{c:"CB-0077",n:"Rosacea",f:"Ochres",h:"#B79279",s:16},{c:"CB-0081",n:"Terra",f:"Ochres",h:"#B48560",s:16},{c:"CB-0084",n:"Deserto",f:"Ochres",h:"#C8AE84",s:16},{c:"CB-0085",n:"Tundra",f:"Ochres",h:"#B08F61",s:16},{c:"CB-0086",n:"Caramelo",f:"Ochres",h:"#9D7B50",s:16},{c:"CB-0087",n:"Ambar",f:"Ochres",h:"#CFAE7C",s:16},{c:"CB-0091",n:"Terra Santa",f:"Ochres",h:"#B07F68",s:16},{c:"CB-0092",n:"Folha de Outono",f:"Ochres",h:"#AF7256",s:16},{c:"CB-0093",n:"Alentejo",f:"Ochres",h:"#AA6D59",s:16},{c:"CB-0094",n:"Planicie Africana",f:"Ochres",h:"#905A47",s:16},{c:"CB-0098",n:"Terra Pura",f:"Ochres",h:"#825744",s:16},{c:"CB-B202",n:"Arenoso",f:"Ochres",h:"#B29B78",s:16},{c:"CB-B207",n:"Ocre",f:"Ochres",h:"#9C6C5C",s:16},{c:"CC-0078",n:"Tijolo Suave",f:"Ochres",h:"#B38851",s:25},{c:"CC-0079",n:"Ceramica",f:"Ochres",h:"#B39055",s:25},{c:"CC-0083",n:"Idade do Ouro",f:"Ochres",h:"#CFAD74",s:25},{c:"CC-0097",n:"Terra Cota",f:"Ochres",h:"#966952",s:25},{c:"CC-0099",n:"Mogno",f:"Ochres",h:"#8C554E",s:25},{c:"CC-0101",n:"Bolota",f:"Ochres",h:"#7A5248",s:25},{c:"CC-0189",n:"Trigo",f:"Ochres",h:"#D7BA79",s:25},{c:"CC-0190",n:"Palha Dourada",f:"Ochres",h:"#CDAD6D",s:25},{c:"CC-0202",n:"Sandalo",f:"Ochres",h:"#774535",s:25},{c:"CC-0278",n:"Verde Azeitona",f:"Ochres",h:"#A0802E",s:25},{c:"CC-0299",n:"Colmeia",f:"Ochres",h:"#CA9E4D",s:25},{c:"CC-0300",n:"Deserto de Gobi",f:"Ochres",h:"#AE8C50",s:25},{c:"CC-0305",n:"Cerejeira",f:"Ochres",h:"#865145",s:25},{c:"CC-B015",n:"Vesuvio",f:"Ochres",h:"#CB9475",s:25},{c:"CC-B087",n:"Grao de Bico",f:"Ochres",h:"#D8B275",s:25},{c:"CC-B088",n:"Ouro Velho",f:"Ochres",h:"#C99D27",s:25},{c:"CC-B089",n:"Nenufar",f:"Ochres",h:"#BBA57B",s:25},{c:"CC-B092",n:"Trufa",f:"Ochres",h:"#92562F",s:25},{c:"CD-0102",n:"Castanho Carvalho",f:"Ochres",h:"#683C37",s:45},{c:"CD-0118",n:"Rosa Obsessao",f:"Ochres",h:"#78504B",s:45},{c:"CD-B139",n:"Vinho Doce",f:"Ochres",h:"#816565",s:45},{c:"CD-B208",n:"Tinto",f:"Ochres",h:"#593D41",s:45},
{c:"CA-0013",n:"Rosa Begonia",f:"Pinks",h:"#D1C1BB",s:10},{c:"CA-0073",n:"Rosa Cafe",f:"Pinks",h:"#C9B4A1",s:10},{c:"CA-0103",n:"Rosa de Primavera",f:"Pinks",h:"#DECFCA",s:10},{c:"CA-0104",n:"Rosa Orquidia",f:"Pinks",h:"#D8C8BB",s:10},{c:"CA-0105",n:"Rosa Doce",f:"Pinks",h:"#EBDAD7",s:10},{c:"CA-0106",n:"Rosa Paixao",f:"Pinks",h:"#B69692",s:10},{c:"CA-0107",n:"Rosa Rose",f:"Pinks",h:"#DBC2C0",s:10},{c:"CA-0108",n:"Rosa Pimenta",f:"Pinks",h:"#C4A195",s:10},{c:"CA-0109",n:"Rosa Algodao",f:"Pinks",h:"#C8A392",s:10},{c:"CA-0110",n:"Rosa Carmim",f:"Pinks",h:"#A87872",s:10},{c:"CA-0111",n:"Rosa Prosa",f:"Pinks",h:"#DCD3C8",s:10},{c:"CA-0112",n:"Rosa Seca",f:"Pinks",h:"#CFBEB5",s:10},{c:"CA-0115",n:"Rosa dos ventos",f:"Pinks",h:"#DAD1CC",s:10},{c:"CA-0116",n:"Rosa d agua",f:"Pinks",h:"#D3B6A7",s:10},{c:"CA-0195",n:"Ceramica Rosa",f:"Pinks",h:"#E5E0DE",s:10},{c:"CA-0212",n:"Rosa dos Ventos 2",f:"Pinks",h:"#EDC8C1",s:10},{c:"CA-0215",n:"Rosa Claro",f:"Pinks",h:"#E5DBDC",s:10},{c:"CA-0216",n:"Flor da Macieira",f:"Pinks",h:"#E4CDDC",s:10},{c:"CA-0217",n:"Agua de Rosas",f:"Pinks",h:"#DBB8CE",s:10},{c:"CA-0218",n:"Alfazema",f:"Pinks",h:"#DEA9C9",s:10},{c:"CA-0219",n:"Rosa Palido",f:"Pinks",h:"#E9DCDA",s:10},{c:"CA-0220",n:"Rosa Pastel",f:"Pinks",h:"#E7C7CB",s:10},{c:"CA-0223",n:"Seda",f:"Pinks",h:"#DCB9B8",s:10},{c:"CA-B029",n:"Rosa Suave",f:"Pinks",h:"#E6DBD8",s:10},{c:"CA-B030",n:"Rosa Real",f:"Pinks",h:"#DFD3C7",s:10},{c:"CA-B031",n:"Begonia",f:"Pinks",h:"#CCBDBB",s:10},{c:"CA-B032",n:"Blush",f:"Pinks",h:"#C6A99E",s:10},{c:"CA-B033",n:"Rosa Merengue",f:"Pinks",h:"#C1B4B6",s:10},{c:"CA-B035",n:"Ouro Rosa",f:"Pinks",h:"#B58880",s:10},{c:"CA-B093",n:"Rosa Segredo",f:"Pinks",h:"#EEC5B9",s:10},{c:"CA-B094",n:"Flor de Maio",f:"Pinks",h:"#DFDADE",s:10},{c:"CA-B095",n:"Rosa Amor",f:"Pinks",h:"#D0A5AE",s:10},{c:"CA-B188",n:"Rosa Lilas",f:"Pinks",h:"#C7C4C6",s:10},{c:"CA-B209",n:"Petala",f:"Pinks",h:"#E4DBDD",s:10},{c:"CA-B210",n:"Rosado",f:"Pinks",h:"#CFC0BA",s:10},{c:"CA-B211",n:"Rosa Velho",f:"Pinks",h:"#BC9DA0",s:10},{c:"CB-0114",n:"Rosa de Inverno",f:"Pinks",h:"#95675C",s:16},{c:"CB-0117",n:"Rosa Selvagem",f:"Pinks",h:"#B49081",s:16},{c:"CB-0221",n:"Petunia",f:"Pinks",h:"#E4B5BE",s:16},{c:"CB-0224",n:"Intemporal",f:"Pinks",h:"#B98E97",s:16},{c:"CB-B034",n:"Terra Quente",f:"Pinks",h:"#B18E84",s:16},{c:"CC-0213",n:"Primavera",f:"Pinks",h:"#EBA19B",s:25},{c:"CC-B096",n:"Pele Rosada",f:"Pinks",h:"#B38786",s:25},{c:"CC-B097",n:"Perola Rosa",f:"Pinks",h:"#B47073",s:25},{c:"CD-0197",n:"Coral",f:"Pinks",h:"#D46159",s:45},{c:"CD-0214",n:"Papaia",f:"Pinks",h:"#DE7F74",s:45},{c:"CD-0222",n:"Pantera",f:"Pinks",h:"#D296AA",s:45},{c:"CD-0225",n:"Doce de Morango",f:"Pinks",h:"#C982AD",s:45},{c:"CD-0226",n:"Rosa Forte",f:"Pinks",h:"#B94C74",s:45},
{c:"CA-0123",n:"Verde Milho",f:"Greens",h:"#D2CAA1",s:10},{c:"CA-0124",n:"Verde Maca",f:"Greens",h:"#C4BD9F",s:10},{c:"CA-0127",n:"Erva Doce",f:"Greens",h:"#B3BEAD",s:10},{c:"CA-0128",n:"Verde Brisa",f:"Greens",h:"#AFBFB2",s:10},{c:"CA-0275",n:"Verde Agua",f:"Greens",h:"#E2E9D7",s:10},{c:"CA-0276",n:"Verde Classico",f:"Greens",h:"#D1D2B4",s:10},{c:"CA-0283",n:"Verde Primavera",f:"Greens",h:"#DBE4DB",s:10},{c:"CA-0284",n:"Verde Amizade",f:"Greens",h:"#D0E9D8",s:10},{c:"CA-0286",n:"Verde Tomilho",f:"Greens",h:"#A8A487",s:10},{c:"CA-0287",n:"Verde Cha",f:"Greens",h:"#C0C3A2",s:10},{c:"CA-0288",n:"Verde Menta",f:"Greens",h:"#BFD1AF",s:10},{c:"CA-0289",n:"Verde Equatorial",f:"Greens",h:"#83AD95",s:10},{c:"CA-B065",n:"Hera",f:"Greens",h:"#D6DCD5",s:10},{c:"CA-B066",n:"Cacto",f:"Greens",h:"#B4C5BC",s:10},{c:"CA-B067",n:"Verde Paraiso",f:"Greens",h:"#D1CBAB",s:10},{c:"CA-B069",n:"Imperio",f:"Greens",h:"#7FC7B7",s:10},{c:"CA-B116",n:"Equilibrio",f:"Greens",h:"#D7E0BE",s:10},{c:"CA-B117",n:"Canhamo",f:"Greens",h:"#A6B0A7",s:10},{c:"CA-B118",n:"Rio Tamisa Verde",f:"Greens",h:"#B4C5BD",s:10},{c:"CA-B119",n:"Folha de Outono Verde",f:"Greens",h:"#99AAA4",s:10},{c:"CA-B123",n:"Verde Real",f:"Greens",h:"#B8B689",s:10},{c:"CA-B192",n:"Eucalipto",f:"Greens",h:"#B0B9B3",s:10},{c:"CA-B193",n:"Salvia",f:"Greens",h:"#CCD7C8",s:10},{c:"CA-B218",n:"Ramo Seco",f:"Greens",h:"#ADAF95",s:10},{c:"CB-0121",n:"Verde Abstrato",f:"Greens",h:"#92A384",s:16},{c:"CB-0122",n:"Verde Esperanca",f:"Greens",h:"#9EA57F",s:16},{c:"CB-0125",n:"Verde Azeitona",f:"Greens",h:"#ABA78D",s:16},{c:"CB-0126",n:"Verde Prado",f:"Greens",h:"#6F7558",s:16},{c:"CB-0129",n:"Verde Jade",f:"Greens",h:"#96A89A",s:16},{c:"CB-0130",n:"Verde Seco",f:"Greens",h:"#899484",s:16},{c:"CB-0131",n:"Cidreira",f:"Greens",h:"#707F74",s:16},{c:"CB-0132",n:"Verde Barroco",f:"Greens",h:"#6B7E78",s:16},{c:"CB-0134",n:"Verde Natureza",f:"Greens",h:"#416156",s:16},{c:"CB-0277",n:"Pinheiro Verde",f:"Greens",h:"#C1B682",s:16},{c:"CB-0285",n:"Verde Musgo",f:"Greens",h:"#A9B37F",s:16},{c:"CB-B068",n:"Ametista",f:"Greens",h:"#93A88E",s:16},{c:"CB-B070",n:"Colonial",f:"Greens",h:"#91A28F",s:16},{c:"CB-B071",n:"Selva",f:"Greens",h:"#4C6556",s:16},{c:"CB-B120",n:"Verde Cacto",f:"Greens",h:"#819494",s:16},{c:"CB-B121",n:"Silvestre",f:"Greens",h:"#687C77",s:16},{c:"CB-B122",n:"Casca de Melao",f:"Greens",h:"#93804E",s:16},{c:"CC-0119",n:"Verde Lima",f:"Greens",h:"#CBC88A",s:25},{c:"CC-0120",n:"Folha Verde",f:"Greens",h:"#A4A877",s:25},{c:"CC-0133",n:"Verde Esmeralda",f:"Greens",h:"#59796D",s:25},{c:"CC-0281",n:"Verde Floresta",f:"Greens",h:"#769260",s:25},{c:"CC-0282",n:"Verde Safari",f:"Greens",h:"#81897B",s:25},{c:"CC-0290",n:"Verde Garrafa",f:"Greens",h:"#36553D",s:25},{c:"CC-B072",n:"Tropical",f:"Greens",h:"#2A5039",s:25},{c:"CC-B124",n:"Charme",f:"Greens",h:"#9C9A67",s:25},{c:"CC-B125",n:"Verde Loureiro",f:"Greens",h:"#525541",s:25},{c:"CC-B126",n:"Verde oriental",f:"Greens",h:"#566750",s:25},{c:"CC-B127",n:"Verde Tropa",f:"Greens",h:"#656D61",s:25},{c:"CD-0280",n:"Verde Tropical",f:"Greens",h:"#CACA72",s:45},
{c:"CA-0072",n:"Salmao",f:"Reds",h:"#D7BB9E",s:10},{c:"CA-0199",n:"Hibisco",f:"Reds",h:"#E5BC9E",s:10},{c:"CA-B013",n:"Pingo de Mel",f:"Reds",h:"#DFB591",s:10},{c:"CA-B014",n:"Centeio",f:"Reds",h:"#DDB286",s:10},{c:"CA-B168",n:"Gengibre",f:"Reds",h:"#DAD3C2",s:10},{c:"CA-B184",n:"Abatanado",f:"Reds",h:"#D8B89B",s:10},{c:"CA-B185",n:"Descafeinado",f:"Reds",h:"#C89876",s:10},{c:"CA-B201",n:"Deserto Dourado",f:"Reds",h:"#D8B886",s:10},{c:"CB-0076",n:"Tangerina",f:"Reds",h:"#D0A05F",s:16},{c:"CB-0080",n:"Alperce",f:"Reds",h:"#C99971",s:16},{c:"CB-0303",n:"Deserto da Arabia",f:"Reds",h:"#C9A080",s:16},{c:"CC-0069",n:"Amarelo Torrado",f:"Reds",h:"#CBA773",s:25},{c:"CC-0075",n:"Gengibre 2",f:"Reds",h:"#E5B982",s:25},{c:"CC-0082",n:"Abobora",f:"Reds",h:"#B17742",s:25},{c:"CC-0096",n:"Terra Carmim",f:"Reds",h:"#964B44",s:25},{c:"CC-0205",n:"Casca de Laranja",f:"Reds",h:"#E9AD6E",s:25},{c:"CC-0207",n:"Salmao 2",f:"Reds",h:"#F5B993",s:25},{c:"CC-B012",n:"Quindim",f:"Reds",h:"#CB9458",s:25},{c:"CC-B026",n:"Jamaica",f:"Reds",h:"#7A3F2F",s:25},{c:"CC-B027",n:"Piri Piri",f:"Reds",h:"#8A4F40",s:25},{c:"CC-B086",n:"Mamao",f:"Reds",h:"#E0AC85",s:25},{c:"CD-0100",n:"Cartier",f:"Reds",h:"#96473B",s:45},{c:"CD-0198",n:"Colorado",f:"Reds",h:"#A75056",s:45},{c:"CD-0209",n:"Pimentao",f:"Reds",h:"#CD4028",s:45},{c:"CD-0210",n:"Rubi",f:"Reds",h:"#7B2D2E",s:45},{c:"CD-B028",n:"Cereja",f:"Reds",h:"#904840",s:45},{c:"CD-B085",n:"Tesouro",f:"Reds",h:"#E5B27D",s:45},
{c:"CA-0244",n:"Gerbera",f:"Violets",h:"#D4CEE1",s:10},{c:"CA-0245",n:"Malva Cha",f:"Violets",h:"#B5A1D3",s:10},{c:"CA-0247",n:"Lilas Subtil",f:"Violets",h:"#CACFE1",s:10},{c:"CA-0252",n:"Flor de Cardo",f:"Violets",h:"#A6A7DA",s:10},{c:"CA-0255",n:"Lilas Perfeito",f:"Violets",h:"#C2C7E3",s:10},{c:"CA-0256",n:"Melodia",f:"Violets",h:"#C8C7D1",s:10},{c:"CA-B098",n:"Lilas Palido",f:"Violets",h:"#D9D0D7",s:10},{c:"CA-B099",n:"Sonho Lilas",f:"Violets",h:"#E0D6EA",s:10},{c:"CA-B100",n:"Nostalgia",f:"Violets",h:"#A99EA0",s:10},{c:"CA-B212",n:"Lilas",f:"Violets",h:"#A39DA6",s:10},{c:"CA-B213",n:"Violeta Claro",f:"Violets",h:"#A8B4C4",s:10},{c:"CB-0248",n:"Beija-Flor",f:"Violets",h:"#707E96",s:16},{c:"CB-0253",n:"Bouquet",f:"Violets",h:"#7F93C4",s:16},{c:"CC-B102",n:"Maldivas",f:"Violets",h:"#4E748B",s:25},{c:"CD-0249",n:"Ilusao",f:"Violets",h:"#857E92",s:45}
]

var COLOURS_RAL=[
{c:"RAL 1000",n:"Green beige",f:"Yellows",h:"#CDBA88",s:10},{c:"RAL 1001",n:"Beige",f:"Yellows",h:"#D0B084",s:16},{c:"RAL 1002",n:"Sand yellow",f:"Yellows",h:"#D2AA6D",s:16},{c:"RAL 1003",n:"Signal yellow",f:"Yellows",h:"#F9A900",s:45},{c:"RAL 1004",n:"Golden yellow",f:"Yellows",h:"#E49E00",s:45},{c:"RAL 1005",n:"Honey yellow",f:"Yellows",h:"#CB8F00",s:45},{c:"RAL 1006",n:"Maize yellow",f:"Yellows",h:"#E19000",s:45},{c:"RAL 1007",n:"Daffodil yellow",f:"Yellows",h:"#E88C00",s:45},{c:"RAL 1011",n:"Brown beige",f:"Yellows",h:"#AF8050",s:25},{c:"RAL 1012",n:"Lemon yellow",f:"Yellows",h:"#DDAF28",s:45},{c:"RAL 1013",n:"Oyster white",f:"Yellows",h:"#E3D9C7",s:10},{c:"RAL 1014",n:"Ivory",f:"Yellows",h:"#DDC49B",s:10},{c:"RAL 1015",n:"Light ivory",f:"Yellows",h:"#E6D2B5",s:10},{c:"RAL 1016",n:"Sulfur yellow",f:"Yellows",h:"#F1DD39",s:45},{c:"RAL 1017",n:"Saffron yellow",f:"Yellows",h:"#F6A951",s:45},{c:"RAL 1018",n:"Zinc yellow",f:"Yellows",h:"#FACA31",s:45},{c:"RAL 1019",n:"Grey beige",f:"Yellows",h:"#A48F7A",s:16},{c:"RAL 1020",n:"Olive yellow",f:"Yellows",h:"#A08F65",s:16},{c:"RAL 1021",n:"Colza yellow",f:"Yellows",h:"#F6B600",s:45},{c:"RAL 1023",n:"Traffic yellow",f:"Yellows",h:"#F7B500",s:45},{c:"RAL 1024",n:"Ochre yellow",f:"Yellows",h:"#BA8F4C",s:45},{c:"RAL 1027",n:"Luminous yellow",f:"Yellows",h:"#FFFF00",s:45},{c:"RAL 1028",n:"Curry",f:"Yellows",h:"#A77F0F",s:45},{c:"RAL 1032",n:"Melon yellow",f:"Yellows",h:"#FF9C00",s:45},{c:"RAL 1033",n:"Broom yellow",f:"Yellows",h:"#E2A300",s:45},{c:"RAL 1034",n:"Dahlia yellow",f:"Yellows",h:"#F99A1D",s:45},{c:"RAL 1037",n:"Pastel yellow",f:"Yellows",h:"#EB9C52",s:45},{c:"RAL 2000",n:"Sun yellow",f:"Oranges",h:"#F09200",s:45},{c:"RAL 2001",n:"Yellow orange",f:"Oranges",h:"#DA6E00",s:45},{c:"RAL 2002",n:"Red orange",f:"Oranges",h:"#BA481C",s:45},{c:"RAL 2002b",n:"Vermilion",f:"Oranges",h:"#BF3922",s:45},{c:"RAL 2003",n:"Pastel orange",f:"Oranges",h:"#F67829",s:45},{c:"RAL 2004",n:"Pure orange",f:"Oranges",h:"#E25304",s:45},{c:"RAL 2008",n:"Bright red orange",f:"Oranges",h:"#EC6B22",s:45},{c:"RAL 2009",n:"Traffic orange",f:"Oranges",h:"#DE5308",s:45},{c:"RAL 2010",n:"Signal orange",f:"Oranges",h:"#D05D29",s:45},{c:"RAL 2011",n:"Deep orange",f:"Oranges",h:"#E26E0F",s:45},{c:"RAL 2012",n:"Salmon orange",f:"Oranges",h:"#D5654E",s:45},{c:"RAL 2017",n:"RAL orange",f:"Oranges",h:"#FC5500",s:45},{c:"RAL 3000",n:"Flame red",f:"Reds",h:"#A72920",s:45},{c:"RAL 3001",n:"Signal red",f:"Reds",h:"#9B2423",s:45},{c:"RAL 3002",n:"Carmine red",f:"Reds",h:"#9B2321",s:45},{c:"RAL 3003",n:"Ruby red",f:"Reds",h:"#861A22",s:45},{c:"RAL 3004",n:"Purple red",f:"Reds",h:"#6B1C23",s:45},{c:"RAL 3005",n:"Wine red",f:"Reds",h:"#59191F",s:45},{c:"RAL 3007",n:"Black red",f:"Reds",h:"#3E2022",s:45},{c:"RAL 3009",n:"Oxide red",f:"Reds",h:"#6D342D",s:45},{c:"RAL 3011",n:"Brown red",f:"Reds",h:"#782423",s:45},{c:"RAL 3012",n:"Beige red",f:"Reds",h:"#C5856D",s:16},{c:"RAL 3013",n:"Tomato red",f:"Reds",h:"#972E25",s:45},{c:"RAL 3014",n:"Antique pink",f:"Reds",h:"#CB7375",s:45},{c:"RAL 3015",n:"Light pink",f:"Reds",h:"#D8A0A6",s:10},{c:"RAL 3016",n:"Coral red",f:"Reds",h:"#A63D30",s:45},{c:"RAL 3017",n:"Rose",f:"Reds",h:"#CA555D",s:45},{c:"RAL 3018",n:"Strawberry red",f:"Reds",h:"#C63F4A",s:45},{c:"RAL 3020",n:"Traffic red",f:"Reds",h:"#BB1F11",s:45},{c:"RAL 3022",n:"Salmon pink",f:"Reds",h:"#CF6955",s:45},{c:"RAL 3027",n:"Raspberry red",f:"Reds",h:"#AB273C",s:45},{c:"RAL 3028",n:"Pure red",f:"Reds",h:"#CC2C24",s:45},{c:"RAL 3031",n:"Orient red",f:"Reds",h:"#A63437",s:45},{c:"RAL 4001",n:"Red lilac",f:"Violets",h:"#816183",s:45},{c:"RAL 4002",n:"Red violet",f:"Violets",h:"#8D3C4B",s:45},{c:"RAL 4003",n:"Heather violet",f:"Violets",h:"#C4618C",s:45},{c:"RAL 4004",n:"Claret violet",f:"Violets",h:"#651E38",s:45},{c:"RAL 4005",n:"Blue lilac",f:"Violets",h:"#76689A",s:45},{c:"RAL 4006",n:"Traffic purple",f:"Violets",h:"#903373",s:45},{c:"RAL 4007",n:"Purple violet",f:"Violets",h:"#47243C",s:45},{c:"RAL 4008",n:"Signal violet",f:"Violets",h:"#844C82",s:45},{c:"RAL 4009",n:"Pastel violet",f:"Violets",h:"#9D8692",s:45},{c:"RAL 4010",n:"Telemagenta",f:"Violets",h:"#BB4077",s:45},{c:"RAL 5000",n:"Violet blue",f:"Blues",h:"#304F6E",s:25},{c:"RAL 5001",n:"Green blue",f:"Blues",h:"#0E4C64",s:45},{c:"RAL 5002",n:"Ultramarine blue",f:"Blues",h:"#00387A",s:45},{c:"RAL 5003",n:"Sapphire blue",f:"Blues",h:"#1F3855",s:25},{c:"RAL 5004",n:"Black blue",f:"Blues",h:"#191E28",s:25},{c:"RAL 5005",n:"Signal blue",f:"Blues",h:"#005387",s:45},{c:"RAL 5007",n:"Brillant blue",f:"Blues",h:"#376B8C",s:45},{c:"RAL 5008",n:"Grey blue",f:"Blues",h:"#2B3A44",s:25},{c:"RAL 5009",n:"Azure blue",f:"Blues",h:"#215F78",s:45},{c:"RAL 5010",n:"Gentian blue",f:"Blues",h:"#004F7C",s:45},{c:"RAL 5011",n:"Steel blue",f:"Blues",h:"#1A2B3C",s:25},{c:"RAL 5012",n:"Light blue",f:"Blues",h:"#0089B6",s:25},{c:"RAL 5013",n:"Cobalt blue",f:"Blues",h:"#193153",s:45},{c:"RAL 5014",n:"Pigeon blue",f:"Blues",h:"#637D96",s:25},{c:"RAL 5015",n:"Sky blue",f:"Blues",h:"#007CAF",s:45},{c:"RAL 5017",n:"Traffic blue",f:"Blues",h:"#005B8C",s:25},{c:"RAL 5018",n:"Turquoise blue",f:"Blues",h:"#048B8C",s:25},{c:"RAL 5019",n:"Capri blue",f:"Blues",h:"#005E83",s:25},{c:"RAL 5020",n:"Ocean blue",f:"Blues",h:"#00414B",s:25},{c:"RAL 5021",n:"Water blue",f:"Blues",h:"#007577",s:25},{c:"RAL 5022",n:"Night blue",f:"Blues",h:"#222D5A",s:45},{c:"RAL 5023",n:"Distant blue",f:"Blues",h:"#41698C",s:45},{c:"RAL 5024",n:"Pastel blue",f:"Blues",h:"#6093AC",s:10},{c:"RAL 6000",n:"Patina green",f:"Greens",h:"#3C7460",s:25},{c:"RAL 6001",n:"Emerald green",f:"Greens",h:"#366735",s:25},{c:"RAL 6002",n:"Leaf green",f:"Greens",h:"#325928",s:45},{c:"RAL 6003",n:"Olive green",f:"Greens",h:"#50533C",s:25},{c:"RAL 6004",n:"Blue green",f:"Greens",h:"#024442",s:25},{c:"RAL 6005",n:"Moss green",f:"Greens",h:"#114232",s:45},{c:"RAL 6006",n:"Grey olive",f:"Greens",h:"#3C392E",s:25},{c:"RAL 6007",n:"Bottle green",f:"Greens",h:"#2C3222",s:45},{c:"RAL 6008",n:"Brown green",f:"Greens",h:"#36342A",s:25},{c:"RAL 6009",n:"Fir green",f:"Greens",h:"#27352A",s:45},{c:"RAL 6010",n:"Grass green",f:"Greens",h:"#4D6F39",s:45},{c:"RAL 6011",n:"Reseda green",f:"Greens",h:"#6B7C59",s:25},{c:"RAL 6012",n:"Black green",f:"Greens",h:"#2F3D3A",s:25},{c:"RAL 6013",n:"Reed green",f:"Greens",h:"#7C765A",s:25},{c:"RAL 6014",n:"Yellow olive",f:"Greens",h:"#474135",s:16},{c:"RAL 6015",n:"Black olive",f:"Greens",h:"#3D3D36",s:25},{c:"RAL 6016",n:"Turquoise green",f:"Greens",h:"#00694C",s:25},{c:"RAL 6017",n:"May green",f:"Greens",h:"#587F40",s:25},{c:"RAL 6018",n:"Yellow green",f:"Greens",h:"#60993B",s:45},{c:"RAL 6019",n:"Pastel green",f:"Greens",h:"#B9CEAC",s:10},{c:"RAL 6020",n:"Chrome green",f:"Greens",h:"#37422F",s:45},{c:"RAL 6021",n:"Pale green",f:"Greens",h:"#8A9977",s:16},{c:"RAL 6022",n:"Olive drab",f:"Greens",h:"#3A3327",s:45},{c:"RAL 6024",n:"Traffic green",f:"Greens",h:"#008351",s:25},{c:"RAL 6025",n:"Fern green",f:"Greens",h:"#5E6E3B",s:25},{c:"RAL 6026",n:"Opal green",f:"Greens",h:"#005F4E",s:25},{c:"RAL 6027",n:"Light green",f:"Greens",h:"#7EBAB5",s:16},{c:"RAL 6028",n:"Pine green",f:"Greens",h:"#315442",s:25},{c:"RAL 6029",n:"Mint green",f:"Greens",h:"#006F3D",s:45},{c:"RAL 6032",n:"Signal green",f:"Greens",h:"#237F52",s:25},{c:"RAL 6033",n:"Mint turquoise",f:"Greens",h:"#45877F",s:25},{c:"RAL 6034",n:"Pastel turquoise",f:"Greens",h:"#7AADAC",s:16},{c:"RAL 6037",n:"Pure green",f:"Greens",h:"#008B29",s:45},{c:"RAL 6200",n:"Deep green",f:"Greens",h:"#3C5749",s:25},{c:"RAL 7000",n:"Squirrel grey",f:"Greys",h:"#7A888E",s:16},{c:"RAL 7001",n:"Silver grey",f:"Greys",h:"#8C979C",s:10},{c:"RAL 7002",n:"Olive grey",f:"Greys",h:"#817863",s:16},{c:"RAL 7003",n:"Moss grey",f:"Greys",h:"#797669",s:16},{c:"RAL 7004",n:"Signal grey",f:"Greys",h:"#9A9B9B",s:10},{c:"RAL 7005",n:"Mouse grey",f:"Greys",h:"#6B6E6B",s:16},{c:"RAL 7006",n:"Beige grey",f:"Greys",h:"#766A5E",s:16},{c:"RAL 7008",n:"Khaki grey",f:"Greys",h:"#745F3D",s:25},{c:"RAL 7009",n:"Green grey",f:"Greys",h:"#5D6058",s:25},{c:"RAL 7010",n:"Tarpaulin grey",f:"Greys",h:"#585C56",s:25},{c:"RAL 7011",n:"Iron grey",f:"Greys",h:"#52595D",s:16},{c:"RAL 7012",n:"Basalt grey",f:"Greys",h:"#575D5E",s:16},{c:"RAL 7013",n:"Brown grey",f:"Greys",h:"#575044",s:25},{c:"RAL 7015",n:"Slate grey",f:"Greys",h:"#4F5358",s:16},{c:"RAL 7016",n:"Anthracite grey",f:"Greys",h:"#383E42",s:25},{c:"RAL 7021",n:"Black grey",f:"Greys",h:"#2F3234",s:25},{c:"RAL 7022",n:"Umbra grey",f:"Greys",h:"#4C4A44",s:25},{c:"RAL 7023",n:"Concrete grey",f:"Greys",h:"#808076",s:16},{c:"RAL 7024",n:"Graphite grey",f:"Greys",h:"#45494E",s:25},{c:"RAL 7025",n:"Perl grey",f:"Greys",h:"#868783",s:16},{c:"RAL 7026",n:"Granite grey",f:"Greys",h:"#374345",s:25},{c:"RAL 7030",n:"Stone grey",f:"Greys",h:"#928E85",s:16},{c:"RAL 7031",n:"Blue grey",f:"Greys",h:"#5B686D",s:16},{c:"RAL 7032",n:"Pebble grey",f:"Greys",h:"#B5B0A1",s:10},{c:"RAL 7033",n:"Cement grey",f:"Greys",h:"#7F8274",s:16},{c:"RAL 7034",n:"Yellow grey",f:"Greys",h:"#92886F",s:16},{c:"RAL 7035",n:"Light grey",f:"Greys",h:"#C5C7C4",s:10},{c:"RAL 7036",n:"Platinum grey",f:"Greys",h:"#979392",s:10},{c:"RAL 7037",n:"Dusty grey",f:"Greys",h:"#7A7B7A",s:16},{c:"RAL 7038",n:"Agate grey",f:"Greys",h:"#B0B0A9",s:10},{c:"RAL 7039",n:"Quartz grey",f:"Greys",h:"#6B665E",s:16},{c:"RAL 7040",n:"Window grey",f:"Greys",h:"#989EA1",s:10},{c:"RAL 7042",n:"Traffic grey A",f:"Greys",h:"#8E9291",s:10},{c:"RAL 7043",n:"Traffic grey B",f:"Greys",h:"#4F5250",s:25},{c:"RAL 7044",n:"Silk grey",f:"Greys",h:"#B7B3A8",s:10},{c:"RAL 7045",n:"Telegrey 1",f:"Greys",h:"#8D9295",s:10},{c:"RAL 7046",n:"Telegrey 2",f:"Greys",h:"#7E868A",s:10},{c:"RAL 7047",n:"Telegrey 4",f:"Greys",h:"#C8C8C7",s:10},{c:"RAL 8000",n:"Green brown",f:"Browns",h:"#89693F",s:25},{c:"RAL 8001",n:"Ochre brown",f:"Browns",h:"#9D622B",s:45},{c:"RAL 8002",n:"Signal brown",f:"Browns",h:"#794D3E",s:25},{c:"RAL 8003",n:"Clay brown",f:"Browns",h:"#7E4B27",s:45},{c:"RAL 8004",n:"Copper brown",f:"Browns",h:"#8D4931",s:25},{c:"RAL 8007",n:"Fawn brown",f:"Browns",h:"#70462B",s:45},{c:"RAL 8008",n:"Olive brown",f:"Browns",h:"#724A25",s:45},{c:"RAL 8011",n:"Nut brown",f:"Browns",h:"#5A3827",s:25},{c:"RAL 8012",n:"Red brown",f:"Browns",h:"#66332B",s:45},{c:"RAL 8014",n:"Sepia brown",f:"Browns",h:"#4A3526",s:25},{c:"RAL 8015",n:"Chestnut brown",f:"Browns",h:"#5E2F26",s:45},{c:"RAL 8016",n:"Mahogany brown",f:"Browns",h:"#4C2B20",s:25},{c:"RAL 8017",n:"Chocolate brown",f:"Browns",h:"#442F29",s:25},{c:"RAL 8019",n:"Grey brown",f:"Browns",h:"#3D3635",s:25},{c:"RAL 8022",n:"Black brown",f:"Browns",h:"#1A1719",s:25},{c:"RAL 8023",n:"Orange brown",f:"Browns",h:"#A45729",s:25},{c:"RAL 8024",n:"Beige brown",f:"Browns",h:"#795038",s:25},{c:"RAL 8025",n:"Pale brown",f:"Browns",h:"#755847",s:25},{c:"RAL 8028",n:"Terra brown",f:"Browns",h:"#513A2A",s:25},{c:"RAL 9001",n:"Cream",f:"Black & White",h:"#E9E0D2",s:10},{c:"RAL 9002",n:"Grey white",f:"Black & White",h:"#D6D5CB",s:10},{c:"RAL 9003",n:"Signal white",f:"Black & White",h:"#ECECE7",s:10},{c:"RAL 9004",n:"Signal black",f:"Black & White",h:"#2B2B2C",s:25},{c:"RAL 9005",n:"Jet black",f:"Black & White",h:"#0E0E10",s:25},{c:"RAL 9010",n:"Pure white",f:"Black & White",h:"#F1EDE1",s:10},{c:"RAL 9011",n:"Graphite black",f:"Black & White",h:"#27292B",s:25},{c:"RAL 9012",n:"Cleanroom white",f:"Black & White",h:"#F8F2E1",s:10},{c:"RAL 9016",n:"Traffic white",f:"Black & White",h:"#F1F1EA",s:10},{c:"RAL 9017",n:"Traffic black",f:"Black & White",h:"#29292A",s:25},{c:"RAL 9018",n:"Papyrus white",f:"Black & White",h:"#C8CBC4",s:10}
]

var COLOURS_NCS=[
{c:"S 0300-N",f:"Neutrals",h:"#F7F7F7",s:10},
{c:"S 0500-N",f:"Neutrals",h:"#F2F2F2",s:10},
{c:"S 0502-B",f:"Neutrals",h:"#EDEDF2",s:10},
{c:"S 0502-B50G",f:"Neutrals",h:"#EDF0F0",s:10},
{c:"S 0502-G",f:"Neutrals",h:"#EDF2ED",s:10},
{c:"S 0502-G50Y",f:"Neutrals",h:"#F0F2ED",s:10},
{c:"S 0502-R",f:"Neutrals",h:"#F2EDED",s:10},
{c:"S 0502-R50B",f:"Neutrals",h:"#F0EDF0",s:10},
{c:"S 0502-Y",f:"Neutrals",h:"#F2F2ED",s:10},
{c:"S 0502-Y20R",f:"Neutrals",h:"#F2F1ED",s:10},
{c:"S 0502-Y50R",f:"Neutrals",h:"#F2F0ED",s:10},
{c:"S 0502-Y80R",f:"Neutrals",h:"#F2EEED",s:10},
{c:"S 0505-B",f:"Neutrals",h:"#E5E5F2",s:10},
{c:"S 0505-B20G",f:"Neutrals",h:"#E5E8F0",s:10},
{c:"S 0505-B50G",f:"Neutrals",h:"#E5ECEC",s:10},
{c:"S 0505-B80G",f:"Neutrals",h:"#E5F0E8",s:10},
{c:"S 0505-G",f:"Neutrals",h:"#E5F2E5",s:10},
{c:"S 0505-G10Y",f:"Neutrals",h:"#E7F2E5",s:10},
{c:"S 0505-G20Y",f:"Neutrals",h:"#E8F2E5",s:10},
{c:"S 0505-G30Y",f:"Neutrals",h:"#E9F2E5",s:10},
{c:"S 0505-G40Y",f:"Neutrals",h:"#EBF2E5",s:10},
{c:"S 0505-G50Y",f:"Neutrals",h:"#ECF2E5",s:10},
{c:"S 0505-G60Y",f:"Neutrals",h:"#EDF2E5",s:10},
{c:"S 0505-G70Y",f:"Neutrals",h:"#EEF2E5",s:10},
{c:"S 0505-G80Y",f:"Neutrals",h:"#F0F2E5",s:10},
{c:"S 0505-G90Y",f:"Neutrals",h:"#F1F2E5",s:10},
{c:"S 0505-R",f:"Neutrals",h:"#F2E5E5",s:10},
{c:"S 0505-R10B",f:"Neutrals",h:"#F1E5E7",s:10},
{c:"S 0505-R20B",f:"Neutrals",h:"#F0E5E8",s:10},
{c:"S 0505-R30B",f:"Neutrals",h:"#EEE5E9",s:10},
{c:"S 0505-R40B",f:"Neutrals",h:"#EDE5EB",s:10},
{c:"S 0505-R50B",f:"Neutrals",h:"#ECE5EC",s:10},
{c:"S 0505-R60B",f:"Neutrals",h:"#EBE5ED",s:10},
{c:"S 0505-R70B",f:"Neutrals",h:"#E9E5EE",s:10},
{c:"S 0505-R80B",f:"Neutrals",h:"#E8E5F0",s:10},
{c:"S 0505-R90B",f:"Neutrals",h:"#E7E5F1",s:10},
{c:"S 0505-Y",f:"Neutrals",h:"#F2F2E5",s:10},
{c:"S 0505-Y10R",f:"Neutrals",h:"#F2F1E5",s:10},
{c:"S 0505-Y20R",f:"Neutrals",h:"#F2F0E5",s:10},
{c:"S 0505-Y30R",f:"Neutrals",h:"#F2EEE5",s:10},
{c:"S 0505-Y40R",f:"Neutrals",h:"#F2EDE5",s:10},
{c:"S 0505-Y50R",f:"Neutrals",h:"#F2ECE5",s:10},
{c:"S 0505-Y60R",f:"Neutrals",h:"#F2EBE5",s:10},
{c:"S 0505-Y70R",f:"Neutrals",h:"#F2E9E5",s:10},
{c:"S 0505-Y80R",f:"Neutrals",h:"#F2E8E5",s:10},
{c:"S 0505-Y90R",f:"Neutrals",h:"#F2E7E5",s:10},
{c:"S 0507-B",f:"Neutrals",h:"#E0E0F2",s:10},
{c:"S 0507-B20G",f:"Neutrals",h:"#E0E4EF",s:10},
{c:"S 0507-B80G",f:"Neutrals",h:"#E0EFE4",s:10},
{c:"S 0507-G",f:"Neutrals",h:"#E0F2E0",s:10},
{c:"S 0507-G40Y",f:"Neutrals",h:"#E8F2E0",s:10},
{c:"S 0507-G80Y",f:"Neutrals",h:"#EFF2E0",s:10},
{c:"S 0507-R",f:"Neutrals",h:"#F2E0E0",s:10},
{c:"S 0507-R20B",f:"Neutrals",h:"#EFE0E4",s:10},
{c:"S 0507-R40B",f:"Neutrals",h:"#EBE0E8",s:10},
{c:"S 0507-R60B",f:"Neutrals",h:"#E8E0EB",s:10},
{c:"S 0507-R80B",f:"Neutrals",h:"#E4E0EF",s:10},
{c:"S 0507-Y",f:"Neutrals",h:"#F2F2E0",s:10},
{c:"S 0507-Y20R",f:"Neutrals",h:"#F2EFE0",s:10},
{c:"S 0507-Y40R",f:"Neutrals",h:"#F2EBE0",s:10},
{c:"S 0507-Y60R",f:"Neutrals",h:"#F2E8E0",s:10},
{c:"S 0507-Y80R",f:"Neutrals",h:"#F2E4E0",s:10},
{c:"S 0510-B",f:"Neutrals",h:"#D9D9F2",s:10},
{c:"S 0510-B10G",f:"Neutrals",h:"#D9DBF0",s:10},
{c:"S 0510-B30G",f:"Neutrals",h:"#D9E0EB",s:10},
{c:"S 0510-B50G",f:"Neutrals",h:"#D9E6E6",s:10},
{c:"S 0510-B70G",f:"Neutrals",h:"#D9EBE0",s:10},
{c:"S 0510-B90G",f:"Neutrals",h:"#D9F0DB",s:10},
{c:"S 0510-G",f:"Neutrals",h:"#D9F2D9",s:10},
{c:"S 0510-G10Y",f:"Neutrals",h:"#DBF2D9",s:10},
{c:"S 0510-G20Y",f:"Neutrals",h:"#DEF2D9",s:10},
{c:"S 0510-G30Y",f:"Neutrals",h:"#E0F2D9",s:10},
{c:"S 0510-G40Y",f:"Neutrals",h:"#E3F2D9",s:10},
{c:"S 0510-G50Y",f:"Neutrals",h:"#E6F2D9",s:10},
{c:"S 0510-G60Y",f:"Neutrals",h:"#E8F2D9",s:10},
{c:"S 0510-G70Y",f:"Neutrals",h:"#EBF2D9",s:10},
{c:"S 0510-G80Y",f:"Neutrals",h:"#EDF2D9",s:10},
{c:"S 0510-G90Y",f:"Neutrals",h:"#F0F2D9",s:10},
{c:"S 0510-R",f:"Neutrals",h:"#F2D9D9",s:10},
{c:"S 0510-R10B",f:"Neutrals",h:"#F0D9DB",s:10},
{c:"S 0510-R20B",f:"Neutrals",h:"#EDD9DE",s:10},
{c:"S 0510-R30B",f:"Neutrals",h:"#EBD9E0",s:10},
{c:"S 0510-R40B",f:"Neutrals",h:"#E8D9E3",s:10},
{c:"S 0510-R50B",f:"Neutrals",h:"#E6D9E6",s:10},
{c:"S 0510-R60B",f:"Neutrals",h:"#E3D9E8",s:10},
{c:"S 0510-R70B",f:"Neutrals",h:"#E0D9EB",s:10},
{c:"S 0510-R80B",f:"Neutrals",h:"#DED9ED",s:10},
{c:"S 0510-R90B",f:"Neutrals",h:"#DBD9F0",s:10},
{c:"S 0510-Y",f:"Neutrals",h:"#F2F2D9",s:10},
{c:"S 0510-Y10R",f:"Neutrals",h:"#F2F0D9",s:10},
{c:"S 0510-Y20R",f:"Neutrals",h:"#F2EDD9",s:10},
{c:"S 0510-Y30R",f:"Neutrals",h:"#F2EBD9",s:10},
{c:"S 0510-Y40R",f:"Neutrals",h:"#F2E8D9",s:10},
{c:"S 0510-Y50R",f:"Neutrals",h:"#F2E6D9",s:10},
{c:"S 0510-Y60R",f:"Neutrals",h:"#F2E3D9",s:10},
{c:"S 0510-Y70R",f:"Neutrals",h:"#F2E0D9",s:10},
{c:"S 0510-Y80R",f:"Neutrals",h:"#F2DED9",s:10},
{c:"S 0510-Y90R",f:"Neutrals",h:"#F2DBD9",s:10},
{c:"S 0515-B",f:"Blues",h:"#CCCCF2",s:10},
{c:"S 0515-B20G",f:"Blues",h:"#CCD4EB",s:10},
{c:"S 0515-B50G",f:"Blues",h:"#CCDFDF",s:10},
{c:"S 0515-B80G",f:"Greens",h:"#CCEBD4",s:10},
{c:"S 0515-G",f:"Greens",h:"#CCF2CC",s:10},
{c:"S 0515-G20Y",f:"Greens",h:"#D4F2CC",s:10},
{c:"S 0515-G40Y",f:"Greens",h:"#DBF2CC",s:10},
{c:"S 0515-G60Y",f:"Greens",h:"#E3F2CC",s:10},
{c:"S 0515-G80Y",f:"Yellows",h:"#EBF2CC",s:10},
{c:"S 0515-G90Y",f:"Yellows",h:"#EEF2CC",s:10},
{c:"S 0515-R",f:"Reds",h:"#F2CCCC",s:10},
{c:"S 0515-R10B",f:"Reds",h:"#EECCD0",s:10},
{c:"S 0515-R20B",f:"Reds",h:"#EBCCD4",s:10},
{c:"S 0515-R40B",f:"Reds",h:"#E3CCDB",s:10},
{c:"S 0515-R60B",f:"Reds",h:"#DBCCE3",s:10},
{c:"S 0515-R80B",f:"Blues",h:"#D4CCEB",s:10},
{c:"S 0515-R90B",f:"Blues",h:"#D0CCEE",s:10},
{c:"S 0515-Y",f:"Yellows",h:"#F2F2CC",s:10},
{c:"S 0515-Y10R",f:"Yellows",h:"#F2EECC",s:10},
{c:"S 0515-Y20R",f:"Yellows",h:"#F2EBCC",s:10},
{c:"S 0515-Y30R",f:"Yellows",h:"#F2E7CC",s:10},
{c:"S 0515-Y40R",f:"Yellows",h:"#F2E3CC",s:10},
{c:"S 0515-Y50R",f:"Yellows",h:"#F2DFCC",s:10},
{c:"S 0515-Y60R",f:"Yellows",h:"#F2DBCC",s:10},
{c:"S 0515-Y70R",f:"Yellows",h:"#F2D7CC",s:10},
{c:"S 0515-Y80R",f:"Reds",h:"#F2D4CC",s:10},
{c:"S 0515-Y90R",f:"Reds",h:"#F2D0CC",s:10},
{c:"S 0520-B",f:"Blues",h:"#BFBFF2",s:10},
{c:"S 0520-B10G",f:"Blues",h:"#BFC4ED",s:10},
{c:"S 0520-B30G",f:"Blues",h:"#BFCFE3",s:10},
{c:"S 0520-B40G",f:"Blues",h:"#BFD4DE",s:10},
{c:"S 0520-B50G",f:"Blues",h:"#BFD9D9",s:10},
{c:"S 0520-B60G",f:"Blues",h:"#BFDED4",s:10},
{c:"S 0520-B70G",f:"Blues",h:"#BFE3CF",s:10},
{c:"S 0520-B90G",f:"Greens",h:"#BFEDC4",s:10},
{c:"S 0520-G",f:"Greens",h:"#BFF2BF",s:10},
{c:"S 0520-G10Y",f:"Greens",h:"#C4F2BF",s:10},
{c:"S 0520-G20Y",f:"Greens",h:"#C9F2BF",s:10},
{c:"S 0520-G30Y",f:"Greens",h:"#CFF2BF",s:10},
{c:"S 0520-G40Y",f:"Greens",h:"#D4F2BF",s:10},
{c:"S 0520-G50Y",f:"Greens",h:"#D9F2BF",s:10},
{c:"S 0520-G60Y",f:"Greens",h:"#DEF2BF",s:10},
{c:"S 0520-G70Y",f:"Greens",h:"#E3F2BF",s:10},
{c:"S 0520-G80Y",f:"Yellows",h:"#E8F2BF",s:10},
{c:"S 0520-G90Y",f:"Yellows",h:"#EDF2BF",s:10},
{c:"S 0520-R",f:"Reds",h:"#F2BFBF",s:10},
{c:"S 0520-R10B",f:"Reds",h:"#EDBFC4",s:10},
{c:"S 0520-R20B",f:"Reds",h:"#E8BFC9",s:10},
{c:"S 0520-R30B",f:"Reds",h:"#E3BFCF",s:10},
{c:"S 0520-R40B",f:"Reds",h:"#DEBFD4",s:10},
{c:"S 0520-R50B",f:"Reds",h:"#D9BFD9",s:10},
{c:"S 0520-R60B",f:"Reds",h:"#D4BFDE",s:10},
{c:"S 0520-R70B",f:"Reds",h:"#CFBFE3",s:10},
{c:"S 0520-R80B",f:"Blues",h:"#C9BFE8",s:10},
{c:"S 0520-R90B",f:"Blues",h:"#C4BFED",s:10},
{c:"S 0520-Y",f:"Yellows",h:"#F2F2BF",s:10},
{c:"S 0520-Y10R",f:"Yellows",h:"#F2EDBF",s:10},
{c:"S 0520-Y20R",f:"Yellows",h:"#F2E8BF",s:10},
{c:"S 0520-Y30R",f:"Yellows",h:"#F2E3BF",s:10},
{c:"S 0520-Y40R",f:"Yellows",h:"#F2DEBF",s:10},
{c:"S 0520-Y50R",f:"Yellows",h:"#F2D9BF",s:10},
{c:"S 0520-Y60R",f:"Yellows",h:"#F2D4BF",s:10},
{c:"S 0520-Y70R",f:"Yellows",h:"#F2CFBF",s:10},
{c:"S 0520-Y80R",f:"Reds",h:"#F2C9BF",s:10},
{c:"S 0520-Y90R",f:"Reds",h:"#F2C4BF",s:10},
{c:"S 0525-R60B",f:"Reds",h:"#CCB2D9",s:10},
{c:"S 0525-R70B",f:"Reds",h:"#C6B2DF",s:10},
{c:"S 0530-B",f:"Blues",h:"#A6A6F2",s:10},
{c:"S 0530-B10G",f:"Blues",h:"#A6ADEB",s:10},
{c:"S 0530-B30G",f:"Blues",h:"#A6BDDB",s:10},
{c:"S 0530-B40G",f:"Blues",h:"#A6C4D4",s:10},
{c:"S 0530-B50G",f:"Blues",h:"#A6CCCC",s:10},
{c:"S 0530-B60G",f:"Blues",h:"#A6D4C4",s:10},
{c:"S 0530-B70G",f:"Blues",h:"#A6DBBD",s:10},
{c:"S 0530-B90G",f:"Greens",h:"#A6EBAD",s:10},
{c:"S 0530-G",f:"Greens",h:"#A6F2A6",s:10},
{c:"S 0530-G10Y",f:"Greens",h:"#ADF2A6",s:10},
{c:"S 0530-G20Y",f:"Greens",h:"#B5F2A6",s:10},
{c:"S 0530-G30Y",f:"Greens",h:"#BDF2A6",s:10},
{c:"S 0530-G40Y",f:"Greens",h:"#C4F2A6",s:10},
{c:"S 0530-G50Y",f:"Greens",h:"#CCF2A6",s:10},
{c:"S 0530-G60Y",f:"Greens",h:"#D4F2A6",s:10},
{c:"S 0530-G70Y",f:"Greens",h:"#DBF2A6",s:10},
{c:"S 0530-G80Y",f:"Yellows",h:"#E3F2A6",s:10},
{c:"S 0530-G90Y",f:"Yellows",h:"#EBF2A6",s:10},
{c:"S 0530-R",f:"Reds",h:"#F2A6A6",s:10},
{c:"S 0530-R10B",f:"Reds",h:"#EBA6AD",s:10},
{c:"S 0530-R20B",f:"Reds",h:"#E3A6B5",s:10},
{c:"S 0530-R30B",f:"Reds",h:"#DBA6BD",s:10},
{c:"S 0530-R40B",f:"Reds",h:"#D4A6C4",s:10},
{c:"S 0530-R50B",f:"Reds",h:"#CCA6CC",s:10},
{c:"S 0530-R80B",f:"Blues",h:"#B5A6E3",s:10},
{c:"S 0530-R90B",f:"Blues",h:"#ADA6EB",s:10},
{c:"S 0530-Y",f:"Yellows",h:"#F2F2A6",s:10},
{c:"S 0530-Y10R",f:"Yellows",h:"#F2EBA6",s:10},
{c:"S 0530-Y20R",f:"Yellows",h:"#F2E3A6",s:25},
{c:"S 0530-Y30R",f:"Yellows",h:"#F2DBA6",s:10},
{c:"S 0530-Y40R",f:"Yellows",h:"#F2D4A6",s:25},
{c:"S 0530-Y50R",f:"Yellows",h:"#F2CCA6",s:25},
{c:"S 0530-Y60R",f:"Yellows",h:"#F2C4A6",s:25},
{c:"S 0530-Y70R",f:"Yellows",h:"#F2BDA6",s:25},
{c:"S 0530-Y80R",f:"Reds",h:"#F2B5A6",s:25},
{c:"S 0530-Y90R",f:"Reds",h:"#F2ADA6",s:10},
{c:"S 0540-B",f:"Blues",h:"#8C8CF2",s:10},
{c:"S 0540-B10G",f:"Blues",h:"#8C96E8",s:10},
{c:"S 0540-B30G",f:"Blues",h:"#8CABD4",s:10},
{c:"S 0540-G",f:"Greens",h:"#8CF28C",s:10},
{c:"S 0540-G10Y",f:"Greens",h:"#96F28C",s:10},
{c:"S 0540-G20Y",f:"Greens",h:"#A1F28C",s:25},
{c:"S 0540-G30Y",f:"Greens",h:"#ABF28C",s:25},
{c:"S 0540-G40Y",f:"Greens",h:"#B5F28C",s:25},
{c:"S 0540-G50Y",f:"Greens",h:"#BFF28C",s:25},
{c:"S 0540-G60Y",f:"Greens",h:"#C9F28C",s:25},
{c:"S 0540-G70Y",f:"Greens",h:"#D4F28C",s:10},
{c:"S 0540-G80Y",f:"Yellows",h:"#DEF28C",s:25},
{c:"S 0540-G90Y",f:"Yellows",h:"#E8F28C",s:25},
{c:"S 0540-R",f:"Reds",h:"#F28C8C",s:25},
{c:"S 0540-R10B",f:"Reds",h:"#E88C96",s:10},
{c:"S 0540-R20B",f:"Reds",h:"#DE8CA1",s:25},
{c:"S 0540-R30B",f:"Reds",h:"#D48CAB",s:10},
{c:"S 0540-R90B",f:"Blues",h:"#968CE8",s:10},
{c:"S 0540-Y",f:"Yellows",h:"#F2F28C",s:25},
{c:"S 0540-Y10R",f:"Yellows",h:"#F2E88C",s:25},
{c:"S 0540-Y20R",f:"Yellows",h:"#F2DE8C",s:25},
{c:"S 0540-Y30R",f:"Yellows",h:"#F2D48C",s:25},
{c:"S 0540-Y40R",f:"Yellows",h:"#F2C98C",s:25},
{c:"S 0540-Y50R",f:"Yellows",h:"#F2BF8C",s:25},
{c:"S 0540-Y60R",f:"Yellows",h:"#F2B58C",s:25},
{c:"S 0540-Y70R",f:"Yellows",h:"#F2AB8C",s:45},
{c:"S 0540-Y80R",f:"Reds",h:"#F2A18C",s:45},
{c:"S 0540-Y90R",f:"Reds",h:"#F2968C",s:45},
{c:"S 0550-G10Y",f:"Greens",h:"#7FF273",s:25},
{c:"S 0550-G20Y",f:"Greens",h:"#8CF273",s:25},
{c:"S 0550-G30Y",f:"Greens",h:"#99F273",s:25},
{c:"S 0550-G40Y",f:"Greens",h:"#A6F273",s:25},
{c:"S 0550-G50Y",f:"Greens",h:"#B2F273",s:25},
{c:"S 0550-G60Y",f:"Greens",h:"#BFF273",s:25},
{c:"S 0550-G70Y",f:"Greens",h:"#CCF273",s:25},
{c:"S 0550-G80Y",f:"Yellows",h:"#D9F273",s:25},
{c:"S 0550-G90Y",f:"Yellows",h:"#E5F273",s:25},
{c:"S 0550-R",f:"Reds",h:"#F27373",s:25},
{c:"S 0550-R10B",f:"Reds",h:"#E5737F",s:25},
{c:"S 0550-Y",f:"Yellows",h:"#F2F273",s:25},
{c:"S 0550-Y10R",f:"Yellows",h:"#F2E573",s:25},
{c:"S 0550-Y20R",f:"Yellows",h:"#F2D973",s:25},
{c:"S 0550-Y30R",f:"Yellows",h:"#F2CC73",s:25},
{c:"S 0550-Y40R",f:"Yellows",h:"#F2BF73",s:45},
{c:"S 0550-Y50R",f:"Yellows",h:"#F2B273",s:25},
{c:"S 0550-Y60R",f:"Yellows",h:"#F2A673",s:25},
{c:"S 0550-Y70R",f:"Yellows",h:"#F29973",s:45},
{c:"S 0550-Y80R",f:"Reds",h:"#F28C73",s:25},
{c:"S 0550-Y90R",f:"Reds",h:"#F27F73",s:25},
{c:"S 0560-G10Y",f:"High chroma accents",h:"#69F259",s:25},
{c:"S 0560-G20Y",f:"High chroma accents",h:"#78F259",s:25},
{c:"S 0560-G30Y",f:"High chroma accents",h:"#87F259",s:25},
{c:"S 0560-G40Y",f:"High chroma accents",h:"#96F259",s:25},
{c:"S 0560-G50Y",f:"High chroma accents",h:"#A6F259",s:25},
{c:"S 0560-G60Y",f:"High chroma accents",h:"#B5F259",s:25},
{c:"S 0560-G70Y",f:"High chroma accents",h:"#C4F259",s:25},
{c:"S 0560-G80Y",f:"High chroma accents",h:"#D4F259",s:25},
{c:"S 0560-G90Y",f:"High chroma accents",h:"#E3F259",s:25},
{c:"S 0560-R",f:"High chroma accents",h:"#F25959",s:25},
{c:"S 0560-Y",f:"High chroma accents",h:"#F2F259",s:25},
{c:"S 0560-Y10R",f:"High chroma accents",h:"#F2E359",s:25},
{c:"S 0560-Y20R",f:"High chroma accents",h:"#F2D459",s:25},
{c:"S 0560-Y30R",f:"High chroma accents",h:"#F2C459",s:25},
{c:"S 0560-Y40R",f:"High chroma accents",h:"#F2B559",s:45},
{c:"S 0560-Y50R",f:"High chroma accents",h:"#F2A659",s:45},
{c:"S 0560-Y60R",f:"High chroma accents",h:"#F29659",s:25},
{c:"S 0560-Y70R",f:"High chroma accents",h:"#F28759",s:45},
{c:"S 0560-Y80R",f:"High chroma accents",h:"#F27859",s:45},
{c:"S 0560-Y90R",f:"High chroma accents",h:"#F26959",s:45},
{c:"S 0565-G10Y",f:"High chroma accents",h:"#5DF24C",s:25},
{c:"S 0565-G50Y",f:"High chroma accents",h:"#9FF24C",s:45},
{c:"S 0565-R",f:"High chroma accents",h:"#F24C4C",s:45},
{c:"S 0570-G20Y",f:"High chroma accents",h:"#63F240",s:25},
{c:"S 0570-G30Y",f:"High chroma accents",h:"#75F240",s:25},
{c:"S 0570-G40Y",f:"High chroma accents",h:"#87F240",s:45},
{c:"S 0570-G60Y",f:"High chroma accents",h:"#ABF240",s:25},
{c:"S 0570-G70Y",f:"High chroma accents",h:"#BDF240",s:45},
{c:"S 0570-G80Y",f:"High chroma accents",h:"#CFF240",s:45},
{c:"S 0570-G90Y",f:"High chroma accents",h:"#E0F240",s:25},
{c:"S 0570-Y",f:"High chroma accents",h:"#F2F240",s:45},
{c:"S 0570-Y10R",f:"High chroma accents",h:"#F2E040",s:45},
{c:"S 0570-Y20R",f:"High chroma accents",h:"#F2CF40",s:25},
{c:"S 0570-Y30R",f:"High chroma accents",h:"#F2BD40",s:45},
{c:"S 0570-Y40R",f:"High chroma accents",h:"#F2AB40",s:45},
{c:"S 0570-Y50R",f:"High chroma accents",h:"#F29940",s:45},
{c:"S 0570-Y60R",f:"High chroma accents",h:"#F28740",s:45},
{c:"S 0570-Y70R",f:"High chroma accents",h:"#F27540",s:45},
{c:"S 0570-Y80R",f:"High chroma accents",h:"#F26340",s:45},
{c:"S 0570-Y90R",f:"High chroma accents",h:"#F25240",s:45},
{c:"S 0575-G20Y",f:"High chroma accents",h:"#59F233",s:45},
{c:"S 0575-G40Y",f:"High chroma accents",h:"#80F233",s:45},
{c:"S 0575-G60Y",f:"High chroma accents",h:"#A6F233",s:45},
{c:"S 0575-G70Y",f:"High chroma accents",h:"#B9F233",s:45},
{c:"S 0575-G90Y",f:"High chroma accents",h:"#DFF233",s:45},
{c:"S 0580-G30Y",f:"High chroma accents",h:"#63F226",s:45},
{c:"S 0580-Y",f:"High chroma accents",h:"#F2F226",s:45},
{c:"S 0580-Y10R",f:"High chroma accents",h:"#F2DE26",s:45},
{c:"S 0580-Y20R",f:"High chroma accents",h:"#F2C926",s:45},
{c:"S 0580-Y30R",f:"High chroma accents",h:"#F2B526",s:45},
{c:"S 0580-Y40R",f:"High chroma accents",h:"#F2A126",s:45},
{c:"S 0580-Y50R",f:"High chroma accents",h:"#F28C26",s:45},
{c:"S 0580-Y60R",f:"High chroma accents",h:"#F27826",s:45},
{c:"S 0580-Y70R",f:"High chroma accents",h:"#F26326",s:45},
{c:"S 0580-Y80R",f:"High chroma accents",h:"#F24F26",s:45},
{c:"S 0580-Y90R",f:"High chroma accents",h:"#F23B26",s:45},
{c:"S 0585-Y20R",f:"High chroma accents",h:"#F2C719",s:45},
{c:"S 0585-Y30R",f:"High chroma accents",h:"#F2B119",s:45},
{c:"S 0585-Y40R",f:"High chroma accents",h:"#F29C19",s:45},
{c:"S 0585-Y50R",f:"High chroma accents",h:"#F28619",s:45},
{c:"S 0585-Y60R",f:"High chroma accents",h:"#F27019",s:45},
{c:"S 0585-Y70R",f:"High chroma accents",h:"#F25B19",s:45},
{c:"S 0585-Y80R",f:"High chroma accents",h:"#F24519",s:45},
{c:"S 0601-B",f:"Neutrals",h:"#EDEDF0",s:10},
{c:"S 0601-G",f:"Neutrals",h:"#EDF0ED",s:10},
{c:"S 0601-R",f:"Neutrals",h:"#F0EDED",s:10},
{c:"S 0601-Y",f:"Neutrals",h:"#F0F0ED",s:10},
{c:"S 0603-G40Y",f:"Neutrals",h:"#EBF0E8",s:10},
{c:"S 0603-G80Y",f:"Neutrals",h:"#EEF0E8",s:10},
{c:"S 0603-R20B",f:"Neutrals",h:"#EEE8EA",s:10},
{c:"S 0603-R40B",f:"Neutrals",h:"#EDE8EB",s:10},
{c:"S 0603-R60B",f:"Neutrals",h:"#EBE8ED",s:10},
{c:"S 0603-R80B",f:"Neutrals",h:"#EAE8EE",s:10},
{c:"S 0603-Y20R",f:"Neutrals",h:"#F0EEE8",s:10},
{c:"S 0603-Y40R",f:"Neutrals",h:"#F0EDE8",s:10},
{c:"S 0603-Y60R",f:"Neutrals",h:"#F0EBE8",s:10},
{c:"S 0603-Y80R",f:"Neutrals",h:"#F0EAE8",s:10},
{c:"S 0804-B50G",f:"Neutrals",h:"#E0E6E6",s:10},
{c:"S 0804-G20Y",f:"Neutrals",h:"#E2EBE0",s:10},
{c:"S 0804-G60Y",f:"Neutrals",h:"#E7EBE0",s:10},
{c:"S 0804-G90Y",f:"Neutrals",h:"#EAEBE0",s:10},
{c:"S 0804-R10B",f:"Neutrals",h:"#EAE0E1",s:10},
{c:"S 0804-R30B",f:"Neutrals",h:"#E8E0E3",s:10},
{c:"S 0804-R50B",f:"Neutrals",h:"#E6E0E6",s:10},
{c:"S 0804-R70B",f:"Neutrals",h:"#E3E0E8",s:10},
{c:"S 0804-R90B",f:"Neutrals",h:"#E1E0EA",s:10},
{c:"S 0804-Y10R",f:"Neutrals",h:"#EBEAE0",s:10},
{c:"S 0804-Y30R",f:"Neutrals",h:"#EBE8E0",s:10},
{c:"S 0804-Y50R",f:"Neutrals",h:"#EBE6E0",s:10},
{c:"S 0804-Y70R",f:"Neutrals",h:"#EBE3E0",s:10},
{c:"S 0804-Y90R",f:"Neutrals",h:"#EBE1E0",s:10},
{c:"S 0907-B20G",f:"Neutrals",h:"#D6DAE4",s:10},
{c:"S 0907-B80G",f:"Neutrals",h:"#D6E4DA",s:10},
{c:"S 0907-G20Y",f:"Neutrals",h:"#DAE8D6",s:10},
{c:"S 0907-G60Y",f:"Neutrals",h:"#E1E8D6",s:10},
{c:"S 0907-G90Y",f:"Neutrals",h:"#E6E8D6",s:10},
{c:"S 0907-R10B",f:"Neutrals",h:"#E6D6D8",s:10},
{c:"S 0907-R30B",f:"Neutrals",h:"#E3D6DC",s:10},
{c:"S 0907-R50B",f:"Neutrals",h:"#DFD6DF",s:10},
{c:"S 0907-R70B",f:"Neutrals",h:"#DCD6E3",s:10},
{c:"S 0907-R90B",f:"Neutrals",h:"#D8D6E6",s:10},
{c:"S 0907-Y10R",f:"Neutrals",h:"#E8E6D6",s:10},
{c:"S 0907-Y30R",f:"Neutrals",h:"#E8E3D6",s:10},
{c:"S 0907-Y50R",f:"Neutrals",h:"#E8DFD6",s:10},
{c:"S 0907-Y70R",f:"Neutrals",h:"#E8DCD6",s:10},
{c:"S 0907-Y90R",f:"Neutrals",h:"#E8D8D6",s:10},
{c:"S 1000-N",f:"Neutrals",h:"#E6E6E6",s:10},
{c:"S 1001-B",f:"Neutrals",h:"#E3E3E6",s:10},
{c:"S 1001-G",f:"Neutrals",h:"#E3E6E3",s:10},
{c:"S 1001-R",f:"Neutrals",h:"#E6E3E3",s:10},
{c:"S 1001-Y",f:"Neutrals",h:"#E6E6E3",s:10},
{c:"S 1002-B",f:"Neutrals",h:"#E0E0E6",s:10},
{c:"S 1002-B50G",f:"Neutrals",h:"#E0E3E3",s:10},
{c:"S 1002-G",f:"Neutrals",h:"#E0E6E0",s:10},
{c:"S 1002-G50Y",f:"Neutrals",h:"#E3E6E0",s:10},
{c:"S 1002-R",f:"Neutrals",h:"#E6E0E0",s:10},
{c:"S 1002-R50B",f:"Neutrals",h:"#E3E0E3",s:10},
{c:"S 1002-Y",f:"Neutrals",h:"#E6E6E0",s:10},
{c:"S 1002-Y20R",f:"Neutrals",h:"#E6E4E0",s:10},
{c:"S 1002-Y50R",f:"Neutrals",h:"#E6E3E0",s:10},
{c:"S 1002-Y80R",f:"Neutrals",h:"#E6E1E0",s:10},
{c:"S 1005-B",f:"Neutrals",h:"#D9D9E6",s:10},
{c:"S 1005-B20G",f:"Neutrals",h:"#D9DBE3",s:10},
{c:"S 1005-B50G",f:"Neutrals",h:"#D9DFDF",s:10},
{c:"S 1005-B80G",f:"Neutrals",h:"#D9E3DB",s:10},
{c:"S 1005-G",f:"Neutrals",h:"#D9E6D9",s:10},
{c:"S 1005-G10Y",f:"Neutrals",h:"#DAE6D9",s:10},
{c:"S 1005-G20Y",f:"Neutrals",h:"#DBE6D9",s:10},
{c:"S 1005-G30Y",f:"Neutrals",h:"#DDE6D9",s:10},
{c:"S 1005-G40Y",f:"Neutrals",h:"#DEE6D9",s:10},
{c:"S 1005-G50Y",f:"Neutrals",h:"#DFE6D9",s:10},
{c:"S 1005-G60Y",f:"Neutrals",h:"#E0E6D9",s:10},
{c:"S 1005-G70Y",f:"Neutrals",h:"#E2E6D9",s:10},
{c:"S 1005-G80Y",f:"Neutrals",h:"#E3E6D9",s:10},
{c:"S 1005-G90Y",f:"Neutrals",h:"#E4E6D9",s:10},
{c:"S 1005-R",f:"Neutrals",h:"#E6D9D9",s:10},
{c:"S 1005-R10B",f:"Neutrals",h:"#E4D9DA",s:10},
{c:"S 1005-R20B",f:"Neutrals",h:"#E3D9DB",s:10},
{c:"S 1005-R30B",f:"Neutrals",h:"#E2D9DD",s:10},
{c:"S 1005-R40B",f:"Neutrals",h:"#E0D9DE",s:10},
{c:"S 1005-R50B",f:"Neutrals",h:"#DFD9DF",s:10},
{c:"S 1005-R60B",f:"Neutrals",h:"#DED9E0",s:10},
{c:"S 1005-R70B",f:"Neutrals",h:"#DDD9E2",s:10},
{c:"S 1005-R80B",f:"Neutrals",h:"#DBD9E3",s:10},
{c:"S 1005-R90B",f:"Neutrals",h:"#DAD9E4",s:10},
{c:"S 1005-Y",f:"Neutrals",h:"#E6E6D9",s:10},
{c:"S 1005-Y10R",f:"Neutrals",h:"#E6E4D9",s:10},
{c:"S 1005-Y20R",f:"Neutrals",h:"#E6E3D9",s:10},
{c:"S 1005-Y30R",f:"Neutrals",h:"#E6E2D9",s:10},
{c:"S 1005-Y40R",f:"Neutrals",h:"#E6E0D9",s:10},
{c:"S 1005-Y50R",f:"Neutrals",h:"#E6DFD9",s:10},
{c:"S 1005-Y60R",f:"Neutrals",h:"#E6DED9",s:10},
{c:"S 1005-Y70R",f:"Neutrals",h:"#E6DDD9",s:10},
{c:"S 1005-Y80R",f:"Neutrals",h:"#E6DBD9",s:10},
{c:"S 1005-Y90R",f:"Neutrals",h:"#E6DAD9",s:10},
{c:"S 1010-B",f:"Neutrals",h:"#CCCCE6",s:10},
{c:"S 1010-B10G",f:"Neutrals",h:"#CCCFE3",s:10},
{c:"S 1010-B30G",f:"Neutrals",h:"#CCD4DE",s:10},
{c:"S 1010-B50G",f:"Neutrals",h:"#CCD9D9",s:10},
{c:"S 1010-B70G",f:"Neutrals",h:"#CCDED4",s:10},
{c:"S 1010-B90G",f:"Neutrals",h:"#CCE3CF",s:10},
{c:"S 1010-G",f:"Neutrals",h:"#CCE6CC",s:10},
{c:"S 1010-G10Y",f:"Neutrals",h:"#CFE6CC",s:10},
{c:"S 1010-G20Y",f:"Neutrals",h:"#D1E6CC",s:10},
{c:"S 1010-G30Y",f:"Neutrals",h:"#D4E6CC",s:10},
{c:"S 1010-G40Y",f:"Neutrals",h:"#D6E6CC",s:10},
{c:"S 1010-G50Y",f:"Neutrals",h:"#D9E6CC",s:10},
{c:"S 1010-G60Y",f:"Neutrals",h:"#DBE6CC",s:10},
{c:"S 1010-G70Y",f:"Neutrals",h:"#DEE6CC",s:10},
{c:"S 1010-G80Y",f:"Neutrals",h:"#E0E6CC",s:10},
{c:"S 1010-G90Y",f:"Neutrals",h:"#E3E6CC",s:10},
{c:"S 1010-R",f:"Neutrals",h:"#E6CCCC",s:10},
{c:"S 1010-R10B",f:"Neutrals",h:"#E3CCCF",s:10},
{c:"S 1010-R20B",f:"Neutrals",h:"#E0CCD1",s:10},
{c:"S 1010-R30B",f:"Neutrals",h:"#DECCD4",s:10},
{c:"S 1010-R40B",f:"Neutrals",h:"#DBCCD6",s:10},
{c:"S 1010-R50B",f:"Neutrals",h:"#D9CCD9",s:10},
{c:"S 1010-R60B",f:"Neutrals",h:"#D6CCDB",s:10},
{c:"S 1010-R70B",f:"Neutrals",h:"#D4CCDE",s:10},
{c:"S 1010-R80B",f:"Neutrals",h:"#D1CCE0",s:10},
{c:"S 1010-R90B",f:"Neutrals",h:"#CFCCE3",s:10},
{c:"S 1010-Y",f:"Neutrals",h:"#E6E6CC",s:10},
{c:"S 1010-Y10R",f:"Neutrals",h:"#E6E3CC",s:10},
{c:"S 1010-Y20R",f:"Neutrals",h:"#E6E0CC",s:10},
{c:"S 1010-Y30R",f:"Neutrals",h:"#E6DECC",s:10},
{c:"S 1010-Y40R",f:"Neutrals",h:"#E6DBCC",s:10},
{c:"S 1010-Y50R",f:"Neutrals",h:"#E6D9CC",s:10},
{c:"S 1010-Y60R",f:"Neutrals",h:"#E6D6CC",s:10},
{c:"S 1010-Y70R",f:"Neutrals",h:"#E6D4CC",s:10},
{c:"S 1010-Y80R",f:"Neutrals",h:"#E6D1CC",s:10},
{c:"S 1010-Y90R",f:"Neutrals",h:"#E6CFCC",s:10},
{c:"S 1015-B",f:"Blues",h:"#BFBFE6",s:10},
{c:"S 1015-B20G",f:"Blues",h:"#BFC7DE",s:10},
{c:"S 1015-B50G",f:"Blues",h:"#BFD2D2",s:10},
{c:"S 1015-B80G",f:"Greens",h:"#BFDEC7",s:10},
{c:"S 1015-G",f:"Greens",h:"#BFE6BF",s:10},
{c:"S 1015-G20Y",f:"Greens",h:"#C7E6BF",s:10},
{c:"S 1015-G40Y",f:"Greens",h:"#CFE6BF",s:10},
{c:"S 1015-G60Y",f:"Greens",h:"#D6E6BF",s:10},
{c:"S 1015-G80Y",f:"Yellows",h:"#DEE6BF",s:10},
{c:"S 1015-G90Y",f:"Yellows",h:"#E2E6BF",s:10},
{c:"S 1015-R",f:"Reds",h:"#E6BFBF",s:10},
{c:"S 1015-R10B",f:"Reds",h:"#E2BFC3",s:10},
{c:"S 1015-R20B",f:"Reds",h:"#DEBFC7",s:10},
{c:"S 1015-R40B",f:"Reds",h:"#D6BFCF",s:10},
{c:"S 1015-R60B",f:"Reds",h:"#CFBFD6",s:10},
{c:"S 1015-R80B",f:"Blues",h:"#C7BFDE",s:10},
{c:"S 1015-R90B",f:"Blues",h:"#C3BFE2",s:10},
{c:"S 1015-Y",f:"Yellows",h:"#E6E6BF",s:10},
{c:"S 1015-Y10R",f:"Yellows",h:"#E6E2BF",s:10},
{c:"S 1015-Y20R",f:"Yellows",h:"#E6DEBF",s:10},
{c:"S 1015-Y30R",f:"Yellows",h:"#E6DABF",s:10},
{c:"S 1015-Y40R",f:"Yellows",h:"#E6D6BF",s:10},
{c:"S 1015-Y50R",f:"Yellows",h:"#E6D2BF",s:10},
{c:"S 1015-Y60R",f:"Yellows",h:"#E6CFBF",s:10},
{c:"S 1015-Y70R",f:"Yellows",h:"#E6CBBF",s:10},
{c:"S 1015-Y80R",f:"Reds",h:"#E6C7BF",s:10},
{c:"S 1015-Y90R",f:"Reds",h:"#E6C3BF",s:10},
{c:"S 1020-B",f:"Blues",h:"#B2B2E5",s:10},
{c:"S 1020-B10G",f:"Blues",h:"#B2B8E0",s:10},
{c:"S 1020-B30G",f:"Blues",h:"#B2C2D6",s:10},
{c:"S 1020-B40G",f:"Blues",h:"#B2C7D1",s:10},
{c:"S 1020-B50G",f:"Blues",h:"#B2CCCC",s:10},
{c:"S 1020-B60G",f:"Blues",h:"#B2D1C7",s:10},
{c:"S 1020-B70G",f:"Blues",h:"#B2D6C2",s:10},
{c:"S 1020-B90G",f:"Greens",h:"#B2E0B8",s:10},
{c:"S 1020-G",f:"Greens",h:"#B2E5B2",s:10},
{c:"S 1020-G10Y",f:"Greens",h:"#B8E5B2",s:10},
{c:"S 1020-G20Y",f:"Greens",h:"#BDE5B2",s:10},
{c:"S 1020-G30Y",f:"Greens",h:"#C2E5B2",s:10},
{c:"S 1020-G40Y",f:"Greens",h:"#C7E5B2",s:10},
{c:"S 1020-G50Y",f:"Greens",h:"#CCE5B2",s:10},
{c:"S 1020-G60Y",f:"Greens",h:"#D1E5B2",s:10},
{c:"S 1020-G70Y",f:"Greens",h:"#D6E5B2",s:10},
{c:"S 1020-G80Y",f:"Yellows",h:"#DBE5B2",s:10},
{c:"S 1020-G90Y",f:"Yellows",h:"#E0E5B2",s:10},
{c:"S 1020-R",f:"Reds",h:"#E5B2B2",s:10},
{c:"S 1020-R10B",f:"Reds",h:"#E0B2B8",s:10},
{c:"S 1020-R20B",f:"Reds",h:"#DBB2BD",s:10},
{c:"S 1020-R30B",f:"Reds",h:"#D6B2C2",s:10},
{c:"S 1020-R40B",f:"Reds",h:"#D1B2C7",s:10},
{c:"S 1020-R50B",f:"Reds",h:"#CCB2CC",s:10},
{c:"S 1020-R60B",f:"Reds",h:"#C7B2D1",s:10},
{c:"S 1020-R70B",f:"Reds",h:"#C2B2D6",s:10},
{c:"S 1020-R80B",f:"Blues",h:"#BDB2DB",s:10},
{c:"S 1020-R90B",f:"Blues",h:"#B8B2E0",s:10},
{c:"S 1020-Y",f:"Yellows",h:"#E5E5B2",s:10},
{c:"S 1020-Y10R",f:"Yellows",h:"#E5E0B2",s:10},
{c:"S 1020-Y20R",f:"Yellows",h:"#E5DBB2",s:10},
{c:"S 1020-Y30R",f:"Yellows",h:"#E5D6B2",s:10},
{c:"S 1020-Y40R",f:"Yellows",h:"#E5D1B2",s:10},
{c:"S 1020-Y50R",f:"Yellows",h:"#E5CCB2",s:10},
{c:"S 1020-Y60R",f:"Yellows",h:"#E5C7B2",s:10},
{c:"S 1020-Y70R",f:"Yellows",h:"#E5C2B2",s:10},
{c:"S 1020-Y80R",f:"Reds",h:"#E5BDB2",s:10},
{c:"S 1020-Y90R",f:"Reds",h:"#E5B8B2",s:10},
{c:"S 1030-B",f:"Blues",h:"#9999E6",s:10},
{c:"S 1030-B10G",f:"Blues",h:"#99A1DE",s:10},
{c:"S 1030-B30G",f:"Blues",h:"#99B0CF",s:10},
{c:"S 1030-B40G",f:"Blues",h:"#99B8C7",s:10},
{c:"S 1030-B50G",f:"Blues",h:"#99BFBF",s:10},
{c:"S 1030-B60G",f:"Blues",h:"#99C7B8",s:10},
{c:"S 1030-B70G",f:"Blues",h:"#99CFB0",s:10},
{c:"S 1030-B90G",f:"Greens",h:"#99DEA1",s:10},
{c:"S 1030-G",f:"Greens",h:"#99E699",s:10},
{c:"S 1030-G10Y",f:"Greens",h:"#A1E699",s:25},
{c:"S 1030-G20Y",f:"Greens",h:"#A8E699",s:25},
{c:"S 1030-G30Y",f:"Greens",h:"#B0E699",s:25},
{c:"S 1030-G40Y",f:"Greens",h:"#B8E699",s:25},
{c:"S 1030-G50Y",f:"Greens",h:"#BFE699",s:25},
{c:"S 1030-G60Y",f:"Greens",h:"#C7E699",s:25},
{c:"S 1030-G70Y",f:"Greens",h:"#CFE699",s:25},
{c:"S 1030-G80Y",f:"Yellows",h:"#D6E699",s:25},
{c:"S 1030-G90Y",f:"Yellows",h:"#DEE699",s:25},
{c:"S 1030-R",f:"Reds",h:"#E69999",s:10},
{c:"S 1030-R10B",f:"Reds",h:"#DE99A1",s:10},
{c:"S 1030-R20B",f:"Reds",h:"#D699A8",s:10},
{c:"S 1030-R30B",f:"Reds",h:"#CF99B0",s:10},
{c:"S 1030-R40B",f:"Reds",h:"#C799B8",s:10},
{c:"S 1030-R50B",f:"Reds",h:"#BF99BF",s:10},
{c:"S 1030-R60B",f:"Reds",h:"#B899C7",s:10},
{c:"S 1030-R70B",f:"Reds",h:"#B099CF",s:10},
{c:"S 1030-R80B",f:"Blues",h:"#A899D6",s:10},
{c:"S 1030-R90B",f:"Blues",h:"#A199DE",s:10},
{c:"S 1030-Y",f:"Yellows",h:"#E6E699",s:25},
{c:"S 1030-Y10R",f:"Yellows",h:"#E6DE99",s:25},
{c:"S 1030-Y20R",f:"Yellows",h:"#E6D699",s:25},
{c:"S 1030-Y30R",f:"Yellows",h:"#E6CF99",s:25},
{c:"S 1030-Y40R",f:"Yellows",h:"#E6C799",s:25},
{c:"S 1030-Y50R",f:"Yellows",h:"#E6BF99",s:25},
{c:"S 1030-Y60R",f:"Yellows",h:"#E6B899",s:25},
{c:"S 1030-Y70R",f:"Yellows",h:"#E6B099",s:25},
{c:"S 1030-Y80R",f:"Reds",h:"#E6A899",s:25},
{c:"S 1030-Y90R",f:"Reds",h:"#E6A199",s:10},
{c:"S 1040-B",f:"Blues",h:"#8080E6",s:10},
{c:"S 1040-B10G",f:"Blues",h:"#808ADB",s:10},
{c:"S 1040-B20G",f:"Blues",h:"#8094D1",s:10},
{c:"S 1040-B30G",f:"Blues",h:"#809EC7",s:10},
{c:"S 1040-B40G",f:"Blues",h:"#80A8BD",s:25},
{c:"S 1040-B50G",f:"Blues",h:"#80B2B2",s:25},
{c:"S 1040-B60G",f:"Blues",h:"#80BDA8",s:25},
{c:"S 1040-B70G",f:"Blues",h:"#80C79E",s:25},
{c:"S 1040-B80G",f:"Greens",h:"#80D194",s:25},
{c:"S 1040-B90G",f:"Greens",h:"#80DB8A",s:25},
{c:"S 1040-G",f:"Greens",h:"#80E680",s:25},
{c:"S 1040-G10Y",f:"Greens",h:"#8AE680",s:25},
{c:"S 1040-G20Y",f:"Greens",h:"#94E680",s:25},
{c:"S 1040-G30Y",f:"Greens",h:"#9EE680",s:25},
{c:"S 1040-G40Y",f:"Greens",h:"#A8E680",s:25},
{c:"S 1040-G50Y",f:"Greens",h:"#B2E680",s:25},
{c:"S 1040-G60Y",f:"Greens",h:"#BDE680",s:25},
{c:"S 1040-G70Y",f:"Greens",h:"#C7E680",s:25},
{c:"S 1040-G80Y",f:"Yellows",h:"#D1E680",s:25},
{c:"S 1040-G90Y",f:"Yellows",h:"#DBE680",s:25},
{c:"S 1040-R",f:"Reds",h:"#E68080",s:25},
{c:"S 1040-R10B",f:"Reds",h:"#DB808A",s:25},
{c:"S 1040-R20B",f:"Reds",h:"#D18094",s:25},
{c:"S 1040-R30B",f:"Reds",h:"#C7809E",s:10},
{c:"S 1040-R40B",f:"Reds",h:"#BD80A8",s:10},
{c:"S 1040-R50B",f:"Reds",h:"#B280B2",s:10},
{c:"S 1040-R60B",f:"Reds",h:"#A880BD",s:10},
{c:"S 1040-R70B",f:"Reds",h:"#9E80C7",s:10},
{c:"S 1040-R80B",f:"Blues",h:"#9480D1",s:10},
{c:"S 1040-R90B",f:"Blues",h:"#8A80DB",s:10},
{c:"S 1040-Y",f:"Yellows",h:"#E6E680",s:25},
{c:"S 1040-Y10R",f:"Yellows",h:"#E6DB80",s:25},
{c:"S 1040-Y20R",f:"Yellows",h:"#E6D180",s:25},
{c:"S 1040-Y30R",f:"Yellows",h:"#E6C780",s:25},
{c:"S 1040-Y40R",f:"Yellows",h:"#E6BD80",s:25},
{c:"S 1040-Y50R",f:"Yellows",h:"#E6B280",s:25},
{c:"S 1040-Y60R",f:"Yellows",h:"#E6A880",s:25},
{c:"S 1040-Y70R",f:"Yellows",h:"#E69E80",s:25},
{c:"S 1040-Y80R",f:"Reds",h:"#E69480",s:25},
{c:"S 1040-Y90R",f:"Reds",h:"#E68A80",s:25},
{c:"S 1050-B",f:"Blues",h:"#6666E6",s:10},
{c:"S 1050-B10G",f:"Blues",h:"#6673D9",s:10},
{c:"S 1050-B20G",f:"Blues",h:"#6680CC",s:25},
{c:"S 1050-B30G",f:"Blues",h:"#668CBF",s:25},
{c:"S 1050-B40G",f:"Blues",h:"#6699B2",s:25},
{c:"S 1050-B50G",f:"Blues",h:"#66A6A6",s:25},
{c:"S 1050-B60G",f:"Blues",h:"#66B299",s:25},
{c:"S 1050-B70G",f:"Blues",h:"#66BF8C",s:25},
{c:"S 1050-B80G",f:"Greens",h:"#66CC80",s:25},
{c:"S 1050-B90G",f:"Greens",h:"#66D973",s:25},
{c:"S 1050-G",f:"Greens",h:"#66E666",s:25},
{c:"S 1050-G10Y",f:"Greens",h:"#73E666",s:25},
{c:"S 1050-G20Y",f:"Greens",h:"#80E666",s:25},
{c:"S 1050-G30Y",f:"Greens",h:"#8CE666",s:25},
{c:"S 1050-G40Y",f:"Greens",h:"#99E666",s:25},
{c:"S 1050-G50Y",f:"Greens",h:"#A6E666",s:25},
{c:"S 1050-G60Y",f:"Greens",h:"#B2E666",s:25},
{c:"S 1050-G70Y",f:"Greens",h:"#BFE666",s:25},
{c:"S 1050-G80Y",f:"Yellows",h:"#CCE666",s:25},
{c:"S 1050-G90Y",f:"Yellows",h:"#D9E666",s:25},
{c:"S 1050-R",f:"Reds",h:"#E66666",s:25},
{c:"S 1050-R10B",f:"Reds",h:"#D96673",s:25},
{c:"S 1050-R20B",f:"Reds",h:"#CC6680",s:45},
{c:"S 1050-R30B",f:"Reds",h:"#BF668C",s:25},
{c:"S 1050-R40B",f:"Reds",h:"#B26699",s:25},
{c:"S 1050-R70B",f:"Reds",h:"#8C66BF",s:10},
{c:"S 1050-R90B",f:"Blues",h:"#7366D9",s:10},
{c:"S 1050-Y",f:"Yellows",h:"#E6E666",s:25},
{c:"S 1050-Y10R",f:"Yellows",h:"#E6D966",s:25},
{c:"S 1050-Y20R",f:"Yellows",h:"#E6CC66",s:25},
{c:"S 1050-Y30R",f:"Yellows",h:"#E6BF66",s:25},
{c:"S 1050-Y40R",f:"Yellows",h:"#E6B266",s:25},
{c:"S 1050-Y50R",f:"Yellows",h:"#E6A666",s:25},
{c:"S 1050-Y60R",f:"Yellows",h:"#E69966",s:45},
{c:"S 1050-Y70R",f:"Yellows",h:"#E68C66",s:45},
{c:"S 1050-Y80R",f:"Reds",h:"#E68066",s:25},
{c:"S 1050-Y90R",f:"Reds",h:"#E67366",s:45},
{c:"S 1055-B90G",f:"Greens",h:"#59D767",s:25},
{c:"S 1060-B",f:"High chroma accents",h:"#4D4DE6",s:10},
{c:"S 1060-G",f:"High chroma accents",h:"#4DE64D",s:25},
{c:"S 1060-G10Y",f:"High chroma accents",h:"#5CE64D",s:25},
{c:"S 1060-G20Y",f:"High chroma accents",h:"#6BE64D",s:25},
{c:"S 1060-G30Y",f:"High chroma accents",h:"#7AE64D",s:25},
{c:"S 1060-G40Y",f:"High chroma accents",h:"#8AE64D",s:25},
{c:"S 1060-G50Y",f:"High chroma accents",h:"#99E64D",s:25},
{c:"S 1060-G60Y",f:"High chroma accents",h:"#A8E64D",s:45},
{c:"S 1060-G70Y",f:"High chroma accents",h:"#B8E64D",s:45},
{c:"S 1060-G80Y",f:"High chroma accents",h:"#C7E64D",s:45},
{c:"S 1060-G90Y",f:"High chroma accents",h:"#D6E64D",s:45},
{c:"S 1060-R",f:"High chroma accents",h:"#E64D4D",s:25},
{c:"S 1060-R10B",f:"High chroma accents",h:"#D64D5C",s:25},
{c:"S 1060-R20B",f:"High chroma accents",h:"#C74D6B",s:25},
{c:"S 1060-R30B",f:"High chroma accents",h:"#B84D7A",s:45},
{c:"S 1060-Y",f:"High chroma accents",h:"#E6E64D",s:25},
{c:"S 1060-Y10R",f:"High chroma accents",h:"#E6D64D",s:25},
{c:"S 1060-Y20R",f:"High chroma accents",h:"#E6C74D",s:45},
{c:"S 1060-Y30R",f:"High chroma accents",h:"#E6B84D",s:25},
{c:"S 1060-Y40R",f:"High chroma accents",h:"#E6A84D",s:25},
{c:"S 1060-Y50R",f:"High chroma accents",h:"#E6994D",s:45},
{c:"S 1060-Y60R",f:"High chroma accents",h:"#E68A4D",s:45},
{c:"S 1060-Y70R",f:"High chroma accents",h:"#E67A4D",s:45},
{c:"S 1060-Y80R",f:"High chroma accents",h:"#E66B4D",s:45},
{c:"S 1060-Y90R",f:"High chroma accents",h:"#E65C4D",s:45},
{c:"S 1070-G10Y",f:"High chroma accents",h:"#45E633",s:45},
{c:"S 1070-G20Y",f:"High chroma accents",h:"#57E633",s:45},
{c:"S 1070-G30Y",f:"High chroma accents",h:"#69E633",s:45},
{c:"S 1070-G40Y",f:"High chroma accents",h:"#7AE633",s:45},
{c:"S 1070-G50Y",f:"High chroma accents",h:"#8CE633",s:45},
{c:"S 1070-G60Y",f:"High chroma accents",h:"#9EE633",s:45},
{c:"S 1070-G70Y",f:"High chroma accents",h:"#B0E633",s:45},
{c:"S 1070-G80Y",f:"High chroma accents",h:"#C2E633",s:45},
{c:"S 1070-G90Y",f:"High chroma accents",h:"#D4E633",s:45},
{c:"S 1070-R",f:"High chroma accents",h:"#E63333",s:45},
{c:"S 1070-R10B",f:"High chroma accents",h:"#D43345",s:45},
{c:"S 1070-R20B",f:"High chroma accents",h:"#C23357",s:45},
{c:"S 1070-Y",f:"High chroma accents",h:"#E6E633",s:45},
{c:"S 1070-Y10R",f:"High chroma accents",h:"#E6D433",s:45},
{c:"S 1070-Y20R",f:"High chroma accents",h:"#E6C233",s:45},
{c:"S 1070-Y30R",f:"High chroma accents",h:"#E6B033",s:45},
{c:"S 1070-Y40R",f:"High chroma accents",h:"#E69E33",s:45},
{c:"S 1070-Y50R",f:"High chroma accents",h:"#E68C33",s:45},
{c:"S 1070-Y60R",f:"High chroma accents",h:"#E67A33",s:45},
{c:"S 1070-Y70R",f:"High chroma accents",h:"#E66933",s:45},
{c:"S 1070-Y80R",f:"High chroma accents",h:"#E65733",s:45},
{c:"S 1070-Y90R",f:"High chroma accents",h:"#E64533",s:45},
{c:"S 1075-G20Y",f:"High chroma accents",h:"#4DE626",s:45},
{c:"S 1075-G40Y",f:"High chroma accents",h:"#73E626",s:45},
{c:"S 1075-G50Y",f:"High chroma accents",h:"#86E626",s:45},
{c:"S 1075-G60Y",f:"High chroma accents",h:"#99E626",s:45},
{c:"S 1075-G70Y",f:"High chroma accents",h:"#ACE626",s:45},
{c:"S 1075-G80Y",f:"High chroma accents",h:"#BFE626",s:45},
{c:"S 1075-G90Y",f:"High chroma accents",h:"#D2E626",s:45},
{c:"S 1080-G30Y",f:"High chroma accents",h:"#57E619",s:45},
{c:"S 1080-R",f:"High chroma accents",h:"#E61919",s:45},
{c:"S 1080-Y",f:"High chroma accents",h:"#E6E619",s:45},
{c:"S 1080-Y10R",f:"High chroma accents",h:"#E6D119",s:45},
{c:"S 1080-Y20R",f:"High chroma accents",h:"#E6BD19",s:45},
{c:"S 1080-Y30R",f:"High chroma accents",h:"#E6A819",s:45},
{c:"S 1080-Y40R",f:"High chroma accents",h:"#E69419",s:45},
{c:"S 1080-Y50R",f:"High chroma accents",h:"#E68019",s:45},
{c:"S 1080-Y60R",f:"High chroma accents",h:"#E66B19",s:45},
{c:"S 1080-Y70R",f:"High chroma accents",h:"#E65719",s:45},
{c:"S 1080-Y80R",f:"High chroma accents",h:"#E64219",s:45},
{c:"S 1080-Y90R",f:"High chroma accents",h:"#E62E19",s:45},
{c:"S 1085-Y80R",f:"High chroma accents",h:"#E6380D",s:45},
{c:"S 1085-Y90R",f:"High chroma accents",h:"#E6220D",s:45},
{c:"S 1500-N",f:"Neutrals",h:"#D9D9D9",s:10},
{c:"S 1502-B",f:"Neutrals",h:"#D4D4D9",s:10},
{c:"S 1502-B50G",f:"Neutrals",h:"#D4D6D6",s:10},
{c:"S 1502-G",f:"Neutrals",h:"#D4D9D4",s:10},
{c:"S 1502-G50Y",f:"Neutrals",h:"#D6D9D4",s:10},
{c:"S 1502-R",f:"Neutrals",h:"#D9D4D4",s:10},
{c:"S 1502-R50B",f:"Neutrals",h:"#D6D4D6",s:10},
{c:"S 1502-Y",f:"Neutrals",h:"#D9D9D4",s:10},
{c:"S 1502-Y20R",f:"Neutrals",h:"#D9D8D4",s:10},
{c:"S 1502-Y50R",f:"Neutrals",h:"#D9D6D4",s:10},
{c:"S 1502-Y80R",f:"Neutrals",h:"#D9D5D4",s:10},
{c:"S 1505-B",f:"Neutrals",h:"#CCCCD9",s:10},
{c:"S 1505-B20G",f:"Neutrals",h:"#CCCFD6",s:10},
{c:"S 1505-B50G",f:"Neutrals",h:"#CCD2D2",s:10},
{c:"S 1505-B80G",f:"Neutrals",h:"#CCD6CF",s:10},
{c:"S 1505-G",f:"Neutrals",h:"#CCD9CC",s:10},
{c:"S 1505-G20Y",f:"Neutrals",h:"#CFD9CC",s:10},
{c:"S 1505-G50Y",f:"Neutrals",h:"#D2D9CC",s:10},
{c:"S 1505-G80Y",f:"Neutrals",h:"#D6D9CC",s:10},
{c:"S 1505-G90Y",f:"Neutrals",h:"#D7D9CC",s:10},
{c:"S 1505-R",f:"Neutrals",h:"#D9CCCC",s:10},
{c:"S 1505-R10B",f:"Neutrals",h:"#D7CCCD",s:10},
{c:"S 1505-R20B",f:"Neutrals",h:"#D6CCCF",s:10},
{c:"S 1505-R30B",f:"Neutrals",h:"#D5CCD0",s:10},
{c:"S 1505-R40B",f:"Neutrals",h:"#D4CCD1",s:10},
{c:"S 1505-R50B",f:"Neutrals",h:"#D2CCD2",s:10},
{c:"S 1505-R60B",f:"Neutrals",h:"#D1CCD4",s:10},
{c:"S 1505-R70B",f:"Neutrals",h:"#D0CCD5",s:10},
{c:"S 1505-R80B",f:"Neutrals",h:"#CFCCD6",s:10},
{c:"S 1505-Y",f:"Neutrals",h:"#D9D9CC",s:10},
{c:"S 1505-Y10R",f:"Neutrals",h:"#D9D7CC",s:10},
{c:"S 1505-Y20R",f:"Neutrals",h:"#D9D6CC",s:10},
{c:"S 1505-Y30R",f:"Neutrals",h:"#D9D5CC",s:10},
{c:"S 1505-Y40R",f:"Neutrals",h:"#D9D4CC",s:10},
{c:"S 1505-Y50R",f:"Neutrals",h:"#D9D2CC",s:10},
{c:"S 1505-Y60R",f:"Neutrals",h:"#D9D1CC",s:10},
{c:"S 1505-Y70R",f:"Neutrals",h:"#D9D0CC",s:10},
{c:"S 1505-Y80R",f:"Neutrals",h:"#D9CFCC",s:10},
{c:"S 1505-Y90R",f:"Neutrals",h:"#D9CDCC",s:10},
{c:"S 1510-B",f:"Neutrals",h:"#BFBFD9",s:10},
{c:"S 1510-B20G",f:"Neutrals",h:"#BFC4D4",s:10},
{c:"S 1510-B50G",f:"Neutrals",h:"#BFCCCC",s:10},
{c:"S 1510-B80G",f:"Neutrals",h:"#BFD4C4",s:10},
{c:"S 1510-G",f:"Neutrals",h:"#BFD9BF",s:10},
{c:"S 1510-G20Y",f:"Neutrals",h:"#C4D9BF",s:10},
{c:"S 1510-G40Y",f:"Neutrals",h:"#C9D9BF",s:10},
{c:"S 1510-G60Y",f:"Neutrals",h:"#CFD9BF",s:10},
{c:"S 1510-G80Y",f:"Neutrals",h:"#D4D9BF",s:10},
{c:"S 1510-G90Y",f:"Neutrals",h:"#D6D9BF",s:10},
{c:"S 1510-R",f:"Neutrals",h:"#D9BFBF",s:10},
{c:"S 1510-R10B",f:"Neutrals",h:"#D6BFC2",s:10},
{c:"S 1510-R20B",f:"Neutrals",h:"#D4BFC4",s:10},
{c:"S 1510-R40B",f:"Neutrals",h:"#CFBFC9",s:10},
{c:"S 1510-R60B",f:"Neutrals",h:"#C9BFCF",s:10},
{c:"S 1510-R80B",f:"Neutrals",h:"#C4BFD4",s:10},
{c:"S 1510-R90B",f:"Neutrals",h:"#C2BFD6",s:10},
{c:"S 1510-Y",f:"Neutrals",h:"#D9D9BF",s:10},
{c:"S 1510-Y10R",f:"Neutrals",h:"#D9D6BF",s:10},
{c:"S 1510-Y20R",f:"Neutrals",h:"#D9D4BF",s:10},
{c:"S 1510-Y30R",f:"Neutrals",h:"#D9D1BF",s:10},
{c:"S 1510-Y40R",f:"Neutrals",h:"#D9CFBF",s:10},
{c:"S 1510-Y50R",f:"Neutrals",h:"#D9CCBF",s:10},
{c:"S 1510-Y60R",f:"Neutrals",h:"#D9C9BF",s:10},
{c:"S 1510-Y70R",f:"Neutrals",h:"#D9C7BF",s:10},
{c:"S 1510-Y80R",f:"Neutrals",h:"#D9C4BF",s:10},
{c:"S 1510-Y90R",f:"Neutrals",h:"#D9C2BF",s:10},
{c:"S 1515-B",f:"Blues",h:"#B2B2D9",s:10},
{c:"S 1515-B20G",f:"Blues",h:"#B2BAD1",s:10},
{c:"S 1515-B50G",f:"Blues",h:"#B2C6C6",s:10},
{c:"S 1515-B80G",f:"Greens",h:"#B2D1BA",s:10},
{c:"S 1515-G",f:"Greens",h:"#B2D9B2",s:10},
{c:"S 1515-G20Y",f:"Greens",h:"#BAD9B2",s:10},
{c:"S 1515-G40Y",f:"Greens",h:"#C2D9B2",s:10},
{c:"S 1515-G60Y",f:"Greens",h:"#C9D9B2",s:10},
{c:"S 1515-G80Y",f:"Yellows",h:"#D1D9B2",s:10},
{c:"S 1515-G90Y",f:"Yellows",h:"#D5D9B2",s:10},
{c:"S 1515-R",f:"Reds",h:"#D9B2B2",s:10},
{c:"S 1515-R10B",f:"Reds",h:"#D5B2B6",s:10},
{c:"S 1515-R20B",f:"Reds",h:"#D1B2BA",s:10},
{c:"S 1515-R40B",f:"Reds",h:"#C9B2C2",s:10},
{c:"S 1515-R60B",f:"Reds",h:"#C2B2C9",s:10},
{c:"S 1515-R80B",f:"Blues",h:"#BAB2D1",s:10},
{c:"S 1515-R90B",f:"Blues",h:"#B6B2D5",s:10},
{c:"S 1515-Y",f:"Yellows",h:"#D9D9B2",s:10},
{c:"S 1515-Y10R",f:"Yellows",h:"#D9D5B2",s:10},
{c:"S 1515-Y20R",f:"Yellows",h:"#D9D1B2",s:10},
{c:"S 1515-Y30R",f:"Yellows",h:"#D9CDB2",s:10},
{c:"S 1515-Y40R",f:"Yellows",h:"#D9C9B2",s:10},
{c:"S 1515-Y50R",f:"Yellows",h:"#D9C6B2",s:10},
{c:"S 1515-Y60R",f:"Yellows",h:"#D9C2B2",s:10},
{c:"S 1515-Y70R",f:"Yellows",h:"#D9BEB2",s:10},
{c:"S 1515-Y80R",f:"Reds",h:"#D9BAB2",s:10},
{c:"S 1515-Y90R",f:"Reds",h:"#D9B6B2",s:10},
{c:"S 1550-R70B",f:"Reds",h:"#8059B2",s:10},
{c:"S 1550-R80B",f:"Blues",h:"#7359BF",s:10},
{c:"S 1555-B10G",f:"Blues",h:"#4C5BCB",s:25},
{c:"S 1555-R70B",f:"Reds",h:"#774CAF",s:45},
{c:"S 1555-R80B",f:"Blues",h:"#694CBD",s:25},
{c:"S 1560-R90B",f:"High chroma accents",h:"#4F40C9",s:25},
{c:"S 1565-B",f:"High chroma accents",h:"#3333D9",s:25},
{c:"S 1565-G",f:"High chroma accents",h:"#33D933",s:45},
{c:"S 1575-R10B",f:"High chroma accents",h:"#C6192D",s:45},
{c:"S 1580-R",f:"High chroma accents",h:"#D90D0D",s:45},
{c:"S 1580-Y80R",f:"High chroma accents",h:"#D9360D",s:45},
{c:"S 1580-Y90R",f:"High chroma accents",h:"#D9210D",s:45},
{c:"S 2000-N",f:"Neutrals",h:"#CCCCCC",s:10},
{c:"S 2002-B",f:"Neutrals",h:"#C7C7CC",s:10},
{c:"S 2002-B50G",f:"Neutrals",h:"#C7C9C9",s:10},
{c:"S 2002-G",f:"Neutrals",h:"#C7CCC7",s:10},
{c:"S 2002-G50Y",f:"Neutrals",h:"#C9CCC7",s:10},
{c:"S 2002-R",f:"Neutrals",h:"#CCC7C7",s:10},
{c:"S 2002-R50B",f:"Neutrals",h:"#C9C7C9",s:10},
{c:"S 2002-Y",f:"Neutrals",h:"#CCCCC7",s:10},
{c:"S 2002-Y20R",f:"Neutrals",h:"#CCCBC7",s:10},
{c:"S 2002-Y50R",f:"Neutrals",h:"#CCC9C7",s:10},
{c:"S 2002-Y80R",f:"Neutrals",h:"#CCC8C7",s:10},
{c:"S 2005-B",f:"Neutrals",h:"#BFBFCC",s:10},
{c:"S 2005-B20G",f:"Neutrals",h:"#BFC2C9",s:10},
{c:"S 2005-B50G",f:"Neutrals",h:"#BFC6C6",s:10},
{c:"S 2005-B80G",f:"Neutrals",h:"#BFC9C2",s:10},
{c:"S 2005-G",f:"Neutrals",h:"#BFCCBF",s:10},
{c:"S 2005-G10Y",f:"Neutrals",h:"#C1CCBF",s:10},
{c:"S 2005-G20Y",f:"Neutrals",h:"#C2CCBF",s:10},
{c:"S 2005-G30Y",f:"Neutrals",h:"#C3CCBF",s:10},
{c:"S 2005-G40Y",f:"Neutrals",h:"#C4CCBF",s:10},
{c:"S 2005-G50Y",f:"Neutrals",h:"#C6CCBF",s:10},
{c:"S 2005-G60Y",f:"Neutrals",h:"#C7CCBF",s:10},
{c:"S 2005-G70Y",f:"Neutrals",h:"#C8CCBF",s:10},
{c:"S 2005-G80Y",f:"Neutrals",h:"#C9CCBF",s:10},
{c:"S 2005-G90Y",f:"Neutrals",h:"#CBCCBF",s:10},
{c:"S 2005-R",f:"Neutrals",h:"#CCBFBF",s:10},
{c:"S 2005-R10B",f:"Neutrals",h:"#CBBFC1",s:10},
{c:"S 2005-R20B",f:"Neutrals",h:"#C9BFC2",s:10},
{c:"S 2005-R30B",f:"Neutrals",h:"#C8BFC3",s:10},
{c:"S 2005-R40B",f:"Neutrals",h:"#C7BFC4",s:10},
{c:"S 2005-R50B",f:"Neutrals",h:"#C6BFC6",s:10},
{c:"S 2005-R60B",f:"Neutrals",h:"#C4BFC7",s:10},
{c:"S 2005-R70B",f:"Neutrals",h:"#C3BFC8",s:10},
{c:"S 2005-R80B",f:"Neutrals",h:"#C2BFC9",s:10},
{c:"S 2005-R90B",f:"Neutrals",h:"#C1BFCB",s:10},
{c:"S 2005-Y",f:"Neutrals",h:"#CCCCBF",s:10},
{c:"S 2005-Y10R",f:"Neutrals",h:"#CCCBBF",s:10},
{c:"S 2005-Y20R",f:"Neutrals",h:"#CCC9BF",s:10},
{c:"S 2005-Y30R",f:"Neutrals",h:"#CCC8BF",s:10},
{c:"S 2005-Y40R",f:"Neutrals",h:"#CCC7BF",s:10},
{c:"S 2005-Y50R",f:"Neutrals",h:"#CCC6BF",s:10},
{c:"S 2005-Y60R",f:"Neutrals",h:"#CCC4BF",s:10},
{c:"S 2005-Y70R",f:"Neutrals",h:"#CCC3BF",s:10},
{c:"S 2005-Y80R",f:"Neutrals",h:"#CCC2BF",s:10},
{c:"S 2005-Y90R",f:"Neutrals",h:"#CCC1BF",s:10},
{c:"S 2010-B",f:"Neutrals",h:"#B3B3CC",s:10},
{c:"S 2010-B10G",f:"Neutrals",h:"#B3B5C9",s:10},
{c:"S 2010-B30G",f:"Neutrals",h:"#B3BAC4",s:10},
{c:"S 2010-B50G",f:"Neutrals",h:"#B3BFBF",s:10},
{c:"S 2010-B70G",f:"Neutrals",h:"#B3C4BA",s:10},
{c:"S 2010-B90G",f:"Neutrals",h:"#B3C9B5",s:10},
{c:"S 2010-G",f:"Neutrals",h:"#B3CCB3",s:10},
{c:"S 2010-G10Y",f:"Neutrals",h:"#B5CCB3",s:10},
{c:"S 2010-G20Y",f:"Neutrals",h:"#B8CCB3",s:10},
{c:"S 2010-G30Y",f:"Neutrals",h:"#BACCB3",s:10},
{c:"S 2010-G40Y",f:"Neutrals",h:"#BDCCB3",s:10},
{c:"S 2010-G50Y",f:"Neutrals",h:"#BFCCB3",s:10},
{c:"S 2010-G60Y",f:"Neutrals",h:"#C2CCB3",s:10},
{c:"S 2010-G70Y",f:"Neutrals",h:"#C4CCB3",s:10},
{c:"S 2010-G80Y",f:"Neutrals",h:"#C7CCB3",s:10},
{c:"S 2010-G90Y",f:"Neutrals",h:"#C9CCB3",s:10},
{c:"S 2010-R",f:"Neutrals",h:"#CCB3B3",s:10},
{c:"S 2010-R10B",f:"Neutrals",h:"#C9B3B5",s:10},
{c:"S 2010-R20B",f:"Neutrals",h:"#C7B3B8",s:10},
{c:"S 2010-R30B",f:"Neutrals",h:"#C4B3BA",s:10},
{c:"S 2010-R40B",f:"Neutrals",h:"#C2B3BD",s:10},
{c:"S 2010-R50B",f:"Neutrals",h:"#BFB3BF",s:10},
{c:"S 2010-R60B",f:"Neutrals",h:"#BDB3C2",s:10},
{c:"S 2010-R70B",f:"Neutrals",h:"#BAB3C4",s:10},
{c:"S 2010-R80B",f:"Neutrals",h:"#B8B3C7",s:10},
{c:"S 2010-R90B",f:"Neutrals",h:"#B5B3C9",s:10},
{c:"S 2010-Y",f:"Neutrals",h:"#CCCCB3",s:10},
{c:"S 2010-Y10R",f:"Neutrals",h:"#CCC9B3",s:10},
{c:"S 2010-Y20R",f:"Neutrals",h:"#CCC7B3",s:10},
{c:"S 2010-Y30R",f:"Neutrals",h:"#CCC4B3",s:10},
{c:"S 2010-Y40R",f:"Neutrals",h:"#CCC2B3",s:10},
{c:"S 2010-Y50R",f:"Neutrals",h:"#CCBFB3",s:10},
{c:"S 2010-Y60R",f:"Neutrals",h:"#CCBDB3",s:10},
{c:"S 2010-Y70R",f:"Neutrals",h:"#CCBAB3",s:10},
{c:"S 2010-Y80R",f:"Neutrals",h:"#CCB8B3",s:10},
{c:"S 2010-Y90R",f:"Neutrals",h:"#CCB5B3",s:10},
{c:"S 2020-B",f:"Blues",h:"#9999CC",s:10},
{c:"S 2020-B10G",f:"Blues",h:"#999EC7",s:10},
{c:"S 2020-B30G",f:"Blues",h:"#99A8BD",s:10},
{c:"S 2020-B40G",f:"Blues",h:"#99ADB8",s:10},
{c:"S 2020-B50G",f:"Blues",h:"#99B3B3",s:10},
{c:"S 2020-B60G",f:"Blues",h:"#99B8AD",s:10},
{c:"S 2020-B70G",f:"Blues",h:"#99BDA8",s:10},
{c:"S 2020-B90G",f:"Greens",h:"#99C79E",s:10},
{c:"S 2020-G",f:"Greens",h:"#99CC99",s:10},
{c:"S 2020-G10Y",f:"Greens",h:"#9ECC99",s:25},
{c:"S 2020-G20Y",f:"Greens",h:"#A3CC99",s:25},
{c:"S 2020-G30Y",f:"Greens",h:"#A8CC99",s:25},
{c:"S 2020-G40Y",f:"Greens",h:"#ADCC99",s:25},
{c:"S 2020-G50Y",f:"Greens",h:"#B3CC99",s:25},
{c:"S 2020-G60Y",f:"Greens",h:"#B8CC99",s:25},
{c:"S 2020-G70Y",f:"Greens",h:"#BDCC99",s:45},
{c:"S 2020-G80Y",f:"Yellows",h:"#C2CC99",s:25},
{c:"S 2020-G90Y",f:"Yellows",h:"#C7CC99",s:25},
{c:"S 2020-R",f:"Reds",h:"#CC9999",s:10},
{c:"S 2020-R10B",f:"Reds",h:"#C7999E",s:45},
{c:"S 2020-R20B",f:"Reds",h:"#C299A3",s:10},
{c:"S 2020-R30B",f:"Reds",h:"#BD99A8",s:10},
{c:"S 2020-R40B",f:"Reds",h:"#B899AD",s:10},
{c:"S 2020-R50B",f:"Reds",h:"#B399B3",s:10},
{c:"S 2020-R60B",f:"Reds",h:"#AD99B8",s:10},
{c:"S 2020-R70B",f:"Reds",h:"#A899BD",s:10},
{c:"S 2020-R80B",f:"Blues",h:"#A399C2",s:10},
{c:"S 2020-R90B",f:"Blues",h:"#9E99C7",s:10},
{c:"S 2020-Y",f:"Yellows",h:"#CCCC99",s:25},
{c:"S 2020-Y10R",f:"Yellows",h:"#CCC799",s:25},
{c:"S 2020-Y20R",f:"Yellows",h:"#CCC299",s:25},
{c:"S 2020-Y30R",f:"Yellows",h:"#CCBD99",s:25},
{c:"S 2020-Y40R",f:"Yellows",h:"#CCB899",s:25},
{c:"S 2020-Y50R",f:"Yellows",h:"#CCB399",s:10},
{c:"S 2020-Y60R",f:"Yellows",h:"#CCAD99",s:10},
{c:"S 2020-Y70R",f:"Yellows",h:"#CCA899",s:10},
{c:"S 2020-Y80R",f:"Reds",h:"#CCA399",s:10},
{c:"S 2020-Y90R",f:"Reds",h:"#CC9E99",s:10},
{c:"S 2030-B",f:"Blues",h:"#8080CC",s:25},
{c:"S 2030-B10G",f:"Blues",h:"#8087C4",s:10},
{c:"S 2030-B30G",f:"Blues",h:"#8096B5",s:25},
{c:"S 2030-B40G",f:"Blues",h:"#809EAD",s:25},
{c:"S 2030-B50G",f:"Blues",h:"#80A6A6",s:25},
{c:"S 2030-B60G",f:"Blues",h:"#80AD9E",s:25},
{c:"S 2030-B70G",f:"Blues",h:"#80B596",s:25},
{c:"S 2030-B90G",f:"Greens",h:"#80C487",s:25},
{c:"S 2030-G",f:"Greens",h:"#80CC80",s:25},
{c:"S 2030-G10Y",f:"Greens",h:"#87CC80",s:25},
{c:"S 2030-G20Y",f:"Greens",h:"#8FCC80",s:25},
{c:"S 2030-G30Y",f:"Greens",h:"#96CC80",s:25},
{c:"S 2030-G40Y",f:"Greens",h:"#9ECC80",s:25},
{c:"S 2030-G50Y",f:"Greens",h:"#A6CC80",s:25},
{c:"S 2030-G60Y",f:"Greens",h:"#ADCC80",s:25},
{c:"S 2030-G70Y",f:"Greens",h:"#B5CC80",s:25},
{c:"S 2030-G80Y",f:"Yellows",h:"#BDCC80",s:25},
{c:"S 2030-G90Y",f:"Yellows",h:"#C4CC80",s:25},
{c:"S 2030-R",f:"Reds",h:"#CC8080",s:10},
{c:"S 2030-R10B",f:"Reds",h:"#C48087",s:10},
{c:"S 2030-R20B",f:"Reds",h:"#BD808F",s:10},
{c:"S 2030-R30B",f:"Reds",h:"#B58096",s:10},
{c:"S 2030-R40B",f:"Reds",h:"#AD809E",s:10},
{c:"S 2030-R50B",f:"Reds",h:"#A680A6",s:10},
{c:"S 2030-R60B",f:"Reds",h:"#9E80AD",s:10},
{c:"S 2030-R70B",f:"Reds",h:"#9680B5",s:10},
{c:"S 2030-R80B",f:"Blues",h:"#8F80BD",s:10},
{c:"S 2030-R90B",f:"Blues",h:"#8780C4",s:25},
{c:"S 2030-Y",f:"Yellows",h:"#CCCC80",s:25},
{c:"S 2030-Y10R",f:"Yellows",h:"#CCC480",s:25},
{c:"S 2030-Y20R",f:"Yellows",h:"#CCBD80",s:25},
{c:"S 2030-Y30R",f:"Yellows",h:"#CCB580",s:25},
{c:"S 2030-Y40R",f:"Yellows",h:"#CCAD80",s:25},
{c:"S 2030-Y50R",f:"Yellows",h:"#CCA680",s:25},
{c:"S 2030-Y60R",f:"Yellows",h:"#CC9E80",s:25},
{c:"S 2030-Y70R",f:"Yellows",h:"#CC9680",s:25},
{c:"S 2030-Y80R",f:"Reds",h:"#CC8F80",s:10},
{c:"S 2030-Y90R",f:"Reds",h:"#CC8780",s:10},
{c:"S 2040-B",f:"Blues",h:"#6666CC",s:10},
{c:"S 2040-B10G",f:"Blues",h:"#6670C2",s:10},
{c:"S 2040-B20G",f:"Blues",h:"#667AB8",s:25},
{c:"S 2040-B30G",f:"Blues",h:"#6685AD",s:25},
{c:"S 2040-B40G",f:"Blues",h:"#668FA3",s:25},
{c:"S 2040-B50G",f:"Blues",h:"#669999",s:25},
{c:"S 2040-B60G",f:"Blues",h:"#66A38F",s:25},
{c:"S 2040-B70G",f:"Blues",h:"#66AD85",s:25},
{c:"S 2040-B80G",f:"Greens",h:"#66B87A",s:25},
{c:"S 2040-B90G",f:"Greens",h:"#66C270",s:25},
{c:"S 2040-G",f:"Greens",h:"#66CC66",s:25},
{c:"S 2040-G10Y",f:"Greens",h:"#70CC66",s:25},
{c:"S 2040-G20Y",f:"Greens",h:"#7ACC66",s:25},
{c:"S 2040-G30Y",f:"Greens",h:"#85CC66",s:25},
{c:"S 2040-G40Y",f:"Greens",h:"#8FCC66",s:25},
{c:"S 2040-G50Y",f:"Greens",h:"#99CC66",s:25},
{c:"S 2040-G60Y",f:"Greens",h:"#A3CC66",s:25},
{c:"S 2040-G70Y",f:"Greens",h:"#ADCC66",s:25},
{c:"S 2040-G80Y",f:"Yellows",h:"#B8CC66",s:25},
{c:"S 2040-G90Y",f:"Yellows",h:"#C2CC66",s:25},
{c:"S 2040-R",f:"Reds",h:"#CC6666",s:25},
{c:"S 2040-R10B",f:"Reds",h:"#C26670",s:25},
{c:"S 2040-R20B",f:"Reds",h:"#B8667A",s:25},
{c:"S 2040-R30B",f:"Reds",h:"#AD6685",s:25},
{c:"S 2040-R40B",f:"Reds",h:"#A3668F",s:25},
{c:"S 2040-R50B",f:"Reds",h:"#996699",s:25},
{c:"S 2040-R60B",f:"Reds",h:"#8F66A3",s:25},
{c:"S 2040-R70B",f:"Reds",h:"#8566AD",s:10},
{c:"S 2040-R80B",f:"Blues",h:"#7A66B8",s:10},
{c:"S 2040-R90B",f:"Blues",h:"#7066C2",s:10},
{c:"S 2040-Y",f:"Yellows",h:"#CCCC66",s:25},
{c:"S 2040-Y10R",f:"Yellows",h:"#CCC266",s:25},
{c:"S 2040-Y20R",f:"Yellows",h:"#CCB866",s:25},
{c:"S 2040-Y30R",f:"Yellows",h:"#CCAD66",s:25},
{c:"S 2040-Y40R",f:"Yellows",h:"#CCA366",s:25},
{c:"S 2040-Y50R",f:"Yellows",h:"#CC9966",s:25},
{c:"S 2040-Y60R",f:"Yellows",h:"#CC8F66",s:25},
{c:"S 2040-Y70R",f:"Yellows",h:"#CC8566",s:25},
{c:"S 2040-Y80R",f:"Reds",h:"#CC7A66",s:25},
{c:"S 2040-Y90R",f:"Reds",h:"#CC7066",s:25},
{c:"S 2050-B",f:"Blues",h:"#4D4DCC",s:10},
{c:"S 2050-B10G",f:"Blues",h:"#4D59BF",s:25},
{c:"S 2050-B20G",f:"Blues",h:"#4D66B3",s:25},
{c:"S 2050-B30G",f:"Blues",h:"#4D73A6",s:25},
{c:"S 2050-B40G",f:"Blues",h:"#4D8099",s:25},
{c:"S 2050-B50G",f:"Blues",h:"#4D8C8C",s:25},
{c:"S 2050-B60G",f:"Blues",h:"#4D9980",s:25},
{c:"S 2050-B70G",f:"Blues",h:"#4DA673",s:25},
{c:"S 2050-B80G",f:"Greens",h:"#4DB366",s:25},
{c:"S 2050-B90G",f:"Greens",h:"#4DBF59",s:25},
{c:"S 2050-G",f:"Greens",h:"#4DCC4D",s:25},
{c:"S 2050-G10Y",f:"Greens",h:"#59CC4D",s:25},
{c:"S 2050-G20Y",f:"Greens",h:"#66CC4D",s:25},
{c:"S 2050-G30Y",f:"Greens",h:"#73CC4D",s:25},
{c:"S 2050-G40Y",f:"Greens",h:"#80CC4D",s:45},
{c:"S 2050-G50Y",f:"Greens",h:"#8CCC4D",s:45},
{c:"S 2050-G60Y",f:"Greens",h:"#99CC4D",s:45},
{c:"S 2050-G70Y",f:"Greens",h:"#A6CC4D",s:45},
{c:"S 2050-G80Y",f:"Yellows",h:"#B3CC4D",s:45},
{c:"S 2050-G90Y",f:"Yellows",h:"#BFCC4D",s:45},
{c:"S 2050-R",f:"Reds",h:"#CC4D4D",s:25},
{c:"S 2050-R10B",f:"Reds",h:"#BF4D59",s:25},
{c:"S 2050-R20B",f:"Reds",h:"#B34D66",s:25},
{c:"S 2050-R30B",f:"Reds",h:"#A64D73",s:25},
{c:"S 2050-R40B",f:"Reds",h:"#994D80",s:25},
{c:"S 2050-R50B",f:"Reds",h:"#8C4D8C",s:45},
{c:"S 2050-R60B",f:"Reds",h:"#804D99",s:25},
{c:"S 2050-R70B",f:"Reds",h:"#734DA6",s:25},
{c:"S 2050-R80B",f:"Blues",h:"#664DB3",s:25},
{c:"S 2050-R90B",f:"Blues",h:"#594DBF",s:25},
{c:"S 2050-Y",f:"Yellows",h:"#CCCC4D",s:45},
{c:"S 2050-Y10R",f:"Yellows",h:"#CCBF4D",s:45},
{c:"S 2050-Y20R",f:"Yellows",h:"#CCB34D",s:25},
{c:"S 2050-Y30R",f:"Yellows",h:"#CCA64D",s:25},
{c:"S 2050-Y40R",f:"Yellows",h:"#CC994D",s:25},
{c:"S 2050-Y50R",f:"Yellows",h:"#CC8C4D",s:25},
{c:"S 2050-Y60R",f:"Yellows",h:"#CC804D",s:45},
{c:"S 2050-Y70R",f:"Yellows",h:"#CC734D",s:45},
{c:"S 2050-Y80R",f:"Reds",h:"#CC664D",s:45},
{c:"S 2050-Y90R",f:"Reds",h:"#CC594D",s:25},
{c:"S 2055-B10G",f:"Blues",h:"#404EBE",s:25},
{c:"S 2060-B",f:"High chroma accents",h:"#3333CC",s:25},
{c:"S 2060-B50G",f:"High chroma accents",h:"#338080",s:25},
{c:"S 2060-B70G",f:"High chroma accents",h:"#339E61",s:45},
{c:"S 2060-B90G",f:"High chroma accents",h:"#33BD42",s:45},
{c:"S 2060-G",f:"High chroma accents",h:"#33CC33",s:45},
{c:"S 2060-G10Y",f:"High chroma accents",h:"#42CC33",s:45},
{c:"S 2060-G20Y",f:"High chroma accents",h:"#52CC33",s:45},
{c:"S 2060-G30Y",f:"High chroma accents",h:"#61CC33",s:45},
{c:"S 2060-G40Y",f:"High chroma accents",h:"#70CC33",s:45},
{c:"S 2060-G50Y",f:"High chroma accents",h:"#80CC33",s:45},
{c:"S 2060-G60Y",f:"High chroma accents",h:"#8FCC33",s:45},
{c:"S 2060-G70Y",f:"High chroma accents",h:"#9ECC33",s:45},
{c:"S 2060-G80Y",f:"High chroma accents",h:"#ADCC33",s:45},
{c:"S 2060-G90Y",f:"High chroma accents",h:"#BDCC33",s:45},
{c:"S 2060-R",f:"High chroma accents",h:"#CC3333",s:45},
{c:"S 2060-R10B",f:"High chroma accents",h:"#BD3342",s:45},
{c:"S 2060-R20B",f:"High chroma accents",h:"#AD3352",s:45},
{c:"S 2060-R30B",f:"High chroma accents",h:"#9E3361",s:25},
{c:"S 2060-R40B",f:"High chroma accents",h:"#8F3370",s:25},
{c:"S 2060-R70B",f:"High chroma accents",h:"#61339E",s:25},
{c:"S 2060-R80B",f:"High chroma accents",h:"#5233AD",s:45},
{c:"S 2060-R90B",f:"High chroma accents",h:"#4233BD",s:25},
{c:"S 2060-Y",f:"High chroma accents",h:"#CCCC33",s:45},
{c:"S 2060-Y10R",f:"High chroma accents",h:"#CCBD33",s:45},
{c:"S 2060-Y20R",f:"High chroma accents",h:"#CCAD33",s:45},
{c:"S 2060-Y30R",f:"High chroma accents",h:"#CC9E33",s:45},
{c:"S 2060-Y40R",f:"High chroma accents",h:"#CC8F33",s:45},
{c:"S 2060-Y50R",f:"High chroma accents",h:"#CC8033",s:45},
{c:"S 2060-Y60R",f:"High chroma accents",h:"#CC7033",s:45},
{c:"S 2060-Y70R",f:"High chroma accents",h:"#CC6133",s:45},
{c:"S 2060-Y80R",f:"High chroma accents",h:"#CC5233",s:45},
{c:"S 2060-Y90R",f:"High chroma accents",h:"#CC4233",s:45},
{c:"S 2065-B",f:"High chroma accents",h:"#2626CC",s:25},
{c:"S 2065-R20B",f:"High chroma accents",h:"#AB2647",s:45},
{c:"S 2065-R90B",f:"High chroma accents",h:"#3726BB",s:25},
{c:"S 2070-G10Y",f:"High chroma accents",h:"#2BCC1A",s:45},
{c:"S 2070-G20Y",f:"High chroma accents",h:"#3DCC1A",s:45},
{c:"S 2070-G30Y",f:"High chroma accents",h:"#4FCC1A",s:45},
{c:"S 2070-G40Y",f:"High chroma accents",h:"#61CC1A",s:45},
{c:"S 2070-G50Y",f:"High chroma accents",h:"#73CC1A",s:45},
{c:"S 2070-G60Y",f:"High chroma accents",h:"#85CC1A",s:45},
{c:"S 2070-G70Y",f:"High chroma accents",h:"#96CC1A",s:45},
{c:"S 2070-G80Y",f:"High chroma accents",h:"#A8CC1A",s:45},
{c:"S 2070-G90Y",f:"High chroma accents",h:"#BACC1A",s:45},
{c:"S 2070-R",f:"High chroma accents",h:"#CC1A1A",s:45},
{c:"S 2070-R10B",f:"High chroma accents",h:"#BA1A2B",s:45},
{c:"S 2070-Y",f:"High chroma accents",h:"#CCCC1A",s:45},
{c:"S 2070-Y10R",f:"High chroma accents",h:"#CCBA1A",s:45},
{c:"S 2070-Y20R",f:"High chroma accents",h:"#CCA81A",s:45},
{c:"S 2070-Y30R",f:"High chroma accents",h:"#CC961A",s:45},
{c:"S 2070-Y40R",f:"High chroma accents",h:"#CC851A",s:45},
{c:"S 2070-Y50R",f:"High chroma accents",h:"#CC731A",s:45},
{c:"S 2070-Y60R",f:"High chroma accents",h:"#CC611A",s:45},
{c:"S 2070-Y70R",f:"High chroma accents",h:"#CC4F1A",s:45},
{c:"S 2070-Y80R",f:"High chroma accents",h:"#CC3D1A",s:45},
{c:"S 2070-Y90R",f:"High chroma accents",h:"#CC2B1A",s:45},
{c:"S 2075-G20Y",f:"High chroma accents",h:"#33CC0D",s:45},
{c:"S 2075-G30Y",f:"High chroma accents",h:"#46CC0D",s:45},
{c:"S 2075-Y60R",f:"High chroma accents",h:"#CC590D",s:45},
{c:"S 2075-Y70R",f:"High chroma accents",h:"#CC460D",s:45},
{c:"S 2500-N",f:"Neutrals",h:"#BFBFBF",s:10},
{c:"S 2502-B",f:"Neutrals",h:"#BABABF",s:10},
{c:"S 2502-B50G",f:"Neutrals",h:"#BABDBD",s:10},
{c:"S 2502-G",f:"Neutrals",h:"#BABFBA",s:10},
{c:"S 2502-G50Y",f:"Neutrals",h:"#BDBFBA",s:10},
{c:"S 2502-R",f:"Neutrals",h:"#BFBABA",s:10},
{c:"S 2502-R50B",f:"Neutrals",h:"#BDBABD",s:10},
{c:"S 2502-Y",f:"Neutrals",h:"#BFBFBA",s:10},
{c:"S 2502-Y20R",f:"Neutrals",h:"#BFBEBA",s:10},
{c:"S 2502-Y50R",f:"Neutrals",h:"#BFBDBA",s:10},
{c:"S 2502-Y80R",f:"Neutrals",h:"#BFBBBA",s:10},
{c:"S 2555-B20G",f:"Blues",h:"#334FA3",s:25},
{c:"S 2555-B30G",f:"Blues",h:"#335D95",s:25},
{c:"S 2555-B40G",f:"Blues",h:"#336B87",s:45},
{c:"S 2555-B60G",f:"Blues",h:"#33876B",s:45},
{c:"S 2555-B80G",f:"Greens",h:"#33A34F",s:45},
{c:"S 2565-G",f:"High chroma accents",h:"#19BF19",s:45},
{c:"S 2565-R80B",f:"High chroma accents",h:"#3B199E",s:25},
{c:"S 2570-G20Y",f:"High chroma accents",h:"#30BF0D",s:45},
{c:"S 2570-G30Y",f:"High chroma accents",h:"#42BF0D",s:45},
{c:"S 2570-R",f:"High chroma accents",h:"#BF0D0D",s:45},
{c:"S 2570-Y30R",f:"High chroma accents",h:"#BF8A0D",s:45},
{c:"S 2570-Y40R",f:"High chroma accents",h:"#BF780D",s:45},
{c:"S 2570-Y50R",f:"High chroma accents",h:"#BF660D",s:45},
{c:"S 2570-Y60R",f:"High chroma accents",h:"#BF540D",s:45},
{c:"S 2570-Y70R",f:"High chroma accents",h:"#BF420D",s:45},
{c:"S 2570-Y80R",f:"High chroma accents",h:"#BF300D",s:45},
{c:"S 2570-Y90R",f:"High chroma accents",h:"#BF1F0D",s:45},
{c:"S 3000-N",f:"Neutrals",h:"#B2B2B2",s:10},
{c:"S 3005-B",f:"Neutrals",h:"#A6A6B2",s:10},
{c:"S 3005-B20G",f:"Neutrals",h:"#A6A8B0",s:10},
{c:"S 3005-B50G",f:"Neutrals",h:"#A6ACAC",s:10},
{c:"S 3005-B80G",f:"Neutrals",h:"#A6B0A8",s:10},
{c:"S 3005-G",f:"Neutrals",h:"#A6B2A6",s:10},
{c:"S 3005-G20Y",f:"Neutrals",h:"#A8B2A6",s:10},
{c:"S 3005-G50Y",f:"Neutrals",h:"#ACB2A6",s:10},
{c:"S 3005-G80Y",f:"Neutrals",h:"#B0B2A6",s:10},
{c:"S 3005-R",f:"Neutrals",h:"#B2A6A6",s:10},
{c:"S 3005-R20B",f:"Neutrals",h:"#B0A6A8",s:10},
{c:"S 3005-R50B",f:"Neutrals",h:"#ACA6AC",s:10},
{c:"S 3005-R80B",f:"Neutrals",h:"#A8A6B0",s:10},
{c:"S 3005-Y",f:"Neutrals",h:"#B2B2A6",s:10},
{c:"S 3005-Y20R",f:"Neutrals",h:"#B2B0A6",s:10},
{c:"S 3005-Y50R",f:"Neutrals",h:"#B2ACA6",s:10},
{c:"S 3005-Y80R",f:"Neutrals",h:"#B2A8A6",s:10},
{c:"S 3010-B",f:"Neutrals",h:"#9999B2",s:10},
{c:"S 3010-B10G",f:"Neutrals",h:"#999CB0",s:10},
{c:"S 3010-B30G",f:"Neutrals",h:"#99A1AB",s:10},
{c:"S 3010-B50G",f:"Neutrals",h:"#99A6A6",s:10},
{c:"S 3010-B70G",f:"Neutrals",h:"#99ABA1",s:10},
{c:"S 3010-B90G",f:"Neutrals",h:"#99B09C",s:10},
{c:"S 3010-G",f:"Neutrals",h:"#99B299",s:10},
{c:"S 3010-G10Y",f:"Neutrals",h:"#9CB299",s:25},
{c:"S 3010-G20Y",f:"Neutrals",h:"#9EB299",s:25},
{c:"S 3010-G30Y",f:"Neutrals",h:"#A1B299",s:25},
{c:"S 3010-G40Y",f:"Neutrals",h:"#A3B299",s:25},
{c:"S 3010-G50Y",f:"Neutrals",h:"#A6B299",s:25},
{c:"S 3010-G60Y",f:"Neutrals",h:"#A8B299",s:25},
{c:"S 3010-G70Y",f:"Neutrals",h:"#ABB299",s:25},
{c:"S 3010-G80Y",f:"Neutrals",h:"#ADB299",s:25},
{c:"S 3010-G90Y",f:"Neutrals",h:"#B0B299",s:25},
{c:"S 3010-R",f:"Neutrals",h:"#B29999",s:10},
{c:"S 3010-R10B",f:"Neutrals",h:"#B0999C",s:10},
{c:"S 3010-R20B",f:"Neutrals",h:"#AD999E",s:45},
{c:"S 3010-R30B",f:"Neutrals",h:"#AB99A1",s:10},
{c:"S 3010-R40B",f:"Neutrals",h:"#A899A3",s:10},
{c:"S 3010-R50B",f:"Neutrals",h:"#A699A6",s:10},
{c:"S 3010-R60B",f:"Neutrals",h:"#A399A8",s:25},
{c:"S 3010-R70B",f:"Neutrals",h:"#A199AB",s:10},
{c:"S 3010-R80B",f:"Neutrals",h:"#9E99AD",s:10},
{c:"S 3010-R90B",f:"Neutrals",h:"#9C99B0",s:10},
{c:"S 3010-Y",f:"Neutrals",h:"#B2B299",s:10},
{c:"S 3010-Y10R",f:"Neutrals",h:"#B2B099",s:10},
{c:"S 3010-Y20R",f:"Neutrals",h:"#B2AD99",s:25},
{c:"S 3010-Y30R",f:"Neutrals",h:"#B2AB99",s:25},
{c:"S 3010-Y40R",f:"Neutrals",h:"#B2A899",s:25},
{c:"S 3010-Y50R",f:"Neutrals",h:"#B2A699",s:10},
{c:"S 3010-Y60R",f:"Neutrals",h:"#B2A399",s:10},
{c:"S 3010-Y70R",f:"Neutrals",h:"#B2A199",s:10},
{c:"S 3010-Y80R",f:"Neutrals",h:"#B29E99",s:10},
{c:"S 3010-Y90R",f:"Neutrals",h:"#B29C99",s:10},
{c:"S 3020-B",f:"Blues",h:"#7F7FB2",s:10},
{c:"S 3020-B10G",f:"Blues",h:"#7F85AD",s:10},
{c:"S 3020-B30G",f:"Blues",h:"#7F8FA3",s:25},
{c:"S 3020-B40G",f:"Blues",h:"#7F949E",s:25},
{c:"S 3020-B50G",f:"Blues",h:"#7F9999",s:25},
{c:"S 3020-B60G",f:"Blues",h:"#7F9E94",s:25},
{c:"S 3020-B70G",f:"Blues",h:"#7FA38F",s:25},
{c:"S 3020-B90G",f:"Greens",h:"#7FAD85",s:25},
{c:"S 3020-G",f:"Greens",h:"#7FB27F",s:25},
{c:"S 3020-G10Y",f:"Greens",h:"#85B27F",s:25},
{c:"S 3020-G20Y",f:"Greens",h:"#8AB27F",s:25},
{c:"S 3020-G30Y",f:"Greens",h:"#8FB27F",s:25},
{c:"S 3020-G40Y",f:"Greens",h:"#94B27F",s:25},
{c:"S 3020-G50Y",f:"Greens",h:"#99B27F",s:25},
{c:"S 3020-G60Y",f:"Greens",h:"#9EB27F",s:25},
{c:"S 3020-G70Y",f:"Greens",h:"#A3B27F",s:25},
{c:"S 3020-G80Y",f:"Yellows",h:"#A8B27F",s:25},
{c:"S 3020-G90Y",f:"Yellows",h:"#ADB27F",s:25},
{c:"S 3020-R",f:"Reds",h:"#B27F7F",s:10},
{c:"S 3020-R10B",f:"Reds",h:"#AD7F85",s:10},
{c:"S 3020-R20B",f:"Reds",h:"#A87F8A",s:10},
{c:"S 3020-R30B",f:"Reds",h:"#A37F8F",s:10},
{c:"S 3020-R40B",f:"Reds",h:"#9E7F94",s:10},
{c:"S 3020-R50B",f:"Reds",h:"#997F99",s:10},
{c:"S 3020-R60B",f:"Reds",h:"#947F9E",s:10},
{c:"S 3020-R70B",f:"Reds",h:"#8F7FA3",s:10},
{c:"S 3020-R80B",f:"Blues",h:"#8A7FA8",s:10},
{c:"S 3020-R90B",f:"Blues",h:"#857FAD",s:25},
{c:"S 3020-Y",f:"Yellows",h:"#B2B27F",s:25},
{c:"S 3020-Y10R",f:"Yellows",h:"#B2AD7F",s:25},
{c:"S 3020-Y20R",f:"Yellows",h:"#B2A87F",s:25},
{c:"S 3020-Y30R",f:"Yellows",h:"#B2A37F",s:25},
{c:"S 3020-Y40R",f:"Yellows",h:"#B29E7F",s:25},
{c:"S 3020-Y50R",f:"Yellows",h:"#B2997F",s:25},
{c:"S 3020-Y60R",f:"Yellows",h:"#B2947F",s:25},
{c:"S 3020-Y70R",f:"Yellows",h:"#B28F7F",s:25},
{c:"S 3020-Y80R",f:"Reds",h:"#B28A7F",s:10},
{c:"S 3020-Y90R",f:"Reds",h:"#B2857F",s:10},
{c:"S 3030-B",f:"Blues",h:"#6666B2",s:25},
{c:"S 3030-B10G",f:"Blues",h:"#666EAB",s:10},
{c:"S 3030-B30G",f:"Blues",h:"#667D9C",s:25},
{c:"S 3030-B40G",f:"Blues",h:"#668594",s:25},
{c:"S 3030-B50G",f:"Blues",h:"#668C8C",s:25},
{c:"S 3030-B60G",f:"Blues",h:"#669485",s:25},
{c:"S 3030-B70G",f:"Blues",h:"#669C7D",s:25},
{c:"S 3030-B90G",f:"Greens",h:"#66AB6E",s:25},
{c:"S 3030-G",f:"Greens",h:"#66B266",s:25},
{c:"S 3030-G10Y",f:"Greens",h:"#6EB266",s:25},
{c:"S 3030-G20Y",f:"Greens",h:"#75B266",s:25},
{c:"S 3030-G30Y",f:"Greens",h:"#7DB266",s:25},
{c:"S 3030-G40Y",f:"Greens",h:"#85B266",s:25},
{c:"S 3030-G50Y",f:"Greens",h:"#8CB266",s:25},
{c:"S 3030-G60Y",f:"Greens",h:"#94B266",s:25},
{c:"S 3030-G70Y",f:"Greens",h:"#9CB266",s:25},
{c:"S 3030-G80Y",f:"Yellows",h:"#A3B266",s:25},
{c:"S 3030-G90Y",f:"Yellows",h:"#ABB266",s:25},
{c:"S 3030-R",f:"Reds",h:"#B26666",s:25},
{c:"S 3030-R10B",f:"Reds",h:"#AB666E",s:25},
{c:"S 3030-R20B",f:"Reds",h:"#A36675",s:25},
{c:"S 3030-R30B",f:"Reds",h:"#9C667D",s:25},
{c:"S 3030-R40B",f:"Reds",h:"#946685",s:25},
{c:"S 3030-R50B",f:"Reds",h:"#8C668C",s:25},
{c:"S 3030-R60B",f:"Reds",h:"#856694",s:25},
{c:"S 3030-R70B",f:"Reds",h:"#7D669C",s:25},
{c:"S 3030-R80B",f:"Blues",h:"#7566A3",s:25},
{c:"S 3030-R90B",f:"Blues",h:"#6E66AB",s:25},
{c:"S 3030-Y",f:"Yellows",h:"#B2B266",s:25},
{c:"S 3030-Y10R",f:"Yellows",h:"#B2AB66",s:25},
{c:"S 3030-Y20R",f:"Yellows",h:"#B2A366",s:25},
{c:"S 3030-Y30R",f:"Yellows",h:"#B29C66",s:25},
{c:"S 3030-Y40R",f:"Yellows",h:"#B29466",s:25},
{c:"S 3030-Y50R",f:"Yellows",h:"#B28C66",s:25},
{c:"S 3030-Y60R",f:"Yellows",h:"#B28566",s:25},
{c:"S 3030-Y70R",f:"Yellows",h:"#B27D66",s:25},
{c:"S 3030-Y80R",f:"Reds",h:"#B27566",s:25},
{c:"S 3030-Y90R",f:"Reds",h:"#B26E66",s:25},
{c:"S 3040-B",f:"Blues",h:"#4C4CB2",s:25},
{c:"S 3040-B10G",f:"Blues",h:"#4C57A8",s:25},
{c:"S 3040-B20G",f:"Blues",h:"#4C619E",s:25},
{c:"S 3040-B30G",f:"Blues",h:"#4C6B94",s:25},
{c:"S 3040-B40G",f:"Blues",h:"#4C758A",s:25},
{c:"S 3040-B50G",f:"Blues",h:"#4C7F7F",s:25},
{c:"S 3040-B60G",f:"Blues",h:"#4C8A75",s:25},
{c:"S 3040-B70G",f:"Blues",h:"#4C946B",s:25},
{c:"S 3040-B80G",f:"Greens",h:"#4C9E61",s:25},
{c:"S 3040-B90G",f:"Greens",h:"#4CA857",s:25},
{c:"S 3040-G",f:"Greens",h:"#4CB24C",s:25},
{c:"S 3040-G10Y",f:"Greens",h:"#57B24C",s:25},
{c:"S 3040-G20Y",f:"Greens",h:"#61B24C",s:25},
{c:"S 3040-G30Y",f:"Greens",h:"#6BB24C",s:45},
{c:"S 3040-G40Y",f:"Greens",h:"#75B24C",s:25},
{c:"S 3040-G50Y",f:"Greens",h:"#7FB24C",s:45},
{c:"S 3040-G60Y",f:"Greens",h:"#8AB24C",s:45},
{c:"S 3040-G70Y",f:"Greens",h:"#94B24C",s:25},
{c:"S 3040-G80Y",f:"Yellows",h:"#9EB24C",s:45},
{c:"S 3040-G90Y",f:"Yellows",h:"#A8B24C",s:45},
{c:"S 3040-R",f:"Reds",h:"#B24C4C",s:45},
{c:"S 3040-R10B",f:"Reds",h:"#A84C57",s:25},
{c:"S 3040-R20B",f:"Reds",h:"#9E4C61",s:25},
{c:"S 3040-R30B",f:"Reds",h:"#944C6B",s:25},
{c:"S 3040-R40B",f:"Reds",h:"#8A4C75",s:25},
{c:"S 3040-R50B",f:"Reds",h:"#7F4C7F",s:25},
{c:"S 3040-R60B",f:"Reds",h:"#754C8A",s:25},
{c:"S 3040-R70B",f:"Reds",h:"#6B4C94",s:25},
{c:"S 3040-R80B",f:"Blues",h:"#614C9E",s:25},
{c:"S 3040-R90B",f:"Blues",h:"#574CA8",s:25},
{c:"S 3040-Y",f:"Yellows",h:"#B2B24C",s:45},
{c:"S 3040-Y10R",f:"Yellows",h:"#B2A84C",s:25},
{c:"S 3040-Y20R",f:"Yellows",h:"#B29E4C",s:45},
{c:"S 3040-Y30R",f:"Yellows",h:"#B2944C",s:45},
{c:"S 3040-Y40R",f:"Yellows",h:"#B28A4C",s:25},
{c:"S 3040-Y50R",f:"Yellows",h:"#B27F4C",s:25},
{c:"S 3040-Y60R",f:"Yellows",h:"#B2754C",s:25},
{c:"S 3040-Y70R",f:"Yellows",h:"#B26B4C",s:25},
{c:"S 3040-Y80R",f:"Reds",h:"#B2614C",s:25},
{c:"S 3040-Y90R",f:"Reds",h:"#B2574C",s:25},
{c:"S 3050-B",f:"Blues",h:"#3333B2",s:25},
{c:"S 3050-B10G",f:"Blues",h:"#3340A6",s:25},
{c:"S 3050-B20G",f:"Blues",h:"#334C99",s:25},
{c:"S 3050-B30G",f:"Blues",h:"#33598C",s:25},
{c:"S 3050-B40G",f:"Blues",h:"#33667F",s:25},
{c:"S 3050-B50G",f:"Blues",h:"#337373",s:45},
{c:"S 3050-B60G",f:"Blues",h:"#337F66",s:45},
{c:"S 3050-B70G",f:"Blues",h:"#338C59",s:45},
{c:"S 3050-B80G",f:"Greens",h:"#33994C",s:45},
{c:"S 3050-B90G",f:"Greens",h:"#33A640",s:45},
{c:"S 3050-G",f:"Greens",h:"#33B233",s:45},
{c:"S 3050-G10Y",f:"Greens",h:"#40B233",s:45},
{c:"S 3050-G20Y",f:"Greens",h:"#4CB233",s:45},
{c:"S 3050-G30Y",f:"Greens",h:"#59B233",s:45},
{c:"S 3050-G40Y",f:"Greens",h:"#66B233",s:45},
{c:"S 3050-G50Y",f:"Greens",h:"#73B233",s:45},
{c:"S 3050-G60Y",f:"Greens",h:"#7FB233",s:45},
{c:"S 3050-G70Y",f:"Greens",h:"#8CB233",s:45},
{c:"S 3050-G80Y",f:"Yellows",h:"#99B233",s:45},
{c:"S 3050-G90Y",f:"Yellows",h:"#A6B233",s:45},
{c:"S 3050-R",f:"Reds",h:"#B23333",s:25},
{c:"S 3050-R10B",f:"Reds",h:"#A63340",s:45},
{c:"S 3050-R20B",f:"Reds",h:"#99334C",s:45},
{c:"S 3050-R30B",f:"Reds",h:"#8C3359",s:45},
{c:"S 3050-R40B",f:"Reds",h:"#7F3366",s:45},
{c:"S 3050-R50B",f:"Reds",h:"#733373",s:25},
{c:"S 3050-R60B",f:"Reds",h:"#66337F",s:25},
{c:"S 3050-R70B",f:"Reds",h:"#59338C",s:25},
{c:"S 3050-R80B",f:"Blues",h:"#4C3399",s:25},
{c:"S 3050-R90B",f:"Blues",h:"#4033A6",s:25},
{c:"S 3050-Y",f:"Yellows",h:"#B2B233",s:45},
{c:"S 3050-Y10R",f:"Yellows",h:"#B2A633",s:45},
{c:"S 3050-Y20R",f:"Yellows",h:"#B29933",s:45},
{c:"S 3050-Y30R",f:"Yellows",h:"#B28C33",s:45},
{c:"S 3050-Y40R",f:"Yellows",h:"#B27F33",s:45},
{c:"S 3050-Y50R",f:"Yellows",h:"#B27333",s:45},
{c:"S 3050-Y60R",f:"Yellows",h:"#B26633",s:45},
{c:"S 3050-Y70R",f:"Yellows",h:"#B25933",s:45},
{c:"S 3050-Y80R",f:"Reds",h:"#B24C33",s:45},
{c:"S 3050-Y90R",f:"Reds",h:"#B24033",s:45},
{c:"S 3055-B50G",f:"Blues",h:"#266C6C",s:45},
{c:"S 3055-R30B",f:"Reds",h:"#882650",s:45},
{c:"S 3055-R40B",f:"Reds",h:"#7A265E",s:45},
{c:"S 3055-R50B",f:"Reds",h:"#6C266C",s:25},
{c:"S 3060-B",f:"High chroma accents",h:"#1919B2",s:25},
{c:"S 3060-B10G",f:"High chroma accents",h:"#1929A3",s:45},
{c:"S 3060-B20G",f:"High chroma accents",h:"#193894",s:45},
{c:"S 3060-B30G",f:"High chroma accents",h:"#194785",s:45},
{c:"S 3060-B40G",f:"High chroma accents",h:"#195775",s:45},
{c:"S 3060-B70G",f:"High chroma accents",h:"#198547",s:45},
{c:"S 3060-B90G",f:"High chroma accents",h:"#19A329",s:45},
{c:"S 3060-G",f:"High chroma accents",h:"#19B219",s:45},
{c:"S 3060-G10Y",f:"High chroma accents",h:"#29B219",s:45},
{c:"S 3060-G20Y",f:"High chroma accents",h:"#38B219",s:45},
{c:"S 3060-G30Y",f:"High chroma accents",h:"#47B219",s:45},
{c:"S 3060-G40Y",f:"High chroma accents",h:"#57B219",s:45},
{c:"S 3060-G50Y",f:"High chroma accents",h:"#66B219",s:45},
{c:"S 3060-G60Y",f:"High chroma accents",h:"#75B219",s:45},
{c:"S 3060-G70Y",f:"High chroma accents",h:"#85B219",s:45},
{c:"S 3060-G80Y",f:"High chroma accents",h:"#94B219",s:45},
{c:"S 3060-G90Y",f:"High chroma accents",h:"#A3B219",s:45},
{c:"S 3060-R",f:"High chroma accents",h:"#B21919",s:45},
{c:"S 3060-R10B",f:"High chroma accents",h:"#A31929",s:45},
{c:"S 3060-R20B",f:"High chroma accents",h:"#941938",s:45},
{c:"S 3060-R70B",f:"High chroma accents",h:"#471985",s:45},
{c:"S 3060-R80B",f:"High chroma accents",h:"#381994",s:25},
{c:"S 3060-R90B",f:"High chroma accents",h:"#2919A3",s:25},
{c:"S 3060-Y",f:"High chroma accents",h:"#B2B219",s:45},
{c:"S 3060-Y10R",f:"High chroma accents",h:"#B2A319",s:45},
{c:"S 3060-Y20R",f:"High chroma accents",h:"#B29419",s:45},
{c:"S 3060-Y30R",f:"High chroma accents",h:"#B28519",s:45},
{c:"S 3060-Y40R",f:"High chroma accents",h:"#B27519",s:45},
{c:"S 3060-Y50R",f:"High chroma accents",h:"#B26619",s:45},
{c:"S 3060-Y60R",f:"High chroma accents",h:"#B25719",s:45},
{c:"S 3060-Y70R",f:"High chroma accents",h:"#B24719",s:45},
{c:"S 3060-Y80R",f:"High chroma accents",h:"#B23819",s:45},
{c:"S 3060-Y90R",f:"High chroma accents",h:"#B22919",s:45},
{c:"S 3065-G10Y",f:"High chroma accents",h:"#1DB20D",s:45},
{c:"S 3065-G40Y",f:"High chroma accents",h:"#4FB20D",s:45},
{c:"S 3065-G50Y",f:"High chroma accents",h:"#60B20D",s:45},
{c:"S 3065-G60Y",f:"High chroma accents",h:"#70B20D",s:45},
{c:"S 3065-R90B",f:"High chroma accents",h:"#1D0DA2",s:45},
{c:"S 3065-Y20R",f:"High chroma accents",h:"#B2910D",s:45},
{c:"S 3500-N",f:"Neutrals",h:"#A6A6A6",s:10},
{c:"S 3502-B",f:"Neutrals",h:"#A1A1A6",s:10},
{c:"S 3502-B50G",f:"Neutrals",h:"#A1A3A3",s:10},
{c:"S 3502-G",f:"Neutrals",h:"#A1A6A1",s:10},
{c:"S 3502-G50G",f:"Neutrals",h:"#A1A6A1",s:10},
{c:"S 3502-G50Y",f:"Neutrals",h:"#A3A6A1",s:10},
{c:"S 3502-R",f:"Neutrals",h:"#A6A1A1",s:10},
{c:"S 3502-R50B",f:"Neutrals",h:"#A3A1A3",s:10},
{c:"S 3502-Y",f:"Neutrals",h:"#A6A6A1",s:10},
{c:"S 3502-Y20R",f:"Neutrals",h:"#A6A5A1",s:10},
{c:"S 3502-Y50R",f:"Neutrals",h:"#A6A3A1",s:10},
{c:"S 3502-Y80R",f:"Neutrals",h:"#A6A2A1",s:10},
{c:"S 3550-Y20R",f:"Yellows",h:"#A68C26",s:45},
{c:"S 3555-B60G",f:"Blues",h:"#196E52",s:45},
{c:"S 3555-B80G",f:"Greens",h:"#198A36",s:45},
{c:"S 3555-R60B",f:"Reds",h:"#52196E",s:45},
{c:"S 3560-G",f:"High chroma accents",h:"#0DA60D",s:45},
{c:"S 3560-G10Y",f:"High chroma accents",h:"#1CA60D",s:45},
{c:"S 3560-G20Y",f:"High chroma accents",h:"#2BA60D",s:45},
{c:"S 3560-G30Y",f:"High chroma accents",h:"#3BA60D",s:45},
{c:"S 3560-G40Y",f:"High chroma accents",h:"#4AA60D",s:45},
{c:"S 3560-G50Y",f:"High chroma accents",h:"#59A60D",s:45},
{c:"S 3560-G60Y",f:"High chroma accents",h:"#69A60D",s:45},
{c:"S 3560-G70Y",f:"High chroma accents",h:"#78A60D",s:45},
{c:"S 3560-R",f:"High chroma accents",h:"#A60D0D",s:45},
{c:"S 3560-R80B",f:"High chroma accents",h:"#2B0D87",s:45},
{c:"S 3560-R90B",f:"High chroma accents",h:"#1C0D96",s:45},
{c:"S 3560-Y",f:"High chroma accents",h:"#A6A60D",s:45},
{c:"S 3560-Y20R",f:"High chroma accents",h:"#A6870D",s:45},
{c:"S 3560-Y30R",f:"High chroma accents",h:"#A6780D",s:45},
{c:"S 3560-Y40R",f:"High chroma accents",h:"#A6690D",s:45},
{c:"S 3560-Y50R",f:"High chroma accents",h:"#A6590D",s:45},
{c:"S 3560-Y60R",f:"High chroma accents",h:"#A64A0D",s:45},
{c:"S 3560-Y70R",f:"High chroma accents",h:"#A63B0D",s:45},
{c:"S 3560-Y80R",f:"High chroma accents",h:"#A62B0D",s:45},
{c:"S 3560-Y90R",f:"High chroma accents",h:"#A61C0D",s:45},
{c:"S 4000-N",f:"Neutrals",h:"#999999",s:10},
{c:"S 4005-B",f:"Neutrals",h:"#8C8C99",s:10},
{c:"S 4005-B20G",f:"Neutrals",h:"#8C8F96",s:10},
{c:"S 4005-B50G",f:"Neutrals",h:"#8C9393",s:10},
{c:"S 4005-B80G",f:"Neutrals",h:"#8C968F",s:25},
{c:"S 4005-G",f:"Neutrals",h:"#8C998C",s:10},
{c:"S 4005-G20Y",f:"Neutrals",h:"#8F998C",s:25},
{c:"S 4005-G50Y",f:"Neutrals",h:"#93998C",s:25},
{c:"S 4005-G80Y",f:"Neutrals",h:"#96998C",s:25},
{c:"S 4005-R",f:"Neutrals",h:"#998C8C",s:10},
{c:"S 4005-R20B",f:"Neutrals",h:"#968C8F",s:25},
{c:"S 4005-R50B",f:"Neutrals",h:"#938C93",s:10},
{c:"S 4005-R80B",f:"Neutrals",h:"#8F8C96",s:10},
{c:"S 4005-Y",f:"Neutrals",h:"#99998C",s:10},
{c:"S 4005-Y20R",f:"Neutrals",h:"#99968C",s:25},
{c:"S 4005-Y50R",f:"Neutrals",h:"#99938C",s:25},
{c:"S 4005-Y80R",f:"Neutrals",h:"#998F8C",s:10},
{c:"S 4010-B10G",f:"Neutrals",h:"#808296",s:25},
{c:"S 4010-B30G",f:"Neutrals",h:"#808791",s:25},
{c:"S 4010-B50G",f:"Neutrals",h:"#808C8C",s:25},
{c:"S 4010-B70G",f:"Neutrals",h:"#809187",s:25},
{c:"S 4010-B90G",f:"Neutrals",h:"#809682",s:25},
{c:"S 4010-G10Y",f:"Neutrals",h:"#829980",s:25},
{c:"S 4010-G30Y",f:"Neutrals",h:"#879980",s:25},
{c:"S 4010-G50Y",f:"Neutrals",h:"#8C9980",s:25},
{c:"S 4010-G70Y",f:"Neutrals",h:"#919980",s:25},
{c:"S 4010-G90Y",f:"Neutrals",h:"#969980",s:25},
{c:"S 4010-R10B",f:"Neutrals",h:"#968082",s:25},
{c:"S 4010-R30B",f:"Neutrals",h:"#918087",s:25},
{c:"S 4010-R50B",f:"Neutrals",h:"#8C808C",s:25},
{c:"S 4010-R70B",f:"Neutrals",h:"#878091",s:10},
{c:"S 4010-R90B",f:"Neutrals",h:"#828096",s:25},
{c:"S 4010-Y10R",f:"Neutrals",h:"#999680",s:25},
{c:"S 4010-Y30R",f:"Neutrals",h:"#999180",s:25},
{c:"S 4010-Y50R",f:"Neutrals",h:"#998C80",s:25},
{c:"S 4010-Y70R",f:"Neutrals",h:"#998780",s:25},
{c:"S 4010-Y90R",f:"Neutrals",h:"#998280",s:10},
{c:"S 4020-B",f:"Blues",h:"#666699",s:25},
{c:"S 4020-B10G",f:"Blues",h:"#666B94",s:25},
{c:"S 4020-B30G",f:"Blues",h:"#66758A",s:25},
{c:"S 4020-B50G",f:"Blues",h:"#668080",s:25},
{c:"S 4020-B70G",f:"Blues",h:"#668A75",s:25},
{c:"S 4020-B90G",f:"Greens",h:"#66946B",s:25},
{c:"S 4020-G",f:"Greens",h:"#669966",s:25},
{c:"S 4020-G10Y",f:"Greens",h:"#6B9966",s:25},
{c:"S 4020-G30Y",f:"Greens",h:"#759966",s:25},
{c:"S 4020-G50Y",f:"Greens",h:"#809966",s:25},
{c:"S 4020-G70Y",f:"Greens",h:"#8A9966",s:25},
{c:"S 4020-G90Y",f:"Yellows",h:"#949966",s:25},
{c:"S 4020-R",f:"Reds",h:"#996666",s:25},
{c:"S 4020-R10B",f:"Reds",h:"#94666B",s:25},
{c:"S 4020-R20B",f:"Reds",h:"#8F6670",s:25},
{c:"S 4020-R30B",f:"Reds",h:"#8A6675",s:25},
{c:"S 4020-R40B",f:"Reds",h:"#85667A",s:25},
{c:"S 4020-R50B",f:"Reds",h:"#806680",s:25},
{c:"S 4020-R60B",f:"Reds",h:"#7A6685",s:25},
{c:"S 4020-R70B",f:"Reds",h:"#75668A",s:25},
{c:"S 4020-R80B",f:"Blues",h:"#70668F",s:25},
{c:"S 4020-R90B",f:"Blues",h:"#6B6694",s:25},
{c:"S 4020-Y",f:"Yellows",h:"#999966",s:25},
{c:"S 4020-Y10R",f:"Yellows",h:"#999466",s:25},
{c:"S 4020-Y20R",f:"Yellows",h:"#998F66",s:25},
{c:"S 4020-Y30R",f:"Yellows",h:"#998A66",s:25},
{c:"S 4020-Y40R",f:"Yellows",h:"#998566",s:25},
{c:"S 4020-Y50R",f:"Yellows",h:"#998066",s:25},
{c:"S 4020-Y60R",f:"Yellows",h:"#997A66",s:25},
{c:"S 4020-Y70R",f:"Yellows",h:"#997566",s:25},
{c:"S 4020-Y80R",f:"Reds",h:"#997066",s:25},
{c:"S 4020-Y90R",f:"Reds",h:"#996B66",s:10},
{c:"S 4030-B",f:"Blues",h:"#4C4C99",s:25},
{c:"S 4030-B10G",f:"Blues",h:"#4C5491",s:25},
{c:"S 4030-B30G",f:"Blues",h:"#4C6382",s:25},
{c:"S 4030-B50G",f:"Blues",h:"#4C7373",s:25},
{c:"S 4030-B70G",f:"Blues",h:"#4C8263",s:25},
{c:"S 4030-B90G",f:"Greens",h:"#4C9154",s:25},
{c:"S 4030-G",f:"Greens",h:"#4C994C",s:45},
{c:"S 4030-G10Y",f:"Greens",h:"#54994C",s:45},
{c:"S 4030-G30Y",f:"Greens",h:"#63994C",s:45},
{c:"S 4030-G50Y",f:"Greens",h:"#73994C",s:45},
{c:"S 4030-G70Y",f:"Greens",h:"#82994C",s:45},
{c:"S 4030-G90Y",f:"Yellows",h:"#91994C",s:45},
{c:"S 4030-R",f:"Reds",h:"#994C4C",s:45},
{c:"S 4030-R10B",f:"Reds",h:"#914C54",s:45},
{c:"S 4030-R20B",f:"Reds",h:"#8A4C5C",s:25},
{c:"S 4030-R30B",f:"Reds",h:"#824C63",s:25},
{c:"S 4030-R40B",f:"Reds",h:"#7A4C6B",s:25},
{c:"S 4030-R50B",f:"Reds",h:"#734C73",s:25},
{c:"S 4030-R60B",f:"Reds",h:"#6B4C7A",s:25},
{c:"S 4030-R70B",f:"Reds",h:"#634C82",s:25},
{c:"S 4030-R80B",f:"Blues",h:"#5C4C8A",s:25},
{c:"S 4030-R90B",f:"Blues",h:"#544C91",s:25},
{c:"S 4030-Y",f:"Yellows",h:"#99994C",s:45},
{c:"S 4030-Y10R",f:"Yellows",h:"#99914C",s:45},
{c:"S 4030-Y20R",f:"Yellows",h:"#998A4C",s:45},
{c:"S 4030-Y30R",f:"Yellows",h:"#99824C",s:25},
{c:"S 4030-Y40R",f:"Yellows",h:"#997A4C",s:25},
{c:"S 4030-Y50R",f:"Yellows",h:"#99734C",s:25},
{c:"S 4030-Y60R",f:"Yellows",h:"#996B4C",s:25},
{c:"S 4030-Y70R",f:"Yellows",h:"#99634C",s:25},
{c:"S 4030-Y80R",f:"Reds",h:"#995C4C",s:25},
{c:"S 4030-Y90R",f:"Reds",h:"#99544C",s:45},
{c:"S 4040-B",f:"Blues",h:"#333399",s:25},
{c:"S 4040-B10G",f:"Blues",h:"#333D8F",s:25},
{c:"S 4040-B20G",f:"Blues",h:"#334785",s:25},
{c:"S 4040-B30G",f:"Blues",h:"#33527A",s:25},
{c:"S 4040-B40G",f:"Blues",h:"#335C70",s:45},
{c:"S 4040-B50G",f:"Blues",h:"#336666",s:45},
{c:"S 4040-B60G",f:"Blues",h:"#33705C",s:45},
{c:"S 4040-B70G",f:"Blues",h:"#337A52",s:45},
{c:"S 4040-B80G",f:"Greens",h:"#338547",s:45},
{c:"S 4040-B90G",f:"Greens",h:"#338F3D",s:45},
{c:"S 4040-G",f:"Greens",h:"#339933",s:45},
{c:"S 4040-G10Y",f:"Greens",h:"#3D9933",s:45},
{c:"S 4040-G20Y",f:"Greens",h:"#479933",s:45},
{c:"S 4040-G30Y",f:"Greens",h:"#529933",s:45},
{c:"S 4040-G40Y",f:"Greens",h:"#5C9933",s:45},
{c:"S 4040-G50Y",f:"Greens",h:"#669933",s:45},
{c:"S 4040-G60Y",f:"Greens",h:"#709933",s:45},
{c:"S 4040-G70Y",f:"Greens",h:"#7A9933",s:45},
{c:"S 4040-G80Y",f:"Yellows",h:"#859933",s:45},
{c:"S 4040-G90Y",f:"Yellows",h:"#8F9933",s:45},
{c:"S 4040-R",f:"Reds",h:"#993333",s:25},
{c:"S 4040-R10B",f:"Reds",h:"#8F333D",s:45},
{c:"S 4040-R20B",f:"Reds",h:"#853347",s:45},
{c:"S 4040-R30B",f:"Reds",h:"#7A3352",s:45},
{c:"S 4040-R40B",f:"Reds",h:"#70335C",s:25},
{c:"S 4040-R50B",f:"Reds",h:"#663366",s:25},
{c:"S 4040-R60B",f:"Reds",h:"#5C3370",s:25},
{c:"S 4040-R70B",f:"Reds",h:"#52337A",s:25},
{c:"S 4040-R80B",f:"Blues",h:"#473385",s:25},
{c:"S 4040-R90B",f:"Blues",h:"#3D338F",s:25},
{c:"S 4040-Y",f:"Yellows",h:"#999933",s:45},
{c:"S 4040-Y10R",f:"Yellows",h:"#998F33",s:45},
{c:"S 4040-Y20R",f:"Yellows",h:"#998533",s:45},
{c:"S 4040-Y30R",f:"Yellows",h:"#997A33",s:45},
{c:"S 4040-Y40R",f:"Yellows",h:"#997033",s:45},
{c:"S 4040-Y50R",f:"Yellows",h:"#996633",s:45},
{c:"S 4040-Y60R",f:"Yellows",h:"#995C33",s:45},
{c:"S 4040-Y70R",f:"Yellows",h:"#995233",s:45},
{c:"S 4040-Y80R",f:"Reds",h:"#994733",s:25},
{c:"S 4040-Y90R",f:"Reds",h:"#993D33",s:25},
{c:"S 4050-B",f:"Blues",h:"#191999",s:25},
{c:"S 4050-B10G",f:"Blues",h:"#19268C",s:45},
{c:"S 4050-B20G",f:"Blues",h:"#193380",s:45},
{c:"S 4050-B30G",f:"Blues",h:"#194073",s:45},
{c:"S 4050-B40G",f:"Blues",h:"#194C66",s:45},
{c:"S 4050-B50G",f:"Blues",h:"#195959",s:45},
{c:"S 4050-B60G",f:"Blues",h:"#19664C",s:45},
{c:"S 4050-B70G",f:"Blues",h:"#197340",s:45},
{c:"S 4050-B80G",f:"Greens",h:"#198033",s:45},
{c:"S 4050-B90G",f:"Greens",h:"#198C26",s:45},
{c:"S 4050-G",f:"Greens",h:"#199919",s:45},
{c:"S 4050-G10Y",f:"Greens",h:"#269919",s:45},
{c:"S 4050-G20Y",f:"Greens",h:"#339919",s:45},
{c:"S 4050-G30Y",f:"Greens",h:"#409919",s:45},
{c:"S 4050-G40Y",f:"Greens",h:"#4C9919",s:45},
{c:"S 4050-G50Y",f:"Greens",h:"#599919",s:45},
{c:"S 4050-G60Y",f:"Greens",h:"#669919",s:45},
{c:"S 4050-G70Y",f:"Greens",h:"#739919",s:45},
{c:"S 4050-G80Y",f:"Yellows",h:"#809919",s:45},
{c:"S 4050-G90Y",f:"Yellows",h:"#8C9919",s:45},
{c:"S 4050-R",f:"Reds",h:"#991919",s:45},
{c:"S 4050-R10B",f:"Reds",h:"#8C1926",s:45},
{c:"S 4050-R20B",f:"Reds",h:"#801933",s:45},
{c:"S 4050-R30B",f:"Reds",h:"#731940",s:45},
{c:"S 4050-R40B",f:"Reds",h:"#66194C",s:45},
{c:"S 4050-R50B",f:"Reds",h:"#591959",s:45},
{c:"S 4050-R60B",f:"Reds",h:"#4C1966",s:45},
{c:"S 4050-R70B",f:"Reds",h:"#401973",s:45},
{c:"S 4050-R80B",f:"Blues",h:"#331980",s:45},
{c:"S 4050-R90B",f:"Blues",h:"#26198C",s:45},
{c:"S 4050-Y",f:"Yellows",h:"#999919",s:45},
{c:"S 4050-Y10R",f:"Yellows",h:"#998C19",s:45},
{c:"S 4050-Y20R",f:"Yellows",h:"#998019",s:45},
{c:"S 4050-Y30R",f:"Yellows",h:"#997319",s:45},
{c:"S 4050-Y40R",f:"Yellows",h:"#996619",s:45},
{c:"S 4050-Y50R",f:"Yellows",h:"#995919",s:45},
{c:"S 4050-Y60R",f:"Yellows",h:"#994C19",s:45},
{c:"S 4050-Y70R",f:"Yellows",h:"#994019",s:45},
{c:"S 4050-Y80R",f:"Reds",h:"#993319",s:45},
{c:"S 4050-Y90R",f:"Reds",h:"#992619",s:45},
{c:"S 4055-B",f:"Blues",h:"#0D0D99",s:45},
{c:"S 4055-B40G",f:"Blues",h:"#0D4561",s:45},
{c:"S 4055-R70B",f:"Reds",h:"#370D6F",s:45},
{c:"S 4055-Y10R",f:"Yellows",h:"#998B0D",s:45},
{c:"S 4500-N",f:"Neutrals",h:"#8C8C8C",s:10},
{c:"S 4502-B",f:"Neutrals",h:"#87878C",s:10},
{c:"S 4502-B50G",f:"Neutrals",h:"#878A8A",s:10},
{c:"S 4502-G",f:"Neutrals",h:"#878C87",s:25},
{c:"S 4502-G50Y",f:"Neutrals",h:"#8A8C87",s:10},
{c:"S 4502-R",f:"Neutrals",h:"#8C8787",s:10},
{c:"S 4502-R50B",f:"Neutrals",h:"#8A878A",s:10},
{c:"S 4502-Y",f:"Neutrals",h:"#8C8C87",s:25},
{c:"S 4502-Y20R",f:"Neutrals",h:"#8C8B87",s:10},
{c:"S 4502-Y50R",f:"Neutrals",h:"#8C8A87",s:10},
{c:"S 4502-Y80R",f:"Neutrals",h:"#8C8887",s:10},
{c:"S 4550-B",f:"Blues",h:"#0D0D8C",s:45},
{c:"S 4550-B20G",f:"Blues",h:"#0D2673",s:45},
{c:"S 4550-B30G",f:"Blues",h:"#0D3366",s:45},
{c:"S 4550-B40G",f:"Blues",h:"#0D4059",s:45},
{c:"S 4550-B50G",f:"Blues",h:"#0D4D4D",s:45},
{c:"S 4550-B80G",f:"Greens",h:"#0D7326",s:45},
{c:"S 4550-B90G",f:"Greens",h:"#0D801A",s:45},
{c:"S 4550-G",f:"Greens",h:"#0D8C0D",s:45},
{c:"S 4550-G10Y",f:"Greens",h:"#1A8C0D",s:45},
{c:"S 4550-G20Y",f:"Greens",h:"#268C0D",s:45},
{c:"S 4550-G30Y",f:"Greens",h:"#338C0D",s:45},
{c:"S 4550-G40Y",f:"Greens",h:"#408C0D",s:45},
{c:"S 4550-G50Y",f:"Greens",h:"#4D8C0D",s:45},
{c:"S 4550-G60Y",f:"Greens",h:"#598C0D",s:45},
{c:"S 4550-G70Y",f:"Greens",h:"#668C0D",s:45},
{c:"S 4550-R70B",f:"Reds",h:"#330D66",s:45},
{c:"S 4550-R80B",f:"Blues",h:"#260D73",s:45},
{c:"S 4550-R90B",f:"Blues",h:"#1A0D80",s:45},
{c:"S 4550-Y",f:"Yellows",h:"#8C8C0D",s:45},
{c:"S 4550-Y30R",f:"Yellows",h:"#8C660D",s:45},
{c:"S 4550-Y40R",f:"Yellows",h:"#8C590D",s:45},
{c:"S 4550-Y50R",f:"Yellows",h:"#8C4D0D",s:45},
{c:"S 4550-Y60R",f:"Yellows",h:"#8C400D",s:45},
{c:"S 4550-Y70R",f:"Yellows",h:"#8C330D",s:45},
{c:"S 4550-Y80R",f:"Reds",h:"#8C260D",s:45},
{c:"S 4550-Y90R",f:"Reds",h:"#8C1A0D",s:45},
{c:"S 5000-N",f:"Neutrals",h:"#808080",s:25},
{c:"S 5005-B",f:"Neutrals",h:"#737380",s:10},
{c:"S 5005-B20G",f:"Neutrals",h:"#73757D",s:25},
{c:"S 5005-B50G",f:"Neutrals",h:"#737979",s:10},
{c:"S 5005-B80G",f:"Neutrals",h:"#737D75",s:25},
{c:"S 5005-G",f:"Neutrals",h:"#738073",s:10},
{c:"S 5005-G20Y",f:"Neutrals",h:"#758073",s:25},
{c:"S 5005-G50Y",f:"Neutrals",h:"#798073",s:25},
{c:"S 5005-G80Y",f:"Neutrals",h:"#7D8073",s:25},
{c:"S 5005-R",f:"Neutrals",h:"#807373",s:10},
{c:"S 5005-R20B",f:"Neutrals",h:"#7D7375",s:25},
{c:"S 5005-R50B",f:"Neutrals",h:"#797379",s:25},
{c:"S 5005-R80B",f:"Neutrals",h:"#75737D",s:25},
{c:"S 5005-Y",f:"Neutrals",h:"#808073",s:25},
{c:"S 5005-Y20R",f:"Neutrals",h:"#807D73",s:25},
{c:"S 5005-Y50R",f:"Neutrals",h:"#807973",s:25},
{c:"S 5005-Y80R",f:"Neutrals",h:"#807573",s:25},
{c:"S 5010-B10G",f:"Neutrals",h:"#66697D",s:25},
{c:"S 5010-B30G",f:"Neutrals",h:"#666E78",s:25},
{c:"S 5010-B50G",f:"Neutrals",h:"#667373",s:25},
{c:"S 5010-B70G",f:"Neutrals",h:"#66786E",s:25},
{c:"S 5010-B90G",f:"Neutrals",h:"#667D69",s:25},
{c:"S 5010-G10Y",f:"Neutrals",h:"#698066",s:25},
{c:"S 5010-G30Y",f:"Neutrals",h:"#6E8066",s:25},
{c:"S 5010-G50Y",f:"Neutrals",h:"#738066",s:25},
{c:"S 5010-G70Y",f:"Neutrals",h:"#788066",s:25},
{c:"S 5010-G90Y",f:"Neutrals",h:"#7D8066",s:25},
{c:"S 5010-R10B",f:"Neutrals",h:"#7D6669",s:25},
{c:"S 5010-R30B",f:"Neutrals",h:"#78666E",s:25},
{c:"S 5010-R50B",f:"Neutrals",h:"#736673",s:25},
{c:"S 5010-R70B",f:"Neutrals",h:"#6E6678",s:25},
{c:"S 5010-R90B",f:"Neutrals",h:"#69667D",s:25},
{c:"S 5010-Y10R",f:"Neutrals",h:"#807D66",s:25},
{c:"S 5010-Y30R",f:"Neutrals",h:"#807866",s:25},
{c:"S 5010-Y50R",f:"Neutrals",h:"#807366",s:25},
{c:"S 5010-Y70R",f:"Neutrals",h:"#806E66",s:25},
{c:"S 5010-Y90R",f:"Neutrals",h:"#806966",s:25},
{c:"S 5020-B",f:"Blues",h:"#4C4C80",s:25},
{c:"S 5020-B10G",f:"Blues",h:"#4C527A",s:25},
{c:"S 5020-B30G",f:"Blues",h:"#4C5C70",s:25},
{c:"S 5020-B50G",f:"Blues",h:"#4C6666",s:25},
{c:"S 5020-B70G",f:"Blues",h:"#4C705C",s:25},
{c:"S 5020-B90G",f:"Greens",h:"#4C7A52",s:25},
{c:"S 5020-G",f:"Greens",h:"#4C804C",s:25},
{c:"S 5020-G10Y",f:"Greens",h:"#52804C",s:45},
{c:"S 5020-G30Y",f:"Greens",h:"#5C804C",s:45},
{c:"S 5020-G50Y",f:"Greens",h:"#66804C",s:45},
{c:"S 5020-G70Y",f:"Greens",h:"#70804C",s:25},
{c:"S 5020-G90Y",f:"Yellows",h:"#7A804C",s:25},
{c:"S 5020-R",f:"Reds",h:"#804C4C",s:25},
{c:"S 5020-R10B",f:"Reds",h:"#7A4C52",s:25},
{c:"S 5020-R20B",f:"Reds",h:"#754C57",s:25},
{c:"S 5020-R30B",f:"Reds",h:"#704C5C",s:25},
{c:"S 5020-R40B",f:"Reds",h:"#6B4C61",s:25},
{c:"S 5020-R50B",f:"Reds",h:"#664C66",s:25},
{c:"S 5020-R60B",f:"Reds",h:"#614C6B",s:25},
{c:"S 5020-R70B",f:"Reds",h:"#5C4C70",s:25},
{c:"S 5020-R80B",f:"Blues",h:"#574C75",s:25},
{c:"S 5020-R90B",f:"Blues",h:"#524C7A",s:25},
{c:"S 5020-Y",f:"Yellows",h:"#80804C",s:45},
{c:"S 5020-Y10R",f:"Yellows",h:"#807A4C",s:45},
{c:"S 5020-Y20R",f:"Yellows",h:"#80754C",s:45},
{c:"S 5020-Y30R",f:"Yellows",h:"#80704C",s:45},
{c:"S 5020-Y40R",f:"Yellows",h:"#806B4C",s:25},
{c:"S 5020-Y50R",f:"Yellows",h:"#80664C",s:25},
{c:"S 5020-Y60R",f:"Yellows",h:"#80614C",s:25},
{c:"S 5020-Y70R",f:"Yellows",h:"#805C4C",s:25},
{c:"S 5020-Y80R",f:"Reds",h:"#80574C",s:25},
{c:"S 5020-Y90R",f:"Reds",h:"#80524C",s:25},
{c:"S 5030-B",f:"Blues",h:"#333380",s:45},
{c:"S 5030-B10G",f:"Blues",h:"#333B78",s:25},
{c:"S 5030-B30G",f:"Blues",h:"#334A69",s:25},
{c:"S 5030-B50G",f:"Blues",h:"#335959",s:45},
{c:"S 5030-B70G",f:"Blues",h:"#33694A",s:45},
{c:"S 5030-B90G",f:"Greens",h:"#33783B",s:45},
{c:"S 5030-G",f:"Greens",h:"#338033",s:45},
{c:"S 5030-G10Y",f:"Greens",h:"#3B8033",s:45},
{c:"S 5030-G30Y",f:"Greens",h:"#4A8033",s:45},
{c:"S 5030-G50Y",f:"Greens",h:"#598033",s:45},
{c:"S 5030-G70Y",f:"Greens",h:"#698033",s:45},
{c:"S 5030-G90Y",f:"Yellows",h:"#788033",s:45},
{c:"S 5030-R",f:"Reds",h:"#803333",s:45},
{c:"S 5030-R10B",f:"Reds",h:"#78333B",s:45},
{c:"S 5030-R20B",f:"Reds",h:"#703342",s:45},
{c:"S 5030-R30B",f:"Reds",h:"#69334A",s:45},
{c:"S 5030-R40B",f:"Reds",h:"#613352",s:25},
{c:"S 5030-R50B",f:"Reds",h:"#593359",s:25},
{c:"S 5030-R60B",f:"Reds",h:"#523361",s:45},
{c:"S 5030-R70B",f:"Reds",h:"#4A3369",s:25},
{c:"S 5030-R80B",f:"Blues",h:"#423370",s:25},
{c:"S 5030-R90B",f:"Blues",h:"#3B3378",s:45},
{c:"S 5030-Y",f:"Yellows",h:"#808033",s:45},
{c:"S 5030-Y10R",f:"Yellows",h:"#807833",s:45},
{c:"S 5030-Y20R",f:"Yellows",h:"#807033",s:45},
{c:"S 5030-Y30R",f:"Yellows",h:"#806933",s:45},
{c:"S 5030-Y40R",f:"Yellows",h:"#806133",s:45},
{c:"S 5030-Y50R",f:"Yellows",h:"#805933",s:45},
{c:"S 5030-Y60R",f:"Yellows",h:"#805233",s:45},
{c:"S 5030-Y70R",f:"Yellows",h:"#804A33",s:45},
{c:"S 5030-Y80R",f:"Reds",h:"#804233",s:25},
{c:"S 5030-Y90R",f:"Reds",h:"#803B33",s:45},
{c:"S 5040-B",f:"Blues",h:"#191980",s:45},
{c:"S 5040-B10G",f:"Blues",h:"#192475",s:45},
{c:"S 5040-B20G",f:"Blues",h:"#192E6B",s:45},
{c:"S 5040-B30G",f:"Blues",h:"#193861",s:45},
{c:"S 5040-B40G",f:"Blues",h:"#194257",s:45},
{c:"S 5040-B50G",f:"Blues",h:"#194C4C",s:45},
{c:"S 5040-B60G",f:"Blues",h:"#195742",s:45},
{c:"S 5040-B70G",f:"Blues",h:"#196138",s:45},
{c:"S 5040-B80G",f:"Greens",h:"#196B2E",s:45},
{c:"S 5040-B90G",f:"Greens",h:"#197524",s:45},
{c:"S 5040-G",f:"Greens",h:"#198019",s:45},
{c:"S 5040-G10Y",f:"Greens",h:"#248019",s:45},
{c:"S 5040-G20Y",f:"Greens",h:"#2E8019",s:45},
{c:"S 5040-G30Y",f:"Greens",h:"#388019",s:45},
{c:"S 5040-G40Y",f:"Greens",h:"#428019",s:45},
{c:"S 5040-G50Y",f:"Greens",h:"#4C8019",s:45},
{c:"S 5040-G60Y",f:"Greens",h:"#578019",s:45},
{c:"S 5040-G70Y",f:"Greens",h:"#618019",s:45},
{c:"S 5040-G80Y",f:"Yellows",h:"#6B8019",s:45},
{c:"S 5040-G90Y",f:"Yellows",h:"#758019",s:45},
{c:"S 5040-R",f:"Reds",h:"#801919",s:45},
{c:"S 5040-R10B",f:"Reds",h:"#751924",s:45},
{c:"S 5040-R20B",f:"Reds",h:"#6B192E",s:45},
{c:"S 5040-R30B",f:"Reds",h:"#611938",s:45},
{c:"S 5040-R40B",f:"Reds",h:"#571942",s:45},
{c:"S 5040-R50B",f:"Reds",h:"#4C194C",s:45},
{c:"S 5040-R60B",f:"Reds",h:"#421957",s:45},
{c:"S 5040-R70B",f:"Reds",h:"#381961",s:45},
{c:"S 5040-R80B",f:"Blues",h:"#2E196B",s:45},
{c:"S 5040-R90B",f:"Blues",h:"#241975",s:45},
{c:"S 5040-Y",f:"Yellows",h:"#808019",s:45},
{c:"S 5040-Y10R",f:"Yellows",h:"#807519",s:45},
{c:"S 5040-Y20R",f:"Yellows",h:"#806B19",s:45},
{c:"S 5040-Y30R",f:"Yellows",h:"#806119",s:45},
{c:"S 5040-Y40R",f:"Yellows",h:"#805719",s:45},
{c:"S 5040-Y50R",f:"Yellows",h:"#804C19",s:45},
{c:"S 5040-Y60R",f:"Yellows",h:"#804219",s:45},
{c:"S 5040-Y70R",f:"Yellows",h:"#803819",s:45},
{c:"S 5040-Y80R",f:"Reds",h:"#802E19",s:45},
{c:"S 5040-Y90R",f:"Reds",h:"#802419",s:45},
{c:"S 5045-B10G",f:"Blues",h:"#0D1874",s:45},
{c:"S 5050-R70B",f:"Reds",h:"#260059",s:45},
{c:"S 5500-N",f:"Neutrals",h:"#737373",s:25},
{c:"S 5502-B",f:"Neutrals",h:"#6E6E73",s:25},
{c:"S 5502-B50G",f:"Neutrals",h:"#6E7070",s:10},
{c:"S 5502-G",f:"Neutrals",h:"#6E736E",s:25},
{c:"S 5502-G50Y",f:"Neutrals",h:"#70736E",s:10},
{c:"S 5502-R",f:"Neutrals",h:"#736E6E",s:25},
{c:"S 5502-R50B",f:"Neutrals",h:"#706E70",s:10},
{c:"S 5502-Y",f:"Neutrals",h:"#73736E",s:25},
{c:"S 5502-Y20R",f:"Neutrals",h:"#73726E",s:10},
{c:"S 5502-Y50R",f:"Neutrals",h:"#73706E",s:10},
{c:"S 5502-Y80R",f:"Neutrals",h:"#736F6E",s:10},
{c:"S 5540-B",f:"Blues",h:"#0D0D73",s:45},
{c:"S 5540-B10G",f:"Blues",h:"#0D1769",s:45},
{c:"S 5540-B20G",f:"Blues",h:"#0D215E",s:45},
{c:"S 5540-B30G",f:"Blues",h:"#0D2B54",s:45},
{c:"S 5540-B40G",f:"Blues",h:"#0D364A",s:45},
{c:"S 5540-B50G",f:"Blues",h:"#0D4040",s:45},
{c:"S 5540-B80G",f:"Greens",h:"#0D5E21",s:45},
{c:"S 5540-B90G",f:"Greens",h:"#0D6917",s:45},
{c:"S 5540-G",f:"Greens",h:"#0D730D",s:45},
{c:"S 5540-G10Y",f:"Greens",h:"#17730D",s:45},
{c:"S 5540-G20Y",f:"Greens",h:"#21730D",s:45},
{c:"S 5540-G30Y",f:"Greens",h:"#2B730D",s:45},
{c:"S 5540-G40Y",f:"Greens",h:"#36730D",s:45},
{c:"S 5540-G50Y",f:"Greens",h:"#40730D",s:45},
{c:"S 5540-G60Y",f:"Greens",h:"#4A730D",s:45},
{c:"S 5540-G70Y",f:"Greens",h:"#54730D",s:45},
{c:"S 5540-R70B",f:"Reds",h:"#2B0D54",s:45},
{c:"S 5540-R90B",f:"Blues",h:"#170D69",s:45},
{c:"S 5540-Y90R",f:"Reds",h:"#73170D",s:45},
{c:"S 6000-N",f:"Neutrals",h:"#666666",s:25},
{c:"S 6005-B",f:"Neutrals",h:"#595966",s:10},
{c:"S 6005-B20G",f:"Neutrals",h:"#595C63",s:25},
{c:"S 6005-B50G",f:"Neutrals",h:"#596060",s:25},
{c:"S 6005-B80G",f:"Neutrals",h:"#59635C",s:25},
{c:"S 6005-G",f:"Neutrals",h:"#596659",s:25},
{c:"S 6005-G20Y",f:"Neutrals",h:"#5C6659",s:25},
{c:"S 6005-G50Y",f:"Neutrals",h:"#606659",s:25},
{c:"S 6005-G80Y",f:"Neutrals",h:"#636659",s:25},
{c:"S 6005-R",f:"Neutrals",h:"#665959",s:25},
{c:"S 6005-R20B",f:"Neutrals",h:"#63595C",s:25},
{c:"S 6005-R50B",f:"Neutrals",h:"#605960",s:25},
{c:"S 6005-R80B",f:"Neutrals",h:"#5C5963",s:25},
{c:"S 6005-Y",f:"Neutrals",h:"#666659",s:25},
{c:"S 6005-Y20R",f:"Neutrals",h:"#666359",s:25},
{c:"S 6005-Y50R",f:"Neutrals",h:"#666059",s:25},
{c:"S 6005-Y80R",f:"Neutrals",h:"#665C59",s:25},
{c:"S 6010-B10G",f:"Neutrals",h:"#4D4F63",s:25},
{c:"S 6010-B30G",f:"Neutrals",h:"#4D545E",s:25},
{c:"S 6010-B50G",f:"Neutrals",h:"#4D5959",s:25},
{c:"S 6010-B70G",f:"Neutrals",h:"#4D5E54",s:25},
{c:"S 6010-B90G",f:"Neutrals",h:"#4D634F",s:25},
{c:"S 6010-G10Y",f:"Neutrals",h:"#4F664D",s:25},
{c:"S 6010-G30Y",f:"Neutrals",h:"#54664D",s:25},
{c:"S 6010-G50Y",f:"Neutrals",h:"#59664D",s:25},
{c:"S 6010-G70Y",f:"Neutrals",h:"#5E664D",s:25},
{c:"S 6010-G90Y",f:"Neutrals",h:"#63664D",s:25},
{c:"S 6010-R10B",f:"Neutrals",h:"#634D4F",s:45},
{c:"S 6010-R30B",f:"Neutrals",h:"#5E4D54",s:25},
{c:"S 6010-R50B",f:"Neutrals",h:"#594D59",s:25},
{c:"S 6010-R70B",f:"Neutrals",h:"#544D5E",s:25},
{c:"S 6010-R90B",f:"Neutrals",h:"#4F4D63",s:25},
{c:"S 6010-Y10R",f:"Neutrals",h:"#66634D",s:25},
{c:"S 6010-Y30R",f:"Neutrals",h:"#665E4D",s:25},
{c:"S 6010-Y50R",f:"Neutrals",h:"#66594D",s:25},
{c:"S 6010-Y70R",f:"Neutrals",h:"#66544D",s:25},
{c:"S 6010-Y90R",f:"Neutrals",h:"#664F4D",s:25},
{c:"S 6020-B",f:"Blues",h:"#333366",s:25},
{c:"S 6020-B10G",f:"Blues",h:"#333861",s:25},
{c:"S 6020-B30G",f:"Blues",h:"#334257",s:45},
{c:"S 6020-B50G",f:"Blues",h:"#334D4D",s:45},
{c:"S 6020-B70G",f:"Blues",h:"#335742",s:45},
{c:"S 6020-B90G",f:"Greens",h:"#336138",s:45},
{c:"S 6020-G",f:"Greens",h:"#336633",s:45},
{c:"S 6020-G10Y",f:"Greens",h:"#386633",s:45},
{c:"S 6020-G30Y",f:"Greens",h:"#426633",s:45},
{c:"S 6020-G50Y",f:"Greens",h:"#4D6633",s:45},
{c:"S 6020-G70Y",f:"Greens",h:"#576633",s:45},
{c:"S 6020-G90Y",f:"Yellows",h:"#616633",s:45},
{c:"S 6020-R",f:"Reds",h:"#663333",s:45},
{c:"S 6020-R10B",f:"Reds",h:"#613338",s:45},
{c:"S 6020-R20B",f:"Reds",h:"#5C333D",s:45},
{c:"S 6020-R30B",f:"Reds",h:"#573342",s:45},
{c:"S 6020-R40B",f:"Reds",h:"#523347",s:45},
{c:"S 6020-R50B",f:"Reds",h:"#4D334D",s:45},
{c:"S 6020-R60B",f:"Reds",h:"#473352",s:25},
{c:"S 6020-R70B",f:"Reds",h:"#423357",s:25},
{c:"S 6020-R80B",f:"Blues",h:"#3D335C",s:45},
{c:"S 6020-R90B",f:"Blues",h:"#383361",s:45},
{c:"S 6020-Y",f:"Yellows",h:"#666633",s:45},
{c:"S 6020-Y10R",f:"Yellows",h:"#666133",s:45},
{c:"S 6020-Y20R",f:"Yellows",h:"#665C33",s:45},
{c:"S 6020-Y30R",f:"Yellows",h:"#665733",s:45},
{c:"S 6020-Y40R",f:"Yellows",h:"#665233",s:45},
{c:"S 6020-Y50R",f:"Yellows",h:"#664D33",s:45},
{c:"S 6020-Y60R",f:"Yellows",h:"#664733",s:45},
{c:"S 6020-Y70R",f:"Yellows",h:"#664233",s:45},
{c:"S 6020-Y80R",f:"Reds",h:"#663D33",s:25},
{c:"S 6020-Y90R",f:"Reds",h:"#663833",s:45},
{c:"S 6030-B",f:"Blues",h:"#1A1A66",s:45},
{c:"S 6030-B10G",f:"Blues",h:"#1A215E",s:45},
{c:"S 6030-B30G",f:"Blues",h:"#1A304F",s:45},
{c:"S 6030-B50G",f:"Blues",h:"#1A4040",s:45},
{c:"S 6030-B70G",f:"Blues",h:"#1A4F30",s:45},
{c:"S 6030-B90G",f:"Greens",h:"#1A5E21",s:45},
{c:"S 6030-G",f:"Greens",h:"#1A661A",s:45},
{c:"S 6030-G10Y",f:"Greens",h:"#21661A",s:45},
{c:"S 6030-G30Y",f:"Greens",h:"#30661A",s:45},
{c:"S 6030-G50Y",f:"Greens",h:"#40661A",s:45},
{c:"S 6030-G70Y",f:"Greens",h:"#4F661A",s:45},
{c:"S 6030-G90Y",f:"Yellows",h:"#5E661A",s:45},
{c:"S 6030-R",f:"Reds",h:"#661A1A",s:45},
{c:"S 6030-R10B",f:"Reds",h:"#5E1A21",s:45},
{c:"S 6030-R20B",f:"Reds",h:"#571A29",s:45},
{c:"S 6030-R30B",f:"Reds",h:"#4F1A30",s:45},
{c:"S 6030-R40B",f:"Reds",h:"#471A38",s:45},
{c:"S 6030-R50B",f:"Reds",h:"#401A40",s:45},
{c:"S 6030-R60B",f:"Reds",h:"#381A47",s:45},
{c:"S 6030-R70B",f:"Reds",h:"#301A4F",s:45},
{c:"S 6030-R80B",f:"Blues",h:"#291A57",s:45},
{c:"S 6030-R90B",f:"Blues",h:"#211A5E",s:45},
{c:"S 6030-Y",f:"Yellows",h:"#66661A",s:45},
{c:"S 6030-Y10R",f:"Yellows",h:"#665E1A",s:45},
{c:"S 6030-Y20R",f:"Yellows",h:"#66571A",s:45},
{c:"S 6030-Y30R",f:"Yellows",h:"#664F1A",s:45},
{c:"S 6030-Y40R",f:"Yellows",h:"#66471A",s:45},
{c:"S 6030-Y50R",f:"Yellows",h:"#66401A",s:45},
{c:"S 6030-Y60R",f:"Yellows",h:"#66381A",s:45},
{c:"S 6030-Y70R",f:"Yellows",h:"#66301A",s:45},
{c:"S 6030-Y80R",f:"Reds",h:"#66291A",s:45},
{c:"S 6030-Y90R",f:"Reds",h:"#66211A",s:45},
{c:"S 6035-B60G",f:"Blues",h:"#0D4230",s:45},
{c:"S 6500-N",f:"Neutrals",h:"#595959",s:25},
{c:"S 6502-B",f:"Neutrals",h:"#545459",s:25},
{c:"S 6502-B50G",f:"Neutrals",h:"#545757",s:25},
{c:"S 6502-G",f:"Neutrals",h:"#545954",s:25},
{c:"S 6502-G50Y",f:"Neutrals",h:"#575954",s:25},
{c:"S 6502-R",f:"Neutrals",h:"#595454",s:25},
{c:"S 6502-R50B",f:"Neutrals",h:"#575457",s:25},
{c:"S 6502-Y",f:"Neutrals",h:"#595954",s:25},
{c:"S 6502-Y20R",f:"Neutrals",h:"#595854",s:25},
{c:"S 6502-Y50R",f:"Neutrals",h:"#595754",s:25},
{c:"S 6502-Y80R",f:"Neutrals",h:"#595554",s:25},
{c:"S 6530-B30G",f:"Blues",h:"#0D2442",s:45},
{c:"S 6530-B50G",f:"Blues",h:"#0D3333",s:45},
{c:"S 6530-G10Y",f:"Greens",h:"#14590D",s:45},
{c:"S 6530-G50Y",f:"Greens",h:"#33590D",s:45},
{c:"S 7000-N",f:"Neutrals",h:"#4D4D4D",s:25},
{c:"S 7005-B",f:"Neutrals",h:"#40404D",s:25},
{c:"S 7005-B20G",f:"Neutrals",h:"#40424A",s:25},
{c:"S 7005-B50G",f:"Neutrals",h:"#404646",s:25},
{c:"S 7005-B80G",f:"Neutrals",h:"#404A42",s:45},
{c:"S 7005-G",f:"Neutrals",h:"#404D40",s:25},
{c:"S 7005-G20Y",f:"Neutrals",h:"#424D40",s:45},
{c:"S 7005-G50Y",f:"Neutrals",h:"#464D40",s:45},
{c:"S 7005-G80Y",f:"Neutrals",h:"#4A4D40",s:45},
{c:"S 7005-R",f:"Neutrals",h:"#4D4040",s:25},
{c:"S 7005-R20B",f:"Neutrals",h:"#4A4042",s:25},
{c:"S 7005-R50B",f:"Neutrals",h:"#464046",s:25},
{c:"S 7005-R80B",f:"Neutrals",h:"#42404A",s:25},
{c:"S 7005-Y",f:"Neutrals",h:"#4D4D40",s:25},
{c:"S 7005-Y20R",f:"Neutrals",h:"#4D4A40",s:45},
{c:"S 7005-Y50R",f:"Neutrals",h:"#4D4640",s:25},
{c:"S 7005-Y80R",f:"Neutrals",h:"#4D4240",s:25},
{c:"S 7010-B10G",f:"Neutrals",h:"#33364A",s:25},
{c:"S 7010-B30G",f:"Neutrals",h:"#333B45",s:45},
{c:"S 7010-B50G",f:"Neutrals",h:"#334040",s:45},
{c:"S 7010-B70G",f:"Neutrals",h:"#33453B",s:45},
{c:"S 7010-B90G",f:"Neutrals",h:"#334A36",s:45},
{c:"S 7010-G10Y",f:"Neutrals",h:"#364D33",s:45},
{c:"S 7010-G30Y",f:"Neutrals",h:"#3B4D33",s:45},
{c:"S 7010-G50Y",f:"Neutrals",h:"#404D33",s:45},
{c:"S 7010-G70Y",f:"Neutrals",h:"#454D33",s:45},
{c:"S 7010-G90Y",f:"Neutrals",h:"#4A4D33",s:45},
{c:"S 7010-R10B",f:"Neutrals",h:"#4A3336",s:45},
{c:"S 7010-R30B",f:"Neutrals",h:"#45333B",s:45},
{c:"S 7010-R50B",f:"Neutrals",h:"#403340",s:25},
{c:"S 7010-R70B",f:"Neutrals",h:"#3B3345",s:45},
{c:"S 7010-R90B",f:"Neutrals",h:"#36334A",s:45},
{c:"S 7010-Y10R",f:"Neutrals",h:"#4D4A33",s:45},
{c:"S 7010-Y30R",f:"Neutrals",h:"#4D4533",s:45},
{c:"S 7010-Y50R",f:"Neutrals",h:"#4D4033",s:45},
{c:"S 7010-Y70R",f:"Neutrals",h:"#4D3B33",s:45},
{c:"S 7010-Y90R",f:"Neutrals",h:"#4D3633",s:25},
{c:"S 7020-B",f:"Blues",h:"#1A1A4D",s:45},
{c:"S 7020-B10G",f:"Blues",h:"#1A1F47",s:45},
{c:"S 7020-B30G",f:"Blues",h:"#1A293D",s:45},
{c:"S 7020-B50G",f:"Blues",h:"#1A3333",s:45},
{c:"S 7020-B70G",f:"Blues",h:"#1A3D29",s:45},
{c:"S 7020-B90G",f:"Greens",h:"#1A471F",s:45},
{c:"S 7020-G",f:"Greens",h:"#1A4D1A",s:45},
{c:"S 7020-G10Y",f:"Greens",h:"#1F4D1A",s:45},
{c:"S 7020-G30Y",f:"Greens",h:"#294D1A",s:45},
{c:"S 7020-G50Y",f:"Greens",h:"#334D1A",s:45},
{c:"S 7020-G70Y",f:"Greens",h:"#3D4D1A",s:45},
{c:"S 7020-G90Y",f:"Yellows",h:"#474D1A",s:45},
{c:"S 7020-R",f:"Reds",h:"#4D1A1A",s:45},
{c:"S 7020-R10B",f:"Reds",h:"#471A1F",s:45},
{c:"S 7020-R20B",f:"Reds",h:"#421A24",s:45},
{c:"S 7020-R30B",f:"Reds",h:"#3D1A29",s:45},
{c:"S 7020-R40B",f:"Reds",h:"#381A2E",s:45},
{c:"S 7020-R50B",f:"Reds",h:"#331A33",s:45},
{c:"S 7020-R60B",f:"Reds",h:"#2E1A38",s:45},
{c:"S 7020-R70B",f:"Reds",h:"#291A3D",s:45},
{c:"S 7020-R80B",f:"Blues",h:"#241A42",s:45},
{c:"S 7020-R90B",f:"Blues",h:"#1F1A47",s:45},
{c:"S 7020-Y",f:"Yellows",h:"#4D4D1A",s:45},
{c:"S 7020-Y10R",f:"Yellows",h:"#4D471A",s:45},
{c:"S 7020-Y20R",f:"Yellows",h:"#4D421A",s:45},
{c:"S 7020-Y30R",f:"Yellows",h:"#4D3D1A",s:45},
{c:"S 7020-Y40R",f:"Yellows",h:"#4D381A",s:45},
{c:"S 7020-Y50R",f:"Yellows",h:"#4D331A",s:45},
{c:"S 7020-Y60R",f:"Yellows",h:"#4D2E1A",s:45},
{c:"S 7020-Y70R",f:"Yellows",h:"#4D291A",s:45},
{c:"S 7020-Y80R",f:"Reds",h:"#4D241A",s:45},
{c:"S 7020-Y90R",f:"Reds",h:"#4D1F1A",s:45},
{c:"S 7500-N",f:"Neutrals",h:"#404040",s:25},
{c:"S 7502-B",f:"Neutrals",h:"#3B3B40",s:25},
{c:"S 7502-G",f:"Neutrals",h:"#3B403B",s:45},
{c:"S 7502-R",f:"Neutrals",h:"#403B3B",s:25},
{c:"S 7502-Y",f:"Neutrals",h:"#40403B",s:45},
{c:"S 8000-N",f:"Neutrals",h:"#333333",s:45},
{c:"S 8005-B",f:"Neutrals",h:"#262633",s:45},
{c:"S 8005-B20G",f:"Neutrals",h:"#262930",s:45},
{c:"S 8005-B50G",f:"Neutrals",h:"#262D2D",s:45},
{c:"S 8005-B80G",f:"Neutrals",h:"#263029",s:45},
{c:"S 8005-G",f:"Neutrals",h:"#263326",s:45},
{c:"S 8005-G20Y",f:"Neutrals",h:"#293326",s:45},
{c:"S 8005-G50Y",f:"Neutrals",h:"#2D3326",s:45},
{c:"S 8005-G80Y",f:"Neutrals",h:"#303326",s:45},
{c:"S 8005-R",f:"Neutrals",h:"#332626",s:45},
{c:"S 8005-R20B",f:"Neutrals",h:"#302629",s:45},
{c:"S 8005-R50B",f:"Neutrals",h:"#2D262D",s:45},
{c:"S 8005-R80B",f:"Neutrals",h:"#292630",s:45},
{c:"S 8005-Y",f:"Neutrals",h:"#333326",s:45},
{c:"S 8005-Y20R",f:"Neutrals",h:"#333026",s:45},
{c:"S 8005-Y50R",f:"Neutrals",h:"#332D26",s:45},
{c:"S 8005-Y80R",f:"Neutrals",h:"#332926",s:45},
{c:"S 8010-B10G",f:"Neutrals",h:"#191C30",s:45},
{c:"S 8010-B30G",f:"Neutrals",h:"#19212B",s:45},
{c:"S 8010-B50G",f:"Neutrals",h:"#192626",s:45},
{c:"S 8010-B70G",f:"Neutrals",h:"#192B21",s:45},
{c:"S 8010-B90G",f:"Neutrals",h:"#19301C",s:45},
{c:"S 8010-G10Y",f:"Neutrals",h:"#1C3319",s:45},
{c:"S 8010-G30Y",f:"Neutrals",h:"#213319",s:45},
{c:"S 8010-G50Y",f:"Neutrals",h:"#263319",s:45},
{c:"S 8010-G70Y",f:"Neutrals",h:"#2B3319",s:45},
{c:"S 8010-G90Y",f:"Neutrals",h:"#303319",s:45},
{c:"S 8010-R10B",f:"Neutrals",h:"#30191C",s:45},
{c:"S 8010-R30B",f:"Neutrals",h:"#2B1921",s:45},
{c:"S 8010-R50B",f:"Neutrals",h:"#261926",s:45},
{c:"S 8010-R70B",f:"Neutrals",h:"#21192B",s:45},
{c:"S 8010-R90B",f:"Neutrals",h:"#1C1930",s:45},
{c:"S 8010-Y10R",f:"Neutrals",h:"#333019",s:45},
{c:"S 8010-Y30R",f:"Neutrals",h:"#332B19",s:45},
{c:"S 8010-Y50R",f:"Neutrals",h:"#332619",s:45},
{c:"S 8010-Y70R",f:"Neutrals",h:"#332119",s:45},
{c:"S 8010-Y90R",f:"Neutrals",h:"#331C19",s:45},
{c:"S 8500-N",f:"Neutrals",h:"#262626",s:45},
{c:"S 8502-B",f:"Neutrals",h:"#212126",s:45},
{c:"S 8502-G",f:"Neutrals",h:"#212621",s:45},
{c:"S 8502-R",f:"Neutrals",h:"#262121",s:45},
{c:"S 8502-Y",f:"Neutrals",h:"#262621",s:45},
{c:"S 8505-B",f:"Neutrals",h:"#1A1A26",s:45},
{c:"S 8505-B20G",f:"Neutrals",h:"#1A1C24",s:45},
{c:"S 8505-B50G",f:"Neutrals",h:"#1A2020",s:45},
{c:"S 8505-B80G",f:"Neutrals",h:"#1A241C",s:45},
{c:"S 8505-G",f:"Neutrals",h:"#1A261A",s:45},
{c:"S 8505-G20Y",f:"Neutrals",h:"#1C261A",s:45},
{c:"S 8505-G50Y",f:"Neutrals",h:"#20261A",s:45},
{c:"S 8505-G80Y",f:"Neutrals",h:"#24261A",s:45},
{c:"S 8505-R",f:"Neutrals",h:"#261A1A",s:45},
{c:"S 8505-R20B",f:"Neutrals",h:"#241A1C",s:45},
{c:"S 8505-R50B",f:"Neutrals",h:"#201A20",s:45},
{c:"S 8505-R80B",f:"Neutrals",h:"#1C1A24",s:45},
{c:"S 8505-Y",f:"Neutrals",h:"#26261A",s:45},
{c:"S 8505-Y20R",f:"Neutrals",h:"#26241A",s:45},
{c:"S 8505-Y50R",f:"Neutrals",h:"#26201A",s:45},
{c:"S 8505-Y80R",f:"Neutrals",h:"#261C1A",s:45},
{c:"S 9000-N",f:"Neutrals",h:"#191919",s:45}
];

var SURCHARGE_VARIANT_ID = 44060064317539;

var SKUS_BASE = {
  "velvet":        {"1L":{"P":"1121610101","D":"1121610301","TR":"1121610501"}, "5L":{"P":"1121610105","D":"1121610305","TR":"1121610505"}, "15L":{"P":"1121670115","D":"1121670315","TR":"1121670515"}},
  "barbomat":      {"1L":{"P":"1130210101","D":"1130210301","TR":"1130210501"}, "5L":{"P":"1130210105","D":"1130210305","TR":"1130210505"}, "15L":{"P":"1130270115","D":"1130270315","TR":"1130270515"}},
  "barbosoft":     {"1L":{"P":"1121010101","D":"1121010301","TR":"1121010501"}, "5L":{"P":"1121010105","D":"1121010305","TR":"1121010505"}, "15L":{"P":"1121070115","D":"1121070315","TR":"1121070515"}},
  "barbosilk":     {"1L":{"P":"1120010101","D":"1120010301","TR":"1120010501"}, "5L":{"P":"1120010105","D":"1120010305","TR":"1120010505"}, "15L":{"P":"1120070115","D":"1120070315","TR":"1120070515"}},
  "dioplaste":     {"1L":{"P":"1133010101","D":"1133010301","TR":"1133010501"}, "5L":{"P":"1133010105","D":"1133010305","TR":"1133010505"}, "15L":{"P":"1133070115","D":"1133070315","TR":"1133070515"}},
  "barbocril":     {"1L":{"P":"1130010101","D":"1130010301","TR":"1130010501"}, "5L":{"P":"1130010105","D":"1130010305","TR":"1130010505"}, "15L":{"P":"1130070115","D":"1130070315","TR":"1130070515"}},
  "acryl-plus-vg": {"1L":{"P":"","D":"","TR":""}, "5L":{"P":"","D":"","TR":"1127910305"}, "15L":{"P":"1127970315","D":"","TR":"1127970515"}}
};

function getBase(surcharge) {
  if (surcharge === 45) return "TR";
  if (surcharge === 16 || surcharge === 25) return "D";
  return "P";
}

(function() {
  if(!window.location.pathname.match(/^\/products\//)) return;

  var F = 'DM Sans,system-ui,sans-serif';
  var style = document.createElement('style');
  style.textContent = [
    '@import url("https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,600;9..40,700;9..40,800&display=swap");',
    '#cpp-overlay{display:none;position:fixed;inset:0;background:rgba(20,19,17,.7);z-index:9999;overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '#cpp-overlay.active{display:block}',
    '#cpp-close{position:fixed;top:14px;right:14px;z-index:10001;background:#1F1E1B;border:none;color:#F7F4EF;width:40px;height:40px;font-size:22px;line-height:1;cursor:pointer;display:none;font-family:'+F+'}',
    '#cpp-close.active{display:flex;align-items:center;justify-content:center}',
    '#cpp-box{background:#F7F4EF;margin:56px auto 40px;max-width:1000px;width:94%;font-family:'+F+';color:#1F1E1B}',
    '#cpp-sel{display:none;background:#EDEAE4;padding:24px 28px}',
    '#cpp-sel-top{display:flex;gap:20px;align-items:flex-start;margin-bottom:20px}',
    '#cpp-sel-name{font-size:20px;font-weight:800;color:#1F1E1B;margin-bottom:3px}',
    '#cpp-sel-code{font-size:12px;color:#8C8880;margin-bottom:3px;letter-spacing:.05em}',
    '#cpp-sel-sur{font-size:13px;color:#A07830;font-weight:600}',
    '#cpp-tabs{display:flex;border-bottom:1px solid rgba(31,30,27,.12);background:#F7F4EF;padding:0 20px}',
    '.cpp-tab{padding:12px 18px;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;background:none;border:none;border-bottom:2px solid transparent;cursor:pointer;color:#8C8880;white-space:nowrap;font-family:'+F+';transition:color .15s}',
    '.cpp-tab:hover{color:#1F1E1B}',
    '.cpp-tab.on{color:#1F1E1B;border-bottom-color:#1F1E1B}',
    '#cpp-controls{padding:14px 20px;display:flex;gap:10px;align-items:flex-start;flex-wrap:wrap;border-bottom:1px solid rgba(31,30,27,.08)}',
    '#cpp-search{flex:1;min-width:180px;padding:9px 14px;border:1px solid rgba(31,30,27,.15);background:#F7F4EF;font-size:13px;color:#1F1E1B;outline:none;font-family:'+F+'}',
    '#cpp-search:focus{border-color:#1F1E1B}',
    '#cpp-fams{display:flex;gap:5px;flex-wrap:wrap}',
    '.cpp-fb{padding:4px 12px;border:1px solid rgba(31,30,27,.2);background:#F7F4EF;font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;color:#5C5851;font-family:'+F+';transition:all .15s}',
    '.cpp-fb:hover{border-color:#1F1E1B;color:#1F1E1B}',
    '.cpp-fb.on{background:#1F1E1B;color:#F7F4EF;border-color:#1F1E1B}',
    '#cpp-grid-wrap{padding:16px 20px}',
    '#cpp-grid{display:grid;grid-template-columns:repeat(15,1fr);gap:4px}',
    '.cpp-sw{cursor:pointer}',
    '.cpp-sq{width:100%;aspect-ratio:1;display:block;border:1px solid rgba(0,0,0,.06);transition:transform .15s}',
    '.cpp-sw:hover .cpp-sq{transform:scale(1.1);position:relative;z-index:2}',
    '.cpp-sw.sel .cpp-sq{outline:2.5px solid #1F1E1B;outline-offset:2px}',
    '.cpp-cd{font-size:8px;color:#8C8880;text-align:center;margin-top:2px;overflow:hidden;white-space:nowrap}',
    '#cpp-sizes{display:flex;gap:10px;margin-bottom:14px;flex-wrap:wrap}',
    '.cpp-sz{flex:1;min-width:90px;padding:12px;text-align:center;cursor:pointer;background:#F7F4EF;border:2px solid rgba(31,30,27,.12);transition:all .15s}',
    '.cpp-sz:hover{border-color:#8C8880}',
    '.cpp-sz.on{background:#A07830;border-color:#A07830}',
    '.cpp-sz-n{font-size:18px;font-weight:800;color:#1F1E1B}',
    '.cpp-sz.on .cpp-sz-n{color:#fff}',
    '.cpp-sz-p{font-size:13px;font-weight:600;color:#A07830;margin-top:2px}',
    '.cpp-sz.on .cpp-sz-p{color:rgba(255,255,255,.9)}',
    '.cpp-sz-oos{border-style:dashed;opacity:.6}',
    '.cpp-sz-oos .cpp-sz-n{color:rgba(31,30,27,.45)}',
    '.cpp-sz-oos .cpp-sz-p{color:#A07830}',
    '.cpp-sz-oos{border-style:dashed;opacity:.7}',
    '.cpp-sz-oos.on{background:#A07830;border-color:#A07830;border-style:dashed;opacity:1}',
    '.cpp-sz-oos.on .cpp-sz-n{color:#fff}',
    '.cpp-sz-oos.on .cpp-sz-p{color:rgba(255,255,255,.9)}',
    '.cpp-sz-preorder-badge{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#A07830;margin-top:2px}',
    '.cpp-sz-oos.on .cpp-sz-preorder-badge{color:rgba(255,255,255,.85)}',
    '#cpp-preorder-btn{padding:13px 28px;background:#A07830;color:#F7F4EF;border:none;font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;font-family:'+F+';transition:opacity .2s;display:none;text-decoration:none;margin-top:8px}',
    '#cpp-preorder-btn:hover{opacity:.8}',
    '#cpp-atc{padding:13px 28px;background:#1F1E1B;color:#F7F4EF;border:none;font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;font-family:'+F+';transition:opacity .2s;display:none}',
    '#cpp-atc:hover{opacity:.8}',
    '#cpp-atc:disabled{opacity:.5;cursor:default}',
    '#cpp-atc-note{font-size:11px;color:#8C8880;margin-top:6px}',
    '#cpp-zoom{display:none;position:fixed;inset:0;z-index:10002;align-items:center;justify-content:center;pointer-events:none}',
    '#cpp-zoom.on{display:flex}',
    '#cpp-zoom-bg{position:absolute;inset:0;background:rgba(31,30,27,.55);cursor:pointer;pointer-events:all}',
    '#cpp-zoom-box{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;gap:14px;pointer-events:all}',
    '#cpp-zoom-sq{width:min(380px,65vw);height:min(380px,65vw);overflow:hidden;box-shadow:0 12px 50px rgba(0,0,0,.4)}',
    '#cpp-zoom-sq svg{width:100%;height:100%;display:block}',
    '#cpp-zoom-name{font-family:'+F+';font-size:17px;font-weight:700;color:#F7F4EF}',
    '#cpp-zoom-code{font-family:'+F+';font-size:12px;color:rgba(245,241,234,.6);letter-spacing:.08em}',
    '@media(max-width:640px){',
    '#cpp-grid{grid-template-columns:repeat(8,1fr)!important;gap:3px!important}',
    '.cpp-cd{display:none}',
    '.cpp-tab{padding:10px 10px;font-size:10px}',
    '#cpp-sel-top{flex-wrap:wrap}',
    '}',
    '@media(max-width:400px){#cpp-grid{grid-template-columns:repeat(6,1fr)!important}}'
  ].join('');
  document.head.appendChild(style);

  var closeBtn = document.createElement('button');
  closeBtn.id = 'cpp-close';
  closeBtn.innerHTML = '&times;';
  document.body.appendChild(closeBtn);

  var overlay = document.createElement('div');
  overlay.id = 'cpp-overlay';
  overlay.innerHTML = [
    '<div id="cpp-box">',
      '<div id="cpp-sel">',
        '<div id="cpp-sel-top">',
          '<div id="cpp-swatch-wrap"></div>',
          '<div>',
            '<div id="cpp-sel-name"></div>',
            '<div id="cpp-sel-code"></div>',
            '<div id="cpp-sel-sur"></div>',
          '</div>',
        '</div>',
        '<div id="cpp-sizes"></div>',
        '<button id="cpp-atc"></button>',
        '<a id="cpp-preorder-btn" href="#" target="_blank" rel="noopener"></a>',
        '<div id="cpp-atc-note"></div>',
      '</div>',
      '<div id="cpp-tabs">',
        '<button class="cpp-tab on" data-sys="barbot">Barbot Collection</button>',
        '<button class="cpp-tab" data-sys="ral">RAL Classic</button>',
        '<button class="cpp-tab" data-sys="ncs">NCS Colours</button>',
      '</div>',
      '<div id="cpp-controls">',
        '<input id="cpp-search" type="text" placeholder="Search by name or code...">',
        '<div id="cpp-fams"></div>',
      '</div>',
      '<div id="cpp-grid-wrap"><div id="cpp-grid"></div></div>',
    '</div>',
    '<div id="cpp-zoom">',
      '<div id="cpp-zoom-bg"></div>',
      '<div id="cpp-zoom-box">',
        '<div id="cpp-zoom-sq"></div>',
        '<div id="cpp-zoom-name"></div>',
        '<div id="cpp-zoom-code"></div>',
      '</div>',
    '</div>'
  ].join('');
  document.body.appendChild(overlay);

  var aSys = 'barbot', aFam = 'all', selColour = null, selSize = null, currentProduct = null;

  function curData(){ return aSys === 'barbot' ? COLOURS_BARBOT : aSys === 'ncs' ? COLOURS_NCS : COLOURS_RAL; }
  function priceFn(base, sur){ return Math.round(base * (1 + sur/100)); }

  var SUR_LBL = {
    0:  'Base white — no surcharge',
    10: '+10% surcharge on white price',
    16: '+16% surcharge on white price',
    25: '+25% surcharge on white price',
    45: '+45% surcharge on white price'
  };

  function openPopup(){
    overlay.classList.add('active');
    closeBtn.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closePopup(){
    overlay.classList.remove('active');
    closeBtn.classList.remove('active');
    document.body.style.overflow = '';
  }
  closeBtn.onclick = closePopup;
  overlay.onclick = function(e){ if(e.target === overlay) closePopup(); };

  function openZoom(c){
    var sq = document.getElementById('cpp-zoom-sq');
    sq.innerHTML = '';
    var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('width','100%'); svg.setAttribute('height','100%');
    svg.setAttribute('viewBox','0 0 1 1'); svg.setAttribute('preserveAspectRatio','none');
    var rect = document.createElementNS('http://www.w3.org/2000/svg','rect');
    rect.setAttribute('width','1'); rect.setAttribute('height','1'); rect.setAttribute('fill',c.h);
    svg.appendChild(rect); sq.appendChild(svg);
    document.getElementById('cpp-zoom-name').textContent = c.n||c.c;
    document.getElementById('cpp-zoom-code').textContent = c.c;
    document.getElementById('cpp-zoom').classList.add('on');
  }
  function closeZoom(){ document.getElementById('cpp-zoom').classList.remove('on'); }
  document.getElementById('cpp-zoom-bg').onclick = closeZoom;
  document.getElementById('cpp-zoom-bg').addEventListener('touchstart', closeZoom, {passive:true});
  window.addEventListener('scroll', closeZoom, {passive:true});
  overlay.addEventListener('scroll', closeZoom, {passive:true});
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeZoom(); closePopup(); } });

  function buildFams(){
    var div = document.getElementById('cpp-fams');
    div.innerHTML = '';
    var fams = [];
    curData().forEach(function(c){ if(fams.indexOf(c.f)===-1) fams.push(c.f); });
    function mkBtn(label, val){
      var b = document.createElement('button');
      b.className = 'cpp-fb' + (aFam===val?' on':'');
      b.textContent = label;
      b.onclick = function(){ aFam=val; buildFams(); drawGrid(); };
      div.appendChild(b);
    }
    mkBtn('All','all');
    fams.sort().forEach(function(f){ mkBtn(f,f); });
  }

  function drawGrid(){
    var q = document.getElementById('cpp-search').value.toLowerCase();
    var g = document.getElementById('cpp-grid');
    g.innerHTML = '';
    curData().filter(function(c){
      return (aFam==='all'||c.f===aFam) && (!q||(c.n&&c.n.toLowerCase().indexOf(q)>-1)||c.c.toLowerCase().indexOf(q)>-1);
    }).forEach(function(c){
      var d = document.createElement('div');
      d.className = 'cpp-sw' + (selColour&&selColour.c===c.c?' sel':'');
      var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 1 1');
      svg.setAttribute('preserveAspectRatio','none');
      svg.setAttribute('width','100%');
      svg.style.display='block';
      svg.style.aspectRatio='1';
      svg.style.border='1px solid rgba(0,0,0,.06)';
      svg.title = (c.n||c.c) + ' · ' + c.c;
      var r = document.createElementNS('http://www.w3.org/2000/svg','rect');
      r.setAttribute('width','1'); r.setAttribute('height','1'); r.setAttribute('fill',c.h);
      svg.appendChild(r);
      d.appendChild(svg);
      var cd = document.createElement('div');
      cd.className = 'cpp-cd'; cd.textContent = c.c;
      d.appendChild(cd);
      d.onclick = function(){ selectColour(c); };
      g.appendChild(d);
    });
  }

  function selectColour(c){
    selColour = c; selSize = null;
    renderSel();
    drawGrid();
    setTimeout(function(){
      var sel = document.getElementById('cpp-sel');
      if(sel) overlay.scrollTop = 0;
    }, 50);
  }

  function renderSel(){
    var area = document.getElementById('cpp-sel');
    if(!selColour){ area.style.display='none'; return; }
    area.style.display = 'block';
    var wrap = document.getElementById('cpp-swatch-wrap');
    wrap.innerHTML = '';
    var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('width','100'); svg.setAttribute('height','100');
    svg.setAttribute('viewBox','0 0 100 100');
    svg.style.display='block'; svg.style.cursor='zoom-in';
    svg.style.border='1px solid rgba(0,0,0,.08)'; svg.style.flexShrink='0';
    var r = document.createElementNS('http://www.w3.org/2000/svg','rect');
    r.setAttribute('width','100'); r.setAttribute('height','100'); r.setAttribute('fill',selColour.h);
    svg.appendChild(r);
    svg.onmouseenter = function(){ openZoom(selColour); };
    svg.onclick = function(){ openZoom(selColour); };
    wrap.appendChild(svg);
    document.getElementById('cpp-sel-name').textContent = selColour.n||selColour.c;
    document.getElementById('cpp-sel-code').textContent = selColour.c;
    document.getElementById('cpp-sel-sur').textContent = SUR_LBL[selColour.s] || '';
    var sizesDiv = document.getElementById('cpp-sizes');
    sizesDiv.innerHTML = '';
    if(currentProduct){
      // Build a map of White prices by size for correct surcharge calculation
      var whitePrices = {};
      currentProduct.variants.forEach(function(v){
        if(v.option1 === 'White') whitePrices[v.option2] = v.price / 100;
      });
      currentProduct.variants.forEach(function(v){
        if(v.option1 !== 'Tinted') return;
        var sz = v.option2;
        // Use White price as base for surcharge calculation
        var whitePrice = whitePrices[sz] || (v.price / 100);
        var total = priceFn(whitePrice, selColour.s);
        var isOn = selSize && selSize.size === sz;
        // Use __encoreStock (built from Liquid) — v.available unreliable with continue policy
        var stockQty = (window.__encoreStock && window.__encoreStock[v.id] !== undefined)
          ? window.__encoreStock[v.id]
          : (v.available !== false ? 1 : 0);
        var isAvailable = stockQty > 0;
        var el = document.createElement('div');
        el.className = 'cpp-sz' + (isOn?' on':'') + (!isAvailable?' cpp-sz-oos':'');
        var nm = document.createElement('div'); nm.className='cpp-sz-n'; nm.textContent=sz;
        var pr = document.createElement('div'); pr.className='cpp-sz-p';
        pr.textContent = 'AED ' + total;
        el.appendChild(nm); el.appendChild(pr);
        el.onclick = (function(szCopy, wpCopy, avCopy){
          return function(){
            selSize = {size: szCopy, price: wpCopy, available: avCopy};
            renderSel();
          };
        })(sz, whitePrice, isAvailable);
        sizesDiv.appendChild(el);
      });
    }
    var atcBtn = document.getElementById('cpp-atc');
    var preorderBtn = document.getElementById('cpp-preorder-btn');
    var atcNote = document.getElementById('cpp-atc-note');
    if(selSize){
      var fp = priceFn(selSize.price, selColour.s);
      var colourLabelFull = selColour.c + (selColour.n ? ' \u2014 ' + selColour.n : '');
      var productTitle = currentProduct ? currentProduct.title : '';

      if(selSize.available !== false){
        // ── In stock: normal Add to Cart ──
        atcBtn.style.display = 'inline-block';
        atcBtn.textContent = 'Add to Cart \u2014 AED ' + fp;
        atcBtn.disabled = false;
        atcBtn.onclick = doAddToCart;
        atcNote.textContent = productTitle + ' \xb7 ' + selSize.size + ' \xb7 Tinted: ' + colourLabelFull;
        preorderBtn.style.display = 'none';
      } else {
        // ── Out of stock: Pre-order → WhatsApp with price shown ──
        atcBtn.style.display = 'none';
        var waMsg = encodeURIComponent('Hi! I would like to pre-order: ' + productTitle + ' ' + selSize.size + ' \u2014 Tinted: ' + colourLabelFull);
        preorderBtn.href = 'https://wa.me/971553585398?text=' + waMsg;
        preorderBtn.textContent = 'Pre-order \u2014 AED ' + fp;
        preorderBtn.style.display = 'inline-block';
        atcNote.textContent = productTitle + ' \xb7 ' + selSize.size + ' \xb7 Tinted: ' + colourLabelFull;
      }
    } else {
      atcBtn.style.display = 'none';
      if(preorderBtn) preorderBtn.style.display = 'none';
      atcNote.textContent = '';
    }
  }

  function doAddToCart(){
    if(!selColour || !selSize) return;
    var btn = document.getElementById('cpp-atc');
    if(btn){ btn.textContent='Adding...'; btn.disabled=true; }

    var handle = window.location.pathname.replace('/products/','').split('?')[0];
    var base = getBase(selColour.s);
    var targetSku = (SKUS_BASE[handle] && SKUS_BASE[handle][selSize.size]) ? SKUS_BASE[handle][selSize.size][base] : '';
    var actualBase = base;

    // Fallback: if no SKU for computed base, use any available base (some products only have TR)
    if (!targetSku && SKUS_BASE[handle] && SKUS_BASE[handle][selSize.size]) {
      var sb = SKUS_BASE[handle][selSize.size];
      if (sb['TR']) { targetSku = sb['TR']; actualBase = 'TR'; }
      else if (sb['P'])  { targetSku = sb['P'];  actualBase = 'P';  }
      else if (sb['D'])  { targetSku = sb['D'];  actualBase = 'D';  }
    }

    var fetchHandle = (actualBase === 'P') ? handle : handle + '-base';
    var surchargeAED = Math.round(selSize.price * selColour.s / 100);
    var baseName = actualBase === 'P' ? 'Basecoat P' : actualBase === 'D' ? 'Basecoat D' : 'Basecoat TR';
    var colourLabel = selColour.c + (selColour.n ? ' — ' + selColour.n : '');

    // Step 1: get current cart
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var existing = cart.items.find(function(i){ return i.variant_id === SURCHARGE_VARIANT_ID; });
        var currentQty = existing ? existing.quantity : 0;

        // Step 2: find variant id by SKU
        return fetch('/products/' + fetchHandle + '.js')
          .then(function(r){ return r.json(); })
          .then(function(prod){
            var vId = null;
            prod.variants.forEach(function(v){ if(v.sku === targetSku) vId = v.id; });
            if(!vId){
              alert('Variant not found. SKU: ' + targetSku);
              if(btn){ btn.textContent='Error — try again'; btn.disabled=false; }
              return Promise.reject('no variant');
            }

            // Step 3: add paint to cart
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({items:[{
                id: vId,
                quantity: 1,
                properties:{
                  'Colour': colourLabel,
                  'Base': baseName,
                  'Surcharge': '+' + selColour.s + '% (AED ' + surchargeAED + ')'
                }
              }]})
            })
            .then(function(r){
              // If item is out of stock (422) — stop here and show message, do NOT proceed
              if(!r.ok) return r.json().then(function(e){
                throw {stockError: true, msg: e.description || e.message || 'This item is currently out of stock'};
              });
              return r.json();
            })
            .then(function(){
              // Step 4: add/update surcharge (only runs if Step 3 succeeded)
              if(surchargeAED === 0){ return Promise.resolve(); }
              var newTotal = currentQty + surchargeAED;
              if(existing){
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {'Content-Type': 'application/json'},
                  body: JSON.stringify({id: existing.key, quantity: newTotal, properties:{'For':'Colour tinting surcharge'}})
                }).then(function(r){ return r.json(); });
              } else {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {'Content-Type': 'application/json'},
                  body: JSON.stringify({id: SURCHARGE_VARIANT_ID, quantity: newTotal, properties:{'For':'Colour tinting surcharge'}})
                }).then(function(r){ return r.json(); });
              }
            })
            .then(function(){
              // Step 5: update cart note
              return fetch('/cart.js')
                .then(function(r){ return r.json(); })
                .then(function(updatedCart){
                  var noteLines = [];
                  updatedCart.items.forEach(function(ci){
                    if(ci.sku && ci.sku !== 'TINTING-SURCHARGE' && ci.sku !== targetSku){
                      var ciProps = ci.properties || {};
                      var ciColour = ciProps['Colour'] || '';
                      var ciBase = ciProps['Base'] || '';
                      if(ciColour){
                        noteLines.push(ci.product_title+' '+ci.variant_title+' | Base: '+ciBase+' | SKU: '+ci.sku+' | Colour: '+ciColour);
                      }
                    }
                  });
                  noteLines.push((currentProduct ? currentProduct.title : '')+' '+selSize.size+' | Base: '+baseName+' | SKU: '+targetSku+' | Colour: '+colourLabel);
                  return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({note: noteLines.join(' || ')})
                  }).then(function(r){ return r.json(); });
                });
            })
            .then(function(){
              // Step 6: redirect to cart
              window.location.href = '/cart';
            });
          });
      })
      .catch(function(err){
        // Out-of-stock: show clear message, do NOT redirect to empty cart
        if(err && err.stockError){
          if(btn){ btn.textContent='Out of Stock'; btn.disabled=false; }
          var note = document.getElementById('cpp-atc-note');
          if(note) note.textContent='This size is currently out of stock. Contact us to reserve: +971 55 358 5398';
          return;
        }
        if(err !== 'no variant') console.error(err);
        if(btn){ btn.textContent='Error — try again'; btn.disabled=false; }
      });
  }

  // ── Expose openPopup globally for product page "Choose Colour & Pre-order" button ──
  window.__encoreOpenColourPicker = function() { openPopup(); };

  document.querySelectorAll('.cpp-tab').forEach(function(t){
    t.onclick = function(){
      document.querySelectorAll('.cpp-tab').forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      aSys = t.getAttribute('data-sys');
      aFam = 'all'; selColour = null; selSize = null;
      document.getElementById('cpp-sel').style.display = 'none';
      document.getElementById('cpp-search').value = '';
      buildFams(); drawGrid();
    };
  });

  document.getElementById('cpp-search').oninput = drawGrid;

  function watchVariants(){
    var handle = window.location.pathname.replace('/products/','').split('?')[0];
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(product){
      currentProduct = product;
      function checkVariant(){
        var url = new URL(window.location.href);
        var variantId = url.searchParams.get('variant');
        if(!variantId) return;
        var variant = product.variants.find(function(v){return String(v.id)===variantId;});
        if(variant && variant.option1==='Tinted'){
          // Find the White variant of same size for correct base price
          var whiteVariant = product.variants.find(function(v){ return v.option1==='White' && v.option2===variant.option2; });
          var basePrice = whiteVariant ? whiteVariant.price/100 : variant.price/100;
          selSize = {size: variant.option2, price: basePrice};
          selColour = null;
          buildFams(); drawGrid();
          renderSel();
          openPopup();
        } else if(variant) {
          // Switched to White or other non-Tinted variant — close palette
          closePopup();
        }
      }
      document.addEventListener('change', function(){ setTimeout(checkVariant,300); });
      document.addEventListener('click', function(e){
        var btn = e.target.closest('.product-form__input input,fieldset label,.variant-input,label');
        if(btn) setTimeout(checkVariant,400);
      });
    });
  }

  buildFams();
  drawGrid();
  watchVariants();

})();